export const products = [
  {
    "id": 1880,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, White",
    "type": "Swatch (accessory)",
    "catalogName": "White",
    "catalogNumber": "P21724WHT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286868_white_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 975,
    "unitCost": 17.54,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
    "type": "Shirt",
    "catalogName": "White Twill Spread Collar Shirt",
    "catalogNumber": "330914WHT",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559063802_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_spread-190528114731-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1559063792_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_spread-190528114548-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273948_181010-154803-shirt-white-spread.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1057,
    "unitCost": 35.49,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Mystic Blue",
    "type": "Vest",
    "catalogName": "Mystic Blue Suit Vest",
    "catalogNumber": "430953MYB",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832984_visualizer_vest_full-solid-MYB-mystic_blue-suit_vest-190405093802.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008408_visualizer_vest_front-solid-MYB-mystic_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539341251_20181009-150631-430953MYB-Vest_Cummerbund-MysticBlue_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539341264_20181009-150631-430953MYB-Vest_Cummerbund-MysticBlue_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2728,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Bronze Pre-Tied Tie",
    "catalogNumber": "913108BRZ",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315464_visualizer_tie_full-solid-BRZ-bronze-long_tie-190409162620.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1557315253_layflat-solid-BRZ-bronze-long_tie-190312180615.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 257,
    "unitCost": 16.25,
    "pattern": "Solid",
    "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Matte",
    "type": "Shoe",
    "catalogName": "Black Dress Shoes",
    "catalogNumber": "A10184BMT",
    "costToCustomer": 20,
    "attributePrimary": "Lace Up",
    "attributeSecondary": "Plain Toe",
    "attributeTertiary": "Slip Resistent Bottom",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360706_20181009-150631-A10184BMT_Shoe_Matte_Black_PVC.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1707,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Midnight",
    "type": "Swatch (suit/tux)",
    "catalogName": "Midnight Blue Tuxedo",
    "catalogNumber": "P21551MDT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_Midnight_Blue_Tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 250,
    "unitCost": 23.75,
    "pattern": "Solid",
    "description": "Shirt, Modern, Wing Tip Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
    "type": "Shirt",
    "catalogName": "White Wingtip Collar Shirt",
    "catalogNumber": "330177WHT",
    "costToCustomer": 20,
    "attributePrimary": "Wing Tip Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559063487_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_wingtip-190528115306-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1559063426_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_wingtip-190528115256-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273464_181010-154803-shirt-white-wing.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 66,
    "unitCost": 23,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Blue",
    "type": "Vest",
    "catalogName": "Navy Blue Suit Vest",
    "catalogNumber": "430465BLU",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831292_visualizer_vest_full-solid-BLU-navy_blue-suit_vest-190405094857.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010485_visualizer_vest_front-solid-BLU-navy_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307797_20181009-150631-430465BLU_Suit_Vest__Back_Blue.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539307813_20181009-150631-430465BLU_Suit_Vest_Blue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 258,
    "unitCost": 16.5,
    "pattern": "Solid",
    "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Black Patent",
    "type": "Shoe",
    "catalogName": "Glossy Black Tuxedo Shoes",
    "catalogNumber": "A10185BPT",
    "costToCustomer": 20,
    "attributePrimary": "Lace Up",
    "attributeSecondary": "Plain Toe",
    "attributeTertiary": "Slip Resistent Bottom",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539702152_20181009-150631-A10185BPT_Shoe_Patent_Leather_PVC.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 157,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Cufflinks, Cuff Link, Black Plastic In Gold Metal, black & gold",
    "type": "Cufflinks",
    "catalogName": "Black and Gold Cufflinks and Studs",
    "catalogNumber": "030084BKG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": "Black Plastic In Gold Metal",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583351825_product_render-cufflinks-original-gold-black-2020-03-04_12-10-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1888,
    "unitCost": 0.5,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Ivory",
    "type": "Swatch (accessory)",
    "catalogName": "Ivory",
    "catalogNumber": "P21732IVO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286864_ivory_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1694,
    "unitCost": 0.6,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Blue",
    "type": "Swatch (suit/tux)",
    "catalogName": "Navy Suit",
    "catalogNumber": "P21538BLU",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286871_Navy Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 158,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Cufflinks, Cuff Link, Black Plastic In Silver Metal, black/silver",
    "type": "Cufflinks",
    "catalogName": "Black and Silver Cufflinks and Studs",
    "catalogNumber": "030085BLS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": "Black Plastic In Silver Metal",
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583351762_product_render-cufflinks-original-silver-black-2020-03-04_11-20-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 375,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Blush",
    "type": "Tie",
    "catalogName": "Petal Pre-Tied Tie",
    "catalogNumber": "910302PET",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542632886_layflat-solid-PET-blush_petal-long_tie-181115164503.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286673_910302BSH-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 248,
    "unitCost": 13.35,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Pleated Front, Convertible Cuff, LS, Poplin, White",
    "type": "Shirt",
    "catalogName": "Pleated White Spread Collar Shirt",
    "catalogNumber": "330175WHT",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Pleated Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559063890_visualizer_shirt_collar-solid-WHT-white_pleated-shirt-shirt-collar_spread-190528114722-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1559063881_visualizer_shirt_full-solid-WHT-white_pleated-shirt-shirt-collar_spread-190528114306-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273898_181010-154803-shirt-white-pleated.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 259,
    "unitCost": 44,
    "pattern": "Solid",
    "description": "Shoe, Mens, Lace Up, Plain Toe, Slip Resistent Bottom, Brown Antiqued",
    "type": "Shoe",
    "catalogName": "Brown Leather Dress Shoes",
    "catalogNumber": "A10186BRA",
    "costToCustomer": 20,
    "attributePrimary": "Lace Up",
    "attributeSecondary": "Plain Toe",
    "attributeTertiary": "Slip Resistent Bottom",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1568841506_190806 - brown shoes GenTux.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1968,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Nude",
    "type": "Swatch (accessory)",
    "catalogName": "Nude",
    "catalogNumber": "P21812NUD",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287063_23_Nude.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 65,
    "unitCost": 23,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Black & White",
    "type": "Vest",
    "catalogName": "Gray Sharkskin Suit Vest",
    "catalogNumber": "430464BLW",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830653_visualizer_vest_full-solid-BLW-gray_sharkskin-suit_vest-190405095243.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008715_visualizer_vest_front-solid-BLW-gray_sharkskin-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307742_20181009-150631-430464BLW-Suit_Vest_Back_Gray_Sharkskin.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539307754_20181009-150631-430464BLW-Suit_Vest_Gray_Sharkskin.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1699,
    "unitCost": 0.65,
    "pattern": null,
    "description": "Promo, Swatches, Suit, Generation Tux, Slate Blue",
    "type": "Swatch (suit/tux)",
    "catalogName": "Slate Blue Suit",
    "catalogNumber": "P21543SLB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286871_Slate blue suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1696,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Bright Blue Crepe",
    "type": "Swatch (suit/tux)",
    "catalogName": "Bright Blue Suit",
    "catalogNumber": "P21540BBC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286869_Bright blue suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2045,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Blush",
    "type": "Swatch (accessory)",
    "catalogName": "Petal",
    "catalogNumber": "P21889PET",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1565035490_petal_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 286,
    "unitCost": 0.99,
    "pattern": "Solid",
    "description": "Socks, Mens, Over The Calf, Formal, Black",
    "type": "Socks",
    "catalogName": "Formal Black Socks",
    "catalogNumber": "810213BLK",
    "costToCustomer": 0,
    "attributePrimary": "Over The Calf",
    "attributeSecondary": "Formal",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358982_20181009-150631-810213BLK_Sock_OverCalf_Nylon_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2729,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Bronze Pre-Tied Bow Tie",
    "catalogNumber": "913109BRZ",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315605_visualizer_tie_no_strap-solid-BRZ-bronze-bow_tie-190313013908-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1557315491_layflat-solid-BRZ-bronze-bow_tie-190312160330.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 159,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Cufflinks, Cuff Link, White Plastic In Silver Metal, white & silver",
    "type": "Cufflinks",
    "catalogName": "White and Silver Cufflinks and Studs",
    "catalogNumber": "030086WHS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": "White Plastic In Silver Metal",
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583351801_product_render-cufflinks-original-silver-white-2020-03-04_12-20-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1616,
    "unitCost": 29.59,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, Bright Blue Crepe",
    "type": "Vest",
    "catalogName": "Bright Blue Suit Vest",
    "catalogNumber": "431460BBC",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830684_visualizer_vest_full-solid-BBC-bright_blue-suit_vest-190405095821.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541009570_visualizer_vest_front-solid-BBC-bright_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539341515_20181009-150631-431460BBC-BrightBlueCrepe_Vest_Back.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539341527_20181009-150631-431460BBC-BrightBlueCrepe_Vest_Front.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 245,
    "unitCost": 23.75,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Ivory",
    "type": "Shirt",
    "catalogName": "Ivory Spread Collar Shirt",
    "catalogNumber": "330172IVO",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541003904_visualizer-shirt_collar_only-shirt-IVO-ivory-shirt-collar_spread-1528901972-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541003893_visualizer-shirt-IVO-ivory-shirt-collar_spread-1528901716-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273384_181010-154803-shirt-ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 251,
    "unitCost": 13.35,
    "pattern": "Solid",
    "description": "Shirt, Modern, Wing Tip Collar, Convertible Placket, Pleated Front, Convertible Cuff, LS, Poplin, White",
    "type": "Shirt",
    "catalogName": "Pleated White Wingtip Collar Shirt",
    "catalogNumber": "330178WHT",
    "costToCustomer": 20,
    "attributePrimary": "Wing Tip Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Pleated Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559063928_visualizer_shirt_collar-solid-WHT-white_pleated-shirt-shirt-collar_wingtip-190528115301-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1559063916_visualizer_shirt_full-solid-WHT-white_pleated-shirt-shirt-collar_wingtip-190528115018-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273791_181010-154803-shirt-white-wing-pleated.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1708,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Mystic Blue",
    "type": "Swatch (suit/tux)",
    "catalogName": "Mystic Blue Tuxedo",
    "catalogNumber": "P21552MYB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286875_Mystic_Blue_tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2720,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Chianti Rose Pre-Tied Tie",
    "catalogNumber": "913100CHR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314032_layflat-solid-CHR-chianti_rose-long_tie-190312180431.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1557313950_visualizer_tie_full-solid-CHR-chianti_rose-long_tie-190409162608.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1997,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Petal Pink",
    "type": "Swatch (accessory)",
    "catalogName": "Petal Pink",
    "catalogNumber": "P21841PTP",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287082_16_Petal Pink.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1055,
    "unitCost": 35.49,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Iron Grey",
    "type": "Vest",
    "catalogName": "Iron Gray Suit Vest",
    "catalogNumber": "430951IGR",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559055078_visualizer_vest_front-solid-IGR-iron_gray-suit_vest-20190528104603-fs8.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1554830865_visualizer_vest_full-solid-IGR-iron_gray-suit_vest-190405093928.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539341210_20181009-150631-430951IGR-Vest_Cummerbund-IronGrey_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539341219_20181009-150631-430951IGR-Vest_Cummerbund-IronGrey_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 75,
    "unitCost": 4,
    "pattern": "Solid",
    "description": "Belt, Mens, Belt, Black",
    "type": "Belt",
    "catalogName": "Black Belt with Silver Buckle",
    "catalogNumber": "B10002BLK",
    "costToCustomer": 10,
    "attributePrimary": "Belt",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539187720_20181009-150631-B10002BLK_Belts_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2721,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Chianti Rose Pre-Tied Bow Tie",
    "catalogNumber": "913101CHR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314482_visualizer_tie_no_strap-solid-CHR-chianti_rose-bow_tie-190313013916-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1557314457_layflat-solid-CHR-chianti_rose-bow_tie-190312160216.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 247,
    "unitCost": 13.65,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Pleated Front, Convertible Cuff, LS, Ivory",
    "type": "Shirt",
    "catalogName": "Pleated Ivory Spread Collar Shirt",
    "catalogNumber": "330174IVO",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Pleated Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541004273_visualizer-shirt_collar_only-shirt-IVO-ivory-pleated-shirt-collar_spread-1528901964-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541004262_visualizer-shirt-IVO-ivory-pleated-shirt-collar_spread-1528901555-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539273688_181010-154803-shirt-ivory-pleated.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1618,
    "unitCost": 29.15,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Slate Blue",
    "type": "Vest",
    "catalogName": "Slate Blue Suit Vest",
    "catalogNumber": "431462SLB",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831100_visualizer_vest_full-solid-SLB-slate_blue-suit_vest-190405095050.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010285_visualizer_vest_front-solid-SLB-slate_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1523286833_431462SLB-vest-back-0977.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286832_431462SLB-vest-front-0968.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1693,
    "unitCost": 0.6,
    "pattern": null,
    "description": "Promo, Swatches, Suit, Generation Tux, Mystic Blue",
    "type": "Swatch (suit/tux)",
    "catalogName": "Mystic Blue Suit",
    "catalogNumber": "P21537MYB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286870_Mystic Blue Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 956,
    "unitCost": 6,
    "pattern": "Solid",
    "description": "Belt, Mens, Belt, Brown",
    "type": "Belt",
    "catalogName": "Brown Belt with Silver Buckle",
    "catalogNumber": "B10903BWN",
    "costToCustomer": 10,
    "attributePrimary": "Belt",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539187669_20181009-150631-B10903BWN_Belts_BRWN.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1953,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Ballet",
    "type": "Swatch (accessory)",
    "catalogName": "Ballet",
    "catalogNumber": "P21797BAL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287081_12_Ballet.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2759,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Persian Plum & Teal Blue Black Argyle Socks",
    "catalogNumber": "881001BLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193906_190806 - 003 I Do_Black_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1949,
    "unitCost": 0.5,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Tea Rose",
    "type": "Swatch (accessory)",
    "catalogName": "Tea Rose",
    "catalogNumber": "P21793TRS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287084_27_Tea Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2724,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Saffron Pre-Tied Tie",
    "catalogNumber": "913104SAF",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314765_layflat-solid-SAF-saffron-long_tie-190312180758.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1557314750_visualizer_tie_full-solid-SAF-saffron-long_tie-190409162631.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 659,
    "unitCost": 23,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Charcoal",
    "type": "Vest",
    "catalogName": "Charcoal Gray Suit Vest",
    "catalogNumber": "430654CHA",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831216_visualizer_vest_full-solid-CHA-charcoal-suit_vest-190405095435.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010409_visualizer_vest_front-solid-CHA-charcoal-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539308027_20181009-150631-430654CHA-Suit_Vest_Back_Charcoal.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539308038_20181009-150631-430654CHA-Suit_Vest_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1575,
    "unitCost": 20.1,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Blue Honeycomb",
    "type": "Shirt",
    "catalogName": "Blue Honeycomb Shirt",
    "catalogNumber": "331419BLH",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541004045_visualizer-shirt_collar_only-shirt-BLH-blue_honeycomb-shirt-collar_spread-1528901955-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541004038_visualizer-shirt-BLH-blue_honeycomb-shirt-collar_spread-1528901386-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286463_331419BLH_Shirt_Honeycomb.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2760,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Plum & Teal Blue Gray Argyle Socks",
    "catalogNumber": "881004GLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193950_190806 - 016-1 I Do_Gray_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1709,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Blue Chambray",
    "type": "Swatch (suit/tux)",
    "catalogName": "Indigo Blue Suit",
    "catalogNumber": "P21553BLC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286868_Blue_Chambray suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 73,
    "unitCost": 4.95,
    "pattern": "Solid",
    "description": "Suspenders, Modern, Polished, Silver Clasp, Black",
    "type": "Suspenders",
    "catalogName": "Black Suspenders",
    "catalogNumber": "C30000BLK",
    "costToCustomer": 10,
    "attributePrimary": "Polished",
    "attributeSecondary": "Silver Clasp",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1549474891_20190206-124020-C30000BLK_Suspenders_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1630,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Cement",
    "type": "Vest",
    "catalogName": "Cement Gray Suit Vest",
    "catalogNumber": "431474CMT",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830478_visualizer_vest_full-solid-CMT-cement_gray-suit_vest-190405095628.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008442_visualizer_vest_front-solid-CMT-cement_gray-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1523286836_431474CMT-vest-back-0953.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286837_431474CMT-vest-front-0950.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 242,
    "unitCost": 11.95,
    "pattern": "Solid",
    "description": "Shirt, Modern, Point Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, White",
    "type": "Shirt",
    "catalogName": "White Point Collar Shirt",
    "catalogNumber": "330169WHT",
    "costToCustomer": 20,
    "attributePrimary": "Point Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559063532_visualizer_shirt_collar-solid-WHT-white-shirt-shirt-collar_point-190528115515-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1559063522_visualizer_shirt_full-solid-WHT-white-shirt-shirt-collar_point-190528115508-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1539274004_181010-154803-shirt-white.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1932,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Tickled",
    "type": "Swatch (accessory)",
    "catalogName": "Tickled",
    "catalogNumber": "P21776TCK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286865_pink_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2725,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Saffron Pre-Tied Bow Tie",
    "catalogNumber": "913105SAF",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314808_visualizer_tie_no_strap-solid-SAF-saffron-bow_tie-190409161355.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1557314787_layflat-solid-SAF-saffron-bow_tie-190312160445.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2756,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Persian Plum, Teal Blue, & Capri Black Pin Dot Socks",
    "catalogNumber": "881002BLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193921_190806 - 008-1 I Do Black Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1701,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Charcoal",
    "type": "Swatch (suit/tux)",
    "catalogName": "Charcoal Suit",
    "catalogNumber": "P21545CHA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286869_Charcoal Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1965,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, First Blush",
    "type": "Swatch (accessory)",
    "catalogName": "First Blush",
    "catalogNumber": "P21809FBL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287090_49_First Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2757,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Plum, Teal Blue, & Bronze Gray Pin Dot Socks",
    "catalogNumber": "881005GLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193966_190806 - 017-1 I Do_Gray_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1574,
    "unitCost": 20.8,
    "pattern": "Plaid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Wht Blue Purple Windowpane",
    "type": "Shirt",
    "catalogName": "Windowpane Plaid Shirt",
    "catalogNumber": "331418BPW",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541004311_visualizer-shirt_collar_only-shirt-BPW-windowpane_plaid-shirt-collar_spread-1528901895-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541004302_visualizer-shirt-BPW-windowpane_plaid-shirt-collar_spread-1528900243-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286462_331418BPW_Shirt_Windowpane.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1697,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Iron Gray",
    "type": "Swatch (suit/tux)",
    "catalogName": "Iron Gray Suit",
    "catalogNumber": "P21541IGR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286870_Iron Gray suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2047,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Quartz",
    "type": "Swatch (accessory)",
    "catalogName": "Quartz",
    "catalogNumber": "P21891QRT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287086_33_Quartz.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 660,
    "unitCost": 23,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Black",
    "type": "Vest",
    "catalogName": "Black Suit Vest",
    "catalogNumber": "430656BLK",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832444_visualizer_vest_full-solid-BLK-black-suit_vest-190405100014.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1554832574_visualizer_vest_front-solid-BLK-black-suit_vest-190405095920-fs8.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539308070_20181009-150631-430656BLK_Suit_Vest_Back_Black.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539308084_20181009-150631-430656BLK_Suit_Vest_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2722,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Teal Blue Pre-Tied Tie",
    "catalogNumber": "913102TEB",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314575_visualizer_tie_full-solid-TEB-teal_blue-long_tie-190409162557.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1557314559_layflat-solid-TEB-teal_blue-long_tie-190312180248.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1573,
    "unitCost": 19.15,
    "pattern": "Microcheck",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Purple White Microcheck",
    "type": "Shirt",
    "catalogName": "Purple Microcheck Shirt",
    "catalogNumber": "331417PRM",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541004000_visualizer-shirt_collar_only-shirt-PRM-purple_microcheck-shirt-collar_spread-1528901946-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541003991_visualizer-shirt-PRM-purple_microcheck-shirt-collar_spread-1528901223-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286462_331417PRM_Shirt_Microcheck.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2723,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Teal Blue Pre-Tied Bow Tie",
    "catalogNumber": "913103TEB",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314648_layflat-solid-TEB-teal_blue-bow_tie-190312160102.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1557314635_visualizer_tie_no_strap-solid-TEB-teal_blue-bow_tie-190313013908-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2754,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Persian Plum, Teal Blue, & Capri Black Striped Socks",
    "catalogNumber": "881003BLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193934_190806 - 011-1 I Do_Black_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 70,
    "unitCost": 23,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Flap Pocket, Tan",
    "type": "Vest",
    "catalogName": "Tan Sharkskin Suit Vest",
    "catalogNumber": "430469TAN",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830196_visualizer_vest_full-solid-TAN-tan_sharkskin-suit_vest-190405094121.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541007985_visualizer_vest_front-solid-TAN-tan_sharkskin-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307981_20181009-150631-430469TAN_Suit_Vest_Back_Tan.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539307993_20181009-150631-430469TAN_Suit_Vest_Tan.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2050,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Dusty Rose",
    "type": "Swatch (accessory)",
    "catalogName": "Dusty Rose",
    "catalogNumber": "P21894DRS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287091_50_Dusty Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1710,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Charcoal",
    "type": "Swatch (suit/tux)",
    "catalogName": "Charcoal Gray Tuxedo",
    "catalogNumber": "P21554CHA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_Charcoal_Tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 218,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Black",
    "type": "Pocket Square",
    "catalogName": "Black Pocket Square",
    "catalogNumber": "610145BLK",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BLK-black-pocket_square-181101161938.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BLK-black-pocket_square-181030161049.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1572,
    "unitCost": 17.95,
    "pattern": "Gingham",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Turq White Gingham",
    "type": "Shirt",
    "catalogName": "Aqua Gingham Shirt",
    "catalogNumber": "331416TQG",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541004149_visualizer-shirt_collar_only-shirt-TQG-aqua_gingham-shirt-collar_spread-1528901912-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541004137_visualizer-shirt-TQG-aqua_gingham-shirt-collar_spread-1528900572-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286461_331416TQG_Shirt_Gingham.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2726,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Harvest Gold Pre-Tied Tie",
    "catalogNumber": "913106HGD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315154_visualizer_tie_full-solid-HGD-harvest_gold-long_tie-190409162643.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1557315141_layflat-solid-HGD-harvest_gold-long_tie-190312180942.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1632,
    "unitCost": 32.69,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 5 Button, Blue Chambray",
    "type": "Vest",
    "catalogName": "Indigo Blue Suit Vest",
    "catalogNumber": "431476BLC",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830530_visualizer_vest_full-solid-BLC-indigo_blue-suit_vest-190405094511.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008479_visualizer_vest_front-solid-BLC-indigo_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1523286834_431476BLC-vest-back-0965.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1523286834_431476BLC-vest-front-0962.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2733,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Chianti Rose",
    "catalogNumber": "P22100CHR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559590748_pdp_hero-solid-CHR-chianti_rose-swatch-190603132342.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1711,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Light Gray",
    "type": "Swatch (suit/tux)",
    "catalogName": "Light Gray Tuxedo",
    "catalogNumber": "P21555LGY",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_Light_Gray_Tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2755,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Plum, Teal Blue, Bronze, & Capri Gray Striped Socks",
    "catalogNumber": "881006GLP",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570193980_190806 - 023-1 I Do_Gray_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1695,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Black & White",
    "type": "Swatch (suit/tux)",
    "catalogName": "Gray Sharkskin Suit",
    "catalogNumber": "P21539BLW",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286869_gray sharkskin Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2727,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Harvest Gold Pre-Tied Bow Tie",
    "catalogNumber": "913107HGD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315191_visualizer_tie_no_strap-solid-HGD-harvest_gold-bow_tie-190313013939-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1557315172_layflat-solid-HGD-harvest_gold-bow_tie-190312160559.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2033,
    "unitCost": 0.65,
    "pattern": null,
    "description": "Promo, Swatches, Generation Tux, Bubble Gum",
    "type": "Swatch (accessory)",
    "catalogName": "Bubble Gum",
    "catalogNumber": "P21877BGM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287092_55_Bubble Gum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 231,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, White",
    "type": "Pocket Square",
    "catalogName": "White Pocket Square",
    "catalogNumber": "610158WHT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WHT-white-pocket_square-181101160838.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-WHT-white-pocket_square-181030154100.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1571,
    "unitCost": 19.65,
    "pattern": "Solid",
    "description": "Shirt, Modern, Semi Spread Collar, Convertible Placket, Plain Front, Convertible Cuff, LS, Pink",
    "type": "Shirt",
    "catalogName": "Pink Tickweave Shirt",
    "catalogNumber": "331415PNK",
    "costToCustomer": 20,
    "attributePrimary": "Semi Spread Collar",
    "attributeSecondary": "Convertible Placket",
    "attributeTertiary": "Plain Front",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1541003757_visualizer-shirt_collar_only-shirt-PNK-pink_tickweave-shirt-collar_spread-1528901938-fs8.png",
        "label": "VISUALIZER_SHIRT_COLLAR"
      },
      {
        "url": "https://gentux.imgix.net/1541003745_visualizer-shirt-PNK-pink_tickweave-shirt-collar_spread-1528901062-fs8.png",
        "label": "VISUALIZER_SHIRT_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286460_331415PNK_Shirt_Pink.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1617,
    "unitCost": 29.15,
    "pattern": "Plaid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Light Grey Crepe",
    "type": "Vest",
    "catalogName": "Light Gray Plaid Suit Vest",
    "catalogNumber": "431461LGC",
    "costToCustomer": 20,
    "attributePrimary": "suit",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830562_visualizer_vest_full-plaid-LGC-light_gray_plaid-suit_vest-190405094318.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008514_visualizer_vest_front-plaid-LGC-light_gray_plaid-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539341569_20181009-150631-431461LGC_Vest_LightGreyCrepe_Back.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539341580_20181009-150631-431461LGC_Vest_LightGreyCrepe_Front.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2764,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Peacock & White Black Argyle Socks",
    "catalogNumber": "881007BLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194119_190806 - 029-1 Something Blue_Black_Argyle.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2181,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Plum",
    "type": "Tie",
    "catalogName": "Plum Striped Pre-Tied Tie",
    "catalogNumber": "912025PLM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554907672_visualizer_tie_full-stripes-PLM-plum-long_tie-190409165502.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542643776_layflat-stripes-PLM-plum-long_tie-181115182327.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1700,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Suit, Generation Tux, Cement",
    "type": "Swatch (suit/tux)",
    "catalogName": "Cement Gray Suit",
    "catalogNumber": "P21544CMT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286869_Cement suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2765,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Dark Navy & Teal Blue Gray Argyle Socks",
    "catalogNumber": "881010GLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194181_190806 - 039-1 Something Blue_Gray_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 230,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Ruby/Valentina",
    "type": "Pocket Square",
    "catalogName": "Ruby Valentino Pocket Square",
    "catalogNumber": "610157RUV",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-RUV-ruby-pocket_square-181101160957.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-RUV-ruby-pocket_square-181030154433.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 64,
    "unitCost": 25.38,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Black",
    "type": "Vest",
    "catalogName": "Black Tux Vest",
    "catalogNumber": "430463BLK",
    "costToCustomer": 20,
    "attributePrimary": "tux",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830631_visualizer_vest_full-solid-BLK-black-tux_vest-190405101132.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008653_visualizer_vest_front-solid-BLK-black-tux_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296794_20181009-150631-430463BLK_Tux_Vest_Back_Black.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296801_20181009-150631-430463BLK_Tux_Vest_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1924,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Watermelon",
    "type": "Swatch (accessory)",
    "catalogName": "Watermelon",
    "catalogNumber": "P21768WTM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286863_deep pink_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 221,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Charcoal",
    "type": "Pocket Square",
    "catalogName": "Pewter Pocket Square",
    "catalogNumber": "610148PEW",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-CHA-pewter-charcoal-pocket_square-181030160604.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CHA-pewter-charcoal-pocket_square-181101161752.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1702,
    "unitCost": 0.7,
    "pattern": "Plaid",
    "description": "Promo, Swatches, Suit, Generation Tux, Light Grey Crepe",
    "type": "Swatch (suit/tux)",
    "catalogName": "Light Gray Plaid Suit",
    "catalogNumber": "P21546LGC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286870_light grey plaid Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 69,
    "unitCost": 25.38,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Midnight",
    "type": "Vest",
    "catalogName": "Midnight Blue Tux Vest",
    "catalogNumber": "430468MDT",
    "costToCustomer": 20,
    "attributePrimary": "tux",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832930_visualizer_vest_full-solid-MDT-midnight_blue-tux_vest-190405100553.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541012243_visualizer_vest_front-solid-MDT-midnight_blue-tux_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307938_20181009-150631-430468MDT_Tux_Vest_Back_Midnight.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539307947_20181009-150631-430468MDT_Tux_Vest_Midnight.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2134,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Desert Blue",
    "type": "Tie",
    "catalogName": "Desert Blue Solid Pre-Tied Tie",
    "catalogNumber": "911978DBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287147_visualizer-solid-DBL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630625_layflat-solid-DBL-desert_blue-long_tie-181115150810.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2762,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Peacock, White, & Steel Blue Black Pin Dot Socks",
    "catalogNumber": "881008BLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194154_190806 - 032-1 Something Blue_Black_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2012,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Fuchsia",
    "type": "Swatch (accessory)",
    "catalogName": "Fuchsia",
    "catalogNumber": "P21856FCH",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287082_17_Fuchsia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 67,
    "unitCost": 25.38,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Charcoal",
    "type": "Vest",
    "catalogName": "Charcoal Tux Vest",
    "catalogNumber": "430466CHA",
    "costToCustomer": 20,
    "attributePrimary": "tux",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830593_visualizer_vest_full-solid-CHA-charcoal_gray-tux_vest-190405100939.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008627_visualizer_vest_front-solid-CHA-charcoal_gray-tux_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307855_20181009-150631-430466CHA_Tux_Vest_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1539307847_20181009-150631-430466CHA_Tux_Vest_Back_Charcoal.jpg",
        "label": "PDP_Alt1"
      }
    ]
  },
  {
    "id": 229,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Royal Blue",
    "type": "Pocket Square",
    "catalogName": "Horizon Pocket Square",
    "catalogNumber": "610156HOR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-RYL-horizon_royal-pocket_square-181101161024.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-RYL-horizon_royal-pocket_square-181030154546.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2763,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Dark Navy, Teal Blue, & White Gray Pin Dot Socks",
    "catalogNumber": "881011GLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194196_190806 - 046-1 Something Blue_Gray_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2690,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Mint Green Pre-Tied Striped Tie",
    "catalogNumber": "912445MGR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MGR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MGR-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1704,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Black",
    "type": "Swatch (suit/tux)",
    "catalogName": "Black Notch Tuxedo",
    "catalogNumber": "P21548BLK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_black_tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2024,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Guava/Sunset",
    "type": "Swatch (accessory)",
    "catalogName": "Guava",
    "catalogNumber": "P21868GUA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287090_47_Guava_Sunset.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1705,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Black",
    "type": "Swatch (suit/tux)",
    "catalogName": "Black Peak Tuxedo",
    "catalogNumber": "P21549BLK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_black_tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1969,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Tangerine",
    "type": "Swatch (accessory)",
    "catalogName": "Tangerine",
    "catalogNumber": "P21813TNG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287077_04_Tangerine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2758,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Peacock, White, Steel Blue, & Dark Navy Black Striped Socks",
    "catalogNumber": "881009BLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194167_190806 - 035-1 Something Blue_Black_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 225,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Malibu",
    "type": "Pocket Square",
    "catalogName": "Aqua-Malibu Pocket Square",
    "catalogNumber": "610152MBU",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MBU-malibu-aqua-pocket_square-181101161818.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MBU-malibu-aqua-pocket_square-181030160715.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 68,
    "unitCost": 25.38,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Light Gray",
    "type": "Vest",
    "catalogName": "Light Gray Tux Vest",
    "catalogNumber": "430467LGY",
    "costToCustomer": 20,
    "attributePrimary": "tux",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831256_visualizer_vest_full-solid-LGY-light_gray-tux_vest-190405100400.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010441_visualizer_vest_front-solid-LGY-light_gray-tux_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539307894_20181009-150631-430467LGY_Tuxedo_Vest_Back_LtGray.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539307907_20181009-150631-430467LGY_Tuxedo_Vest_LtGray.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2668,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Kelly Green Pre-Tied Tie",
    "catalogNumber": "911933KGR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287241_visualizer-solid-KGN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630544_layflat-solid-KGN-kelly_green-long_tie-181115152527.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2040,
    "unitCost": 0.65,
    "pattern": null,
    "description": "Promo, Swatches, Generation Tux, Sun Coral",
    "type": "Swatch (accessory)",
    "catalogName": "Sun Coral",
    "catalogNumber": "P21884SCO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287085_28_Sun Coral.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1555,
    "unitCost": 25.82,
    "pattern": "Solid",
    "description": "Vest, Modern, Suit, Lining Back, 4 Bttn, Double Besom Pocket, Mystic Blue",
    "type": "Vest",
    "catalogName": "Mystic Blue Edge Lapel Tux Vest",
    "catalogNumber": "431399MYB",
    "costToCustomer": 20,
    "attributePrimary": "tux",
    "attributeSecondary": "Lining Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831076_visualizer_vest_full-solid-MYB-mystic_blue-suit_vest-190405093802.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010239_visualizer_vest_front-solid-MYB-mystic_blue-suit_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539341302_20181009-150631-431399MYB-MysticBlue_Vest_Back.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539341312_20181009-150631-431399MYB-MysticBlue_Vest_Front.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2761,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Dark Navy, Teal Blue, White, & Steel Blue Gray Striped Socks",
    "catalogNumber": "881012GLB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194218_190806 - 051-1 Something Blue_Gray_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1706,
    "unitCost": 0.7,
    "pattern": "Solid",
    "description": "Promo, Swatches, Tux, Generation Tux, Black",
    "type": "Swatch (suit/tux)",
    "catalogName": "Black Shawl Tuxedo",
    "catalogNumber": "P21550BLK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286874_black_tux_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 226,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Mint",
    "type": "Pocket Square",
    "catalogName": "Mint Pocket Square",
    "catalogNumber": "610153MNT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MNT-mint-pocket_square-181101161235.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MNT-mint-pocket_square-181030155146.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1771,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Meadow",
    "type": "Tie",
    "catalogName": "Meadow Solid Pre-Tied Tie",
    "catalogNumber": "911615MDW",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287152_visualizer-solid-MDW-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630723_layflat-solid-MDW-meadow-long_tie-181115153221.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 374,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Black",
    "type": "Tie",
    "catalogName": "Black Pre-Tied Tie",
    "catalogNumber": "910301BLK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609259_20181009-150631-910301BLK_Solid_Solid_Long_PT_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286673_910301BLK-visualizer-tie-full-0489.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1698,
    "unitCost": 0.7,
    "pattern": null,
    "description": "Promo, Swatches, Suit, Generation Tux, Black",
    "type": "Swatch (suit/tux)",
    "catalogName": "Black Suit",
    "catalogNumber": "P21542BLK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286868_Black_Suit_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 222,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Emerald",
    "type": "Pocket Square",
    "catalogName": "Emerald Pocket Square",
    "catalogNumber": "610149EMD",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-EMD-emerald-pocket_square-181101161513.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-EMD-emerald-pocket_square-181030155857.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 50,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Black",
    "type": "Vest",
    "catalogName": "Black Vest",
    "catalogNumber": "410449BLK",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832700_visualizer_vest_full-solid-BLK-black_vest-190405111337.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541011969_visualizer_vest_front-satin_twill-BLK-black-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539293941_20181009-150631-410449BLK_Solid_Vest_Back_Black.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539293952_20181009-150631-410449BLK_Solid_Vest_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2004,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Persimmon",
    "type": "Swatch (accessory)",
    "catalogName": "Persimmon",
    "catalogNumber": "P21848PER",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287083_21_Persimmon.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2766,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Steel Blue, Champagne, & Biscotti Black Striped Socks",
    "catalogNumber": "881021BLS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195707_190806 - 075-1 Champagne Toast_Black_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 228,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Purple",
    "type": "Pocket Square",
    "catalogName": "Viola Pocket Square",
    "catalogNumber": "610155VIO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PRP-viola-pocket_square-181101161050.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PRP-viola-pocket_square-181030154656.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2768,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Steel Blue, Champagne, & Biscotti Gray Striped Socks",
    "catalogNumber": "881024GYS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195759_190806 - 083-1 Champagne Toast_Gray_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 39,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, 4 Bttn, No Pocket, Paisley, Black",
    "type": "Vest",
    "catalogName": "Black Paisley Vest",
    "catalogNumber": "410438BLK",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": null,
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830765_visualizer_vest_full-paisley-BLK-black_vest-not_tailored_vest-190405093609.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541009644_visualizer_vest_front-paisley-BLK-black-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288328_20181009-150631-410438BLK_Paisley_Vest_Back_Black.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288364_20181009-150631-410438BLK_Paisley_Vest_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2146,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Mercury",
    "type": "Tie",
    "catalogName": "Mercury Solid Pre-Tied Tie",
    "catalogNumber": "911990MRC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287149_visualizer-solid-MRC-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630676_layflat-solid-MRC-mercury-long_tie-181115150954.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1972,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Burnt Orange",
    "type": "Swatch (accessory)",
    "catalogName": "Burnt Orange",
    "catalogNumber": "P21816BOR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287084_22_Burnt Orange.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1917,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Jalapeno Dark Orange",
    "type": "Swatch (accessory)",
    "catalogName": "Jalapeno",
    "catalogNumber": "P21761JDO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286863_dark orange_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2692,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Sun Coral Pre-Tied Striped Tie",
    "catalogNumber": "912451SCO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-SCO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-SCO-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2770,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Steel Blue, & Champagne Black Pin Dot Socks",
    "catalogNumber": "881020BLS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195691_190806 - 073-1 Champagne Toast_Black_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 224,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Lilac",
    "type": "Pocket Square",
    "catalogName": "Lilac Pocket Square",
    "catalogNumber": "610151LIL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-LIL-lilac-pocket_square-181101161209.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-LIL-lilac-pocket_square-181030155035.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 63,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, White",
    "type": "Vest",
    "catalogName": "White Vest",
    "catalogNumber": "410462WHT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832259_visualizer_vest_full-solid-WHT-white_vest-190405111150.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541011719_visualizer_vest_front-satin_twill-WHT-white-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295446_20181009-150631-410462WHT_Solid_Vest_Back_White.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295457_20181009-150631-410462WHT_Solid_Vest_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1945,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Ferrari Red",
    "type": "Swatch (accessory)",
    "catalogName": "Ferrari Red",
    "catalogNumber": "P21789FRD",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287083_18_Ferrari Red.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2693,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Rose Gold Pre-Tied Striped Tie",
    "catalogNumber": "912454RGL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Miscellaneous",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-RGL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-RGL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 48,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, White",
    "type": "Vest",
    "catalogName": "White Paisley Vest",
    "catalogNumber": "410447WHT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832284_visualizer_vest_full-paisley-WHT-white_vest-not_tailored_vest-190405102732.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541014041_visualizer_vest_front-paisley-WHT-white-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288826_20181009-150631-410447WHT_Paisley_Vest_Back_White.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288837_20181009-150631-410447WHT_Paisley_Vest_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2772,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Steel Blue, & Champagne Gray Pin Dot Socks",
    "catalogNumber": "881023GYS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195748_190806 - 080-1 Champagne Toast_Gray_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 217,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Begonia",
    "type": "Pocket Square",
    "catalogName": "Begonia Pocket Square",
    "catalogNumber": "610144BGA",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-BGA-begonia-pocket_square-181030161311.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BGA-begonia-pocket_square-181101162030.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 2774,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria & Steel Blue Black Argyle Socks",
    "catalogNumber": "881019BLS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194389_190806 - 069-1 Champagne Toast_Black_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1908,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Ruby/Valentina",
    "type": "Swatch (accessory)",
    "catalogName": "Ruby Valentino",
    "catalogNumber": "P21752RUV",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286867_ruby_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2694,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Capri Pre-Tied Striped Tie",
    "catalogNumber": "912457CAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-CAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-CAP-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 62,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Ruby/Valentina",
    "type": "Vest",
    "catalogName": "Ruby Valentino Vest",
    "catalogNumber": "410461RUV",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831320_visualizer_vest_full-solid-RUV-ruby_vest-190405111005.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010583_visualizer_vest_front-satin_twill-RUV-ruby-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295402_20181009-150631-410461RUV_Solid_Vest_Back_RubyValentina.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295412_20181009-150631-410461RUV_Solid_Vest_RubyValentina.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 219,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Blush",
    "type": "Pocket Square",
    "catalogName": "Petal Pocket Square",
    "catalogNumber": "610146PET",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BSH-petal_blush-pocket_square-181101162004.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BSH-petal_blush-pocket_square-181030161159.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 47,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Ruby/Valentina",
    "type": "Vest",
    "catalogName": "Ruby Valentino Paisley Vest",
    "catalogNumber": "410446RUV",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830105_visualizer_vest_full-paisley-RUV-ruby_vest-not_tailored_vest-190405102545.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541007819_visualizer_vest_front-paisley-RUV-ruby-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288789_20181009-150631-410446RUV_Paisley_Vest_Back_RubyValentina.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288796_20181009-150631-410446RUV_Paisley_Vest_RubyValentina.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1925,
    "unitCost": 0.5,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Chianti",
    "type": "Swatch (accessory)",
    "catalogName": "Apple",
    "catalogNumber": "P21769APL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286860_Apple_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 227,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Platinum",
    "type": "Pocket Square",
    "catalogName": "Platinum Pocket Square",
    "catalogNumber": "610154PLT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PLT-platinum-pocket_square-181101161355.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PLT-platinum-pocket_square-181030155519.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1804,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Clover",
    "type": "Tie",
    "catalogName": "Clover Solid Pre-Tied Tie",
    "catalogNumber": "911648CLV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287154_visualizer-solid-CLV-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630762_layflat-solid-CLV-clover-long_tie-181115151832.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2776,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria & Steel Blue Gray Argyle Socks",
    "catalogNumber": "881022GYS",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195725_190806 - 077-1 Champagne Toast_Gray_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2780,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Petal & Teal Blue Black Argyle Socks",
    "catalogNumber": "881013BLN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194285_190806 - 055-4 The Perfect Pair_Black_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 53,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Charcoal",
    "type": "Vest",
    "catalogName": "Pewter Vest",
    "catalogNumber": "410452PEW",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832127_visualizer_vest_full-solid-CHA-pewter-charcoal_vest-190405110818.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1527606583_visualizer-satin_twill-CHA-pewter-charcoal-vest-masked-fs8.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539294993_20181009-150631-410452CHA_Solid_Vest_Back_Charcoal.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295002_20181009-150631-410452CHA_Solid_Vest_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 223,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Ivory",
    "type": "Pocket Square",
    "catalogName": "Ivory Pocket Square",
    "catalogNumber": "610150IVO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-IVO-ivory-pocket_square-181101161142.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-IVO-ivory-pocket_square-181030154922.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1976,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Wine/Merlot",
    "type": "Swatch (accessory)",
    "catalogName": "Merlot",
    "catalogNumber": "P21820MER",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287084_24_Wine_Merlot.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2695,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Blush Pre-Tied Striped Tie",
    "catalogNumber": "912460BSH",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286686_911322BSH-visualizer-tie-full-0498.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1569423854_layflat-stripes-PET-blush_petal-long_tie-190312212541.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2025,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Mulberry",
    "type": "Swatch (accessory)",
    "catalogName": "Mulberry",
    "catalogNumber": "P21869MUL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287087_37_Mulberry.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2777,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Petal, Teal Blue, Chianti Rose, & White Black Striped Socks",
    "catalogNumber": "881015BLN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194310_190806 - 059-1 The Perfect Pair_Black_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 220,
    "unitCost": 1.25,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Canary",
    "type": "Pocket Square",
    "catalogName": "Canary Pocket Square",
    "catalogNumber": "610147CAN",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CAN-canary-pocket_square-181101162056.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CAN-canary-pocket_square-181030161423.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 41,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Charcoal",
    "type": "Vest",
    "catalogName": "Pewter Paisley Vest",
    "catalogNumber": "410440PEW",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830738_visualizer_vest_full-paisley-CHA-pewter-charcoal_vest-not_tailored_vest-190405102358.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541009612_visualizer_vest_front-paisley-CHA-pewter-charcoal-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288482_20181009-150631-410440CHA_Paisley_Vest_Back_Charcoal.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288493_20181009-150631-410440CHA_Paisley_Vest_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2696,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Quartz Pre-Tied Striped Tie",
    "catalogNumber": "912463QRT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-QRT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-QRT-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2316,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Bubble Gum",
    "type": "Tie",
    "catalogName": "Bubble Gum Pre-Tied Bow Tie",
    "catalogNumber": "912160BGM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832720_layflat-solid-BGM-bubble_gum-bow_tie-190312175227.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287213_visualizer-solid-BGM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1889,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Wine",
    "type": "Swatch (accessory)",
    "catalogName": "Sangria",
    "catalogNumber": "P21733SGA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286868_wine_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1474,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Dark Navy",
    "type": "Vest",
    "catalogName": "Dark Navy Vest",
    "catalogNumber": "411341DNV",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831123_visualizer_vest_full-solid-DNV-dark_navy_vest-190405110632.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010323_visualizer_vest_front-satin_twill-DNV-dark_navy-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296414_20181009-150631-411341DNV_Vest_Solid_DarkNavy_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296425_20181009-150631-411341DNV_Vest_Solid_DarkNavy_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2779,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Petal, Teal Blue, & Chianti Rose Black Pin Dot Socks",
    "catalogNumber": "881014BLN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194299_190806 - 057-1 The Perfect Pair_Black_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1064,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Champagne",
    "type": "Pocket Square",
    "catalogName": "Champagne Pocket Square",
    "catalogNumber": "610959CHM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-CHM-champagne-pocket_square-181030161533.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CHM-champagne-pocket_square-181101162123.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1479,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Plum",
    "type": "Vest",
    "catalogName": "Plum Vest",
    "catalogNumber": "411344PLM",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830340_visualizer_vest_full-solid-PLM-plum_vest-190405110445.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008158_visualizer_vest_front-satin_twill-PLM-plum-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296537_20181009-150631-411344PLM_Vest_Solid_Plum_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296546_20181009-150631-411344PLM_Vest_Solid_Plum_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1069,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Wine",
    "type": "Pocket Square",
    "catalogName": "Sangria Pocket Square",
    "catalogNumber": "610960SGA",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WNE-sangria-wine-pocket_square-181101160812.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-WNE-sangria-wine-pocket_square-181030153948.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1921,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Begonia",
    "type": "Swatch (accessory)",
    "catalogName": "Begonia",
    "catalogNumber": "P21765BGA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286861_bright pink_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2318,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Mint Green",
    "type": "Tie",
    "catalogName": "Mint Green Pre-Tied Bow Tie",
    "catalogNumber": "912162MGR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833721_layflat-solid-MGR-mint_green-bow_tie-190312173358.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287213_visualizer-solid-MGR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2785,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Black & Blush Gray Argyle Socks",
    "catalogNumber": "881016GYN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194337_190806 - 062-1 BLUSHing Bride_Gray_Arygle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1964,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Bright Fuchsia",
    "type": "Swatch (accessory)",
    "catalogName": "Bright Fuchsia",
    "catalogNumber": "P21808BFU",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287092_56_Bright Fuchsia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1471,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Wine",
    "type": "Vest",
    "catalogName": "Sangria Vest",
    "catalogNumber": "411338SGA",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831792_visualizer_vest_full-solid-WNE-sangria-wine_vest-190405110113.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010680_visualizer_vest_front-satin_twill-WNE-sangria-wine-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295558_20181009-150631-411338WNE_Vest_Solid_Wine_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295566_20181009-150631-411338WNE_Vest_Solid_Wine_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2324,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Sun Coral",
    "type": "Tie",
    "catalogName": "Sun Coral Pre-Tied Bow Tie",
    "catalogNumber": "912169SCO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833251_layflat-solid-SCO-sun_coral-bow_tie-190312174235.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287215_visualizer-solid-SCO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2782,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Black, Blush, & Silver Gray Pin Dot Socks",
    "catalogNumber": "881017GYN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194353_190806 - 065-3 BLUSHing Bride_Gray_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1070,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Coral Reef",
    "type": "Pocket Square",
    "catalogName": "Coral Reef Pocket Square",
    "catalogNumber": "610961COR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-COR-coral_reef-pocket_square-181101161726.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-COR-coral_reef-pocket_square-181030160454.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1071,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Pacific",
    "type": "Pocket Square",
    "catalogName": "Pacific Pocket Square",
    "catalogNumber": "610962PAC",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PAC-pacific-pocket_square-181101161302.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PAC-pacific-pocket_square-181030155256.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1892,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Coral Reef",
    "type": "Swatch (accessory)",
    "catalogName": "Coral Reef",
    "catalogNumber": "P21736COR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286862_coral_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 61,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Royal Blue",
    "type": "Vest",
    "catalogName": "Horizon Blue Vest",
    "catalogNumber": "410460HOR",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830400_visualizer_vest_full-solid-RYL-horizon_royal_vest-190405105927.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008267_visualizer_vest_front-satin_twill-RYL-horizon-royal-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295340_20181009-150631-410460RYL_Solid_Vest_Back_RoyalBlue.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295353_20181009-150631-410460RYL_Solid_Vest_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1834,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Sunbeam",
    "type": "Tie",
    "catalogName": "Sunbeam Solid Pre-Tied Tie",
    "catalogNumber": "911678SUN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287162_visualizer-solid-SUN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630889_layflat-solid-SUN-sunbeam-long_tie-181115152159.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2781,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Black, Blush, Silver, & White Gray Striped Socks",
    "catalogNumber": "881018GYN",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570194364_190806 - 067-1 BLUSHing Bride_Gray_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1072,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Dark Navy",
    "type": "Pocket Square",
    "catalogName": "Dark Navy Pocket Square",
    "catalogNumber": "610963DNV",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-DNV-dark_navy-pocket_square-181101161633.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-DNV-dark_navy-pocket_square-181030160232.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 46,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Royal Blue",
    "type": "Vest",
    "catalogName": "Horizon Paisley Vest",
    "catalogNumber": "410445HOR",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832640_visualizer_vest_full-paisley-RYL-horizon_royal_vest-not_tailored_vest-190405102212.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541011889_visualizer_vest_front-paisley-RYL-horizon-royal-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288695_20181009-150631-410445RYL_Paisley_Vest_Back_RoyalBlue.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288703_20181009-150631-410445RYL_Paisley_Vest_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2332,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Capri",
    "type": "Tie",
    "catalogName": "Capri Pre-Tied Bow Tie",
    "catalogNumber": "912176CAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834652_visualizer_tie_no_strap-solid-CAP-capri-bow_tie-190313014800-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834627_layflat-solid-CAP-capri-bow_tie-190312172407.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2789,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria & Midas Gold Black Argyle Socks",
    "catalogNumber": "881025BLR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195811_190806 - 086-1 Wine Flight_Black_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2016,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Salmon",
    "type": "Swatch (accessory)",
    "catalogName": "Salmon",
    "catalogNumber": "P21860SAL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287085_30_Salmon.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1877,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Blush",
    "type": "Swatch (accessory)",
    "catalogName": "Blush",
    "catalogNumber": "P21721BSH",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1565035480_16_Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2787,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Midas Gold, & Champagne Black Pin Dot Socks",
    "catalogNumber": "881026BLR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195822_190806 - 087-1 Wine Flight_Black_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2077,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Hunter",
    "type": "Tie",
    "catalogName": "Hunter Solid Pre-Tied Tie",
    "catalogNumber": "911921HUN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287174_visualizer-solid-HUN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630977_layflat-solid-HUN-juniper-hunter-long_tie-181115163441.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1473,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Pacific",
    "type": "Vest",
    "catalogName": "Pacific Vest",
    "catalogNumber": "411340PAC",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831147_visualizer_vest_full-solid-PAC-pacific_vest-190405105741.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010350_visualizer_vest_front-satin_twill-PAC-pacific-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296377_20181009-150631-411340PAC_Vest_Solid_Pacific_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296388_20181009-150631-411340PAC_Vest_Solid_Pacific_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1073,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Jalapeno Dark Orange",
    "type": "Pocket Square",
    "catalogName": "Jalapeno Pocket Square",
    "catalogNumber": "610964JDO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-JDO-jalapeno-pocket_square-181101161607.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-JDO-jalapeno-pocket_square-181030160121.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 57,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Malibu",
    "type": "Vest",
    "catalogName": "Aqua Vest",
    "catalogNumber": "410456MBU",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831891_visualizer_vest_full-solid-MBU-malibu-aqua_vest-190405105554.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010713_visualizer_vest_front-satin_twill-MBU-malibu-aqua-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295167_20181009-150631-410456MBU_Solid_Vest_Back_Malibu.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295176_20181009-150631-410456MBU_Solid_Vest_Malibu.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2786,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Sangria, Midas Gold, & Champagne Black Striped Socks",
    "catalogNumber": "881027BLR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195834_190806 - 091-1 Wine Flight_Black_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1074,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Tiffany Blue",
    "type": "Pocket Square",
    "catalogName": "Tiffany Blue Pocket Square",
    "catalogNumber": "610965TBL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TBL-tiffany_blue-pocket_square-181101160930.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TBL-tiffany_blue-pocket_square-181030154322.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2697,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Dusty Rose Pre-Tied Striped Tie",
    "catalogNumber": "912466DRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-DRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-DRS-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1900,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Bellini",
    "type": "Swatch (accessory)",
    "catalogName": "Bellini",
    "catalogNumber": "P21744BEL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286860_bellini_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2340,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Blush",
    "type": "Tie",
    "catalogName": "Petal Pre-Tied Bow Tie",
    "catalogNumber": "910266PET",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833705_visualizer_tie_no_strap-solid-BSH-petal_blush-bow_tie-190313014346-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833691_layflat-solid-BSH-petal_blush-bow_tie-190312164435.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2793,
    "unitCost": null,
    "pattern": "Argyle",
    "description": null,
    "type": "Socks",
    "catalogName": "Burnt Orange & Midas Gold Gray Argyle Socks",
    "catalogNumber": "881028GYR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195858_190806 - 093-1 Fall For You_Gray_Argyle Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1481,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Ice Blue",
    "type": "Vest",
    "catalogName": "Ice Blue Vest",
    "catalogNumber": "411346IBL",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830149_visualizer_vest_full-solid-IBL-ice_blue_vest-190405105408.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541007950_visualizer_vest_front-satin_twill-IBL-ice_blue-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296720_20181009-150631-411346IBL_Vest_Solid_IceBlue_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296729_20181009-150631-411346IBL_Vest_Solid_IceBlue_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1884,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Champagne",
    "type": "Swatch (accessory)",
    "catalogName": "Champagne",
    "catalogNumber": "P21728CHM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286862_champagne_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1075,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Plum",
    "type": "Pocket Square",
    "catalogName": "Plum Pocket Square",
    "catalogNumber": "610966PLM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PLM-plum-pocket_square-181101161421.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PLM-plum-pocket_square-181030155632.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2792,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Socks",
    "catalogName": "Burnt Orange, Midas Gold, & Champagne Gray Pin Dot Socks",
    "catalogNumber": "881029GYR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195868_190806 - 094-1 Fall For You_Gray_Pindot Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2343,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Quartz",
    "type": "Tie",
    "catalogName": "Quartz Pre-Tied Bow Tie",
    "catalogNumber": "912187QRT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834531_visualizer_tie_no_strap-solid-QRT-quartz-bow_tie-190313014506-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834524_layflat-solid-QRT-quartz-bow_tie-190312165700.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1478,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Tiffany Blue",
    "type": "Vest",
    "catalogName": "Tiffany Blue Vest",
    "catalogNumber": "411343TBL",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832747_visualizer_vest_full-solid-TBL-tiffany_blue_vest-190405105222.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541012174_visualizer_vest_front-satin_twill-TBL-tiffany_blue-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296496_20181009-150631-411343TBL_Vest_Solid_TffanyBlue_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296506_20181009-150631-411343TBL_Vest_Solid_TffanyBlue_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2041,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Rose Gold",
    "type": "Swatch (accessory)",
    "catalogName": "Rose Gold",
    "catalogNumber": "P21885RGL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287086_31_Rose Gold.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1076,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Bellini",
    "type": "Pocket Square",
    "catalogName": "Bellini Tuxedo Pocket Square",
    "catalogNumber": "610967BEL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BEL-bellini-pocket_square-181101161844.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BEL-bellini-pocket_square-181030160827.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2345,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Dusty Rose",
    "type": "Tie",
    "catalogName": "Dusty Rose Pre-Tied Bow Tie",
    "catalogNumber": "912189DRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834581_visualizer_tie_no_strap-solid-DRS-dusty_rose-bow_tie-190313014458-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834573_layflat-solid-DRS-dusty_rose-bow_tie-190312165546.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1077,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Ice Blue",
    "type": "Pocket Square",
    "catalogName": "Ice Blue Pocket Square",
    "catalogNumber": "610968IBL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-IBL-ice_blue-pocket_square-181101161447.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-IBL-ice_blue-pocket_square-181030155745.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 58,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Mint",
    "type": "Vest",
    "catalogName": "Mint Vest",
    "catalogNumber": "410457MNT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831748_visualizer_vest_full-solid-MNT-mint_vest-190405105036.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010643_visualizer_vest_front-satin_twill-MNT-mint-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295201_20181009-150631-410457MNT_Solid_Vest_Back_Mint.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295209_20181009-150631-410457MNT_Solid_Vest_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1929,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Biscotti",
    "type": "Swatch (accessory)",
    "catalogName": "Biscotti",
    "catalogNumber": "P21773BIS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286860_biscotti_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2790,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Socks",
    "catalogName": "Midas Gold, Champagne, & Apple Gray Striped Socks",
    "catalogNumber": "881030GYR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1570195879_190806 - 097-1 Fall For You_Gray_Stripe Square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1078,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Biscotti",
    "type": "Pocket Square",
    "catalogName": "Biscotti Color Pocket Square",
    "catalogNumber": "610969BIS",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BIS-biscotti-pocket_square-181101161911.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BIS-biscotti-pocket_square-181030160940.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2730,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Socks",
    "catalogName": "ASPCA Pup Socks",
    "catalogNumber": "810300DOG",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554301096_810300DOG_Sock_Crew_ASPCA_PupSock.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 43,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Mint",
    "type": "Vest",
    "catalogName": "Mint Paisley Vest",
    "catalogNumber": "410442MNT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830819_visualizer_vest_full-paisley-MNT-mint_vest-not_tailored_vest-190405102025.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541009713_visualizer_vest_front-paisley-MNT-mint-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288562_20181009-150631-410442MNT_Paisley_Vest_Back_Mint.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288569_20181009-150631-410442MNT_Paisley_Vest_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1940,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Toffee Gold",
    "type": "Swatch (accessory)",
    "catalogName": "Toffee",
    "catalogNumber": "P21784TOF",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286717_toffee_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2698,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Desert Blue Pre-Tied Striped Tie",
    "catalogNumber": "912469DBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-DBL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-DBL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 54,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Emerald",
    "type": "Vest",
    "catalogName": "Emerald Vest",
    "catalogNumber": "410453EMD",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831960_visualizer_vest_full-solid-EMD-emerald_vest-190405104850.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010750_visualizer_vest_front-satin_twill-EMD-emerald-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295034_20181009-150631-410453EMD_Solid_Vest_Back_Emerald.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295045_20181009-150631-410453EMD_Solid_Vest_Emerald.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2350,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Desert Blue",
    "type": "Tie",
    "catalogName": "Desert Blue Pre-Tied Bow Tie",
    "catalogNumber": "912194DBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834379_visualizer_tie_no_strap-solid-DBL-desert_blue-bow_tie-190313014434-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834355_layflat-solid-DBL-desert_blue-bow_tie-190312165204.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2735,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Harvest Gold",
    "catalogNumber": "P22103HGD",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559590808_pdp_hero-solid-HGD-harvest_gold-swatch-190603132346.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1079,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Cornflower",
    "type": "Pocket Square",
    "catalogName": "Cornflower Pocket Square",
    "catalogNumber": "610970CFL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CFL-cornflower-pocket_square-181101161659.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CFL-cornflower-pocket_square-181030160344.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2732,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Bronze",
    "catalogNumber": "P22104BRN",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559590844_pdp_hero-solid-BRZ-bronze-swatch-190603132343.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 60,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Purple",
    "type": "Vest",
    "catalogName": "Viola Vest",
    "catalogNumber": "410459VIO",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832673_visualizer_vest_full-solid-PRP-viola_vest-190405104703.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541013813_visualizer_vest_front-satin_twill-PRP-viola-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295275_20181009-150631-410459PRP_Solid_Vest_Back_Purple.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295285_20181009-150631-410459PRP_Solid_Vest_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1080,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Toffee Gold",
    "type": "Pocket Square",
    "catalogName": "Toffee Pocket Square",
    "catalogNumber": "610971TOF",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TOF-toffee-pocket_square-181101160904.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TOF-toffee-pocket_square-181030154212.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2691,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Cocoa Pre-Tied Striped Tie",
    "catalogNumber": "912448COC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-COC-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-COC-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1081,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Bouquet",
    "type": "Pocket Square",
    "catalogName": "Bouquet Pocket Square",
    "catalogNumber": "610972BQT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BQT-bouquet-pocket_square-181101162149.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BQT-bouquet-pocket_square-181030161645.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2005,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Midas Gold",
    "type": "Swatch (accessory)",
    "catalogName": "Midas Gold",
    "catalogNumber": "P21849MGO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287088_40_Midas Gold.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 45,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Purple",
    "type": "Vest",
    "catalogName": "Viola Paisley Vest",
    "catalogNumber": "410444VIO",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830793_visualizer_vest_full-paisley-PRP-viola_vest-not_tailored_vest-190405101838.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541009681_visualizer_vest_front-paisley-PRP-viola-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288658_20181009-150631-410444PRP_Paisley_Vest_Back_Purple.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288667_20181009-150631-410444PRP_Paisley_Vest_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2352,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Iris",
    "type": "Tie",
    "catalogName": "Iris Pre-Tied Bow Tie",
    "catalogNumber": "912196IRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834478_visualizer_tie_no_strap-solid-IRS-iris-bow_tie-190313015134-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834422_layflat-solid-IRS-iris-bow_tie-190312175721.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1849,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Freesia",
    "type": "Tie",
    "catalogName": "Freesia Solid Pre-Tied Tie",
    "catalogNumber": "911693FRE",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287165_visualizer-solid-FRE-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631125_layflat-solid-FRE-freesia-long_tie-181115162235.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 56,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Lilac",
    "type": "Vest",
    "catalogName": "Lilac Vest",
    "catalogNumber": "410455LIL",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830044_visualizer_vest_full-solid-LIL-lilac_vest-190405104517.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541007745_visualizer_vest_front-satin_twill-LIL-lilac-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295119_20181009-150631-410455LIL_Solid_Vest_Back_Lilac.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295127_20181009-150631-410455LIL_Solid_Vest_Lilac.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1082,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Portobello",
    "type": "Pocket Square",
    "catalogName": "Portobello Pocket Square",
    "catalogNumber": "610973PRT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PRT-portobello-pocket_square-181101161116.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PRT-portobello-pocket_square-181030154812.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1937,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Gold",
    "type": "Swatch (accessory)",
    "catalogName": "Gold",
    "catalogNumber": "P21781GLD",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286864_gold_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1083,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Watermelon",
    "type": "Pocket Square",
    "catalogName": "Watermelon Pocket Square",
    "catalogNumber": "610974WTM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WTM-watermelon-pocket_square-181101161540.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-WTM-watermelon-pocket_square-181030160010.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2731,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Saffron",
    "catalogNumber": "P22102SAF",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559590651_pdp_hero-solid-SAF-saffron-swatch-190603132344.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2699,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Iris Pre-Tied Striped Tie",
    "catalogNumber": "912472IRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-IRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-IRS-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 49,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Begonia",
    "type": "Vest",
    "catalogName": "Begonia Vest",
    "catalogNumber": "410448BGA",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830455_visualizer_vest_full-solid-BGA-begonia_vest-190405104330.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008364_visualizer_vest_front-satin_twill-BGA-begonia-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539293826_20181009-150631-410448BGA_Solid_Vest_Back_Begonia.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539293865_20181009-150631-410448BGA_Solid_Vest_Begonia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1084,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Tickled",
    "type": "Pocket Square",
    "catalogName": "Tickled Pocket Square",
    "catalogNumber": "610975TCK",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TCK-tickled-pocket_square-181101161328.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TCK-tickled-pocket_square-181030155409.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2401,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Blush",
    "type": "Tie",
    "catalogName": "Blush Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912245BSH",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PET-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PET-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1977,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Sunbeam",
    "type": "Swatch (accessory)",
    "catalogName": "Sunbeam",
    "catalogNumber": "P21821SUN",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287077_02_Sunbeam.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1477,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Jalapeno Dark Orange",
    "type": "Vest",
    "catalogName": "Jalapeno Vest",
    "catalogNumber": "411342JDO",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830426_visualizer_vest_full-solid-JDO-jalapeno_vest-190405104142.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008303_visualizer_vest_front-satin_twill-JDO-jalapeno-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296458_20181009-150631-411342JDO_Vest_Solid_Jalapeno_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296468_20181009-150631-411342JDO_Vest_Solid_Jalapeno_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2393,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Cocoa",
    "type": "Tie",
    "catalogName": "Cocoa Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912237COC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-COC-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-COC-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1909,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Canary",
    "type": "Swatch (accessory)",
    "catalogName": "Canary",
    "catalogNumber": "P21753CAN",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286861_canary_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1472,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Coral Reef",
    "type": "Vest",
    "catalogName": "Coral Reef Vest",
    "catalogNumber": "411339COR",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831185_visualizer_vest_full-solid-COR-coral_reef_vest-190405103956.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010375_visualizer_vest_front-satin_twill-COR-coral_reef-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296221_20181009-150631-411339COR_Vest_Solid_CoralReef_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296232_20181009-150631-411339COR_Vest_Solid_CoralReef_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1291,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Champagne",
    "type": "Pocket Square",
    "catalogName": "Champagne Zig Zag Pocket Square",
    "catalogNumber": "611168CHM",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-CHM-champagne-pocket_square-181101165815.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539357122_20181009-150631-611168CHM_PocketSquare_ZigZag_Champagne.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 51,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Blush",
    "type": "Vest",
    "catalogName": "Blush Vest",
    "catalogNumber": "410450BSH",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832399_visualizer_vest_full-solid-BSH-petal_blush_vest-190405103810.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541011793_visualizer_vest_front-satin_twill-BSH-petal_blush-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539293983_20181009-150631-410450BSH_Solid_Vest_Back_Blush.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539293994_20181009-150631-410450BSH_Solid_Vest_Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2389,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Bubble Gum",
    "type": "Tie",
    "catalogName": "Bubble Gum Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912233BGM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-BGM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-BGM-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1292,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Wine",
    "type": "Pocket Square",
    "catalogName": "Sangria Zig Zag Pocket Square",
    "catalogNumber": "611169SGA",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-WNE-wine-pocket_square-181101165047.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539357143_20181009-150631-611169WNE_PocketSquare_ZigZag_Wine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2017,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Lime",
    "type": "Swatch (accessory)",
    "catalogName": "Lime",
    "catalogNumber": "P21861LIM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287088_42_Lime.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2387,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Wedgewood",
    "type": "Tie",
    "catalogName": "Wedgewood Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912231WED",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-WED-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-WED-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1480,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Bellini",
    "type": "Vest",
    "catalogName": "Bellini Vest",
    "catalogNumber": "411345BEL",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830298_visualizer_vest_full-solid-BEL-bellini_vest-190405103624.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008108_visualizer_vest_front-satin_twill-BEL-bellini-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296668_20181009-150631-411345BEL_Vest_Solid_Bellini_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296677_20181009-150631-411345BEL_Vest_Solid_Bellini_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1293,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Coral Reef",
    "type": "Pocket Square",
    "catalogName": "Coral Reef Zig Zag Pocket Square",
    "catalogNumber": "611170COR",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-COR-coral-pocket_square-181101165510.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539357164_20181009-150631-611170COR_PocketSquare_ZigZag_CoralReef.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2379,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Guava/Sunset",
    "type": "Tie",
    "catalogName": "Guava Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912223GUA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-GUA-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-GUA-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1916,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Emerald",
    "type": "Swatch (accessory)",
    "catalogName": "Emerald",
    "catalogNumber": "P21760EMD",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286864_emerald_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1482,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Biscotti",
    "type": "Vest",
    "catalogName": "Biscotti Vest",
    "catalogNumber": "411347BIS",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830893_visualizer_vest_full-solid-BIS-biscotti_vest-190405103436.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010142_visualizer_vest_front-satin_twill-BIS-biscotti-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539296757_20181009-150631-411347BIS_Vest_Solid_Biscotti_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539296764_20181009-150631-411347BIS_Vest_Solid_Biscotti_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1294,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Pacific",
    "type": "Pocket Square",
    "catalogName": "Pacific Zig Zag Pocket Square",
    "catalogNumber": "611171PAC",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-PAC-pacific-pocket_square-181101165232.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539357184_20181009-150631-611171PAC_PocketSquare_ZigZag_Pacific.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1295,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Dark Navy",
    "type": "Pocket Square",
    "catalogName": "Dark Navy Zig Zag Pocket Square",
    "catalogNumber": "611172DNV",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-DNV-dark_navy-pocket_square-181101165603.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356791_20181009-150631-611172DNV_PocketSquare_ZigZag_DarkNavy.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1470,
    "unitCost": 26.75,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Champagne",
    "type": "Vest",
    "catalogName": "Champagne Vest",
    "catalogNumber": "411337CHM",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830265_visualizer_vest_full-solid-CHM-champagne_vest-190405103250.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008064_visualizer_vest_front-satin_twill-CHM-champagne-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295523_20181009-150631-411337CHM_Vest_Solid_Champagne_B.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295531_20181009-150631-411337CHM_Vest_Solid_Champagne_F.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1952,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Blue Ice",
    "type": "Swatch (accessory)",
    "catalogName": "Blue Ice",
    "catalogNumber": "P21796BIC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287081_13_Blue Ice.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2354,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Lapis",
    "type": "Tie",
    "catalogName": "Lapis Pre-Tied Bow Tie",
    "catalogNumber": "912198LAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559844679_layflat-solid-LAP-lapis-bow_tie-190312165814.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287220_visualizer-solid-LAP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1973,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Pool",
    "type": "Swatch (accessory)",
    "catalogName": "Pool",
    "catalogNumber": "P21817POL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287081_11_Pool.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1296,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Jalapeno Dark Orange",
    "type": "Pocket Square",
    "catalogName": "Jalapeno Zig Zag Pocket Square",
    "catalogNumber": "611173JDO",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-JDO-dark_orange-pocket_square-181101165629.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356826_20181009-150631-611173JDO_PocketSquare_ZigZag_Jalapeno.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2373,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Lime",
    "type": "Tie",
    "catalogName": "Lime Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912217LIM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-LIM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-LIM-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 59,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Platinum",
    "type": "Vest",
    "catalogName": "Platinum Vest",
    "catalogNumber": "410458PLT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554831362_visualizer_vest_full-solid-PLT-platinum_vest-190405103104.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541010613_visualizer_vest_front-satin_twill-PLT-platinum-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295239_20181009-150631-410458PLT_Solid_Vest_Back_Platinum.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295246_20181009-150631-410458PLT_Solid_Vest_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 44,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Platinum",
    "type": "Vest",
    "catalogName": "Platinum Paisley Vest",
    "catalogNumber": "410443PLT",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832718_visualizer_vest_full-paisley-PLT-platinum_vest-not_tailored_vest-190405101651.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541012006_visualizer_vest_front-paisley-PLT-platinum-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288624_20181009-150631-410443PLT_Paisley_Vest_Back_Platinum.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288631_20181009-150631-410443PLT_Paisley_Vest_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2328,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Rose Gold",
    "type": "Tie",
    "catalogName": "Rose Gold Pre-Tied Bow Tie",
    "catalogNumber": "912172RGL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832816_layflat-solid-RGL-rose_gold-bow_tie-190312165432.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287216_visualizer-solid-RGL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1936,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Pacific",
    "type": "Swatch (accessory)",
    "catalogName": "Pacific",
    "catalogNumber": "P21780PAC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286865_pacific_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1297,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Tiffany Blue",
    "type": "Pocket Square",
    "catalogName": "Tiffany Blue Zig Zag Pocket Square",
    "catalogNumber": "611174TBL",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-TBL-tiffany_blue-pocket_square-181101164928.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356224_20181009-150631-611174TBL_PocketSquare_Plaid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1298,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Plum",
    "type": "Pocket Square",
    "catalogName": "Plum Zig Zag Pocket Square",
    "catalogNumber": "611175PLM",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-PLM-plum-pocket_square-181101165113.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356247_20181009-150631-611175PLM_PocketSquare_ZigZag_Plum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1989,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Turquoise",
    "type": "Swatch (accessory)",
    "catalogName": "Turquoise",
    "catalogNumber": "P21833TRQ",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287085_26_Turquoise.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2367,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Fuchsia",
    "type": "Tie",
    "catalogName": "Fuchsia Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912211FCH",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-FCH-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-FCH-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 55,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Ivory",
    "type": "Vest",
    "catalogName": "Ivory Vest",
    "catalogNumber": "410454IVO",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830372_visualizer_vest_full-solid-IVO-ivory_vest-190405102918.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008189_visualizer_vest_front-satin_twill-IVO-ivory-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539295082_20181009-150631-410454IVO_Solid_Vest_Back_Ivory.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539295094_20181009-150631-410454IVO_Solid_Vest_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2321,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Cocoa",
    "type": "Tie",
    "catalogName": "Cocoa Pre-Tied Bow Tie",
    "catalogNumber": "912165COC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832894_layflat-solid-COC-cocoa-bow_tie-190312172520.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287214_visualizer-solid-COC-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 42,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Ivory",
    "type": "Vest",
    "catalogName": "Ivory Paisley Vest",
    "catalogNumber": "410441IVO",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832222_visualizer_vest_full-paisley-IVO-ivory_vest-not_tailored_vest-190405101505.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541012633_visualizer_vest_front-paisley-IVO-ivory-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288529_20181009-150631-410441IVO_Paisley_Vest_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1920,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Malibu",
    "type": "Swatch (accessory)",
    "catalogName": "Aqua-Malibu",
    "catalogNumber": "P21764MBU",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286860_aqua_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1299,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Bellini",
    "type": "Pocket Square",
    "catalogName": "Bellini Zig Zag Pocket Square",
    "catalogNumber": "611176BEL",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BEL-bellini-pocket_square-181101170026.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539355995_20181009-150631-611176BEL_PocketSquare_ZigZag_Bellini.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 52,
    "unitCost": 20.38,
    "pattern": "Solid",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Solid Twill, Canary",
    "type": "Vest",
    "catalogName": "Canary Vest",
    "catalogNumber": "410451CAN",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554832102_visualizer_vest_full-solid-CAN-canary_vest-190405110259.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541011500_visualizer_vest_front-satin_twill-CAN-canary-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539294936_20181009-150631-410451CAN_Solid_Vest_Back_Canary.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539294944_20181009-150631-410451CAN_Solid_Vest_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1904,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Tiffany Blue",
    "type": "Swatch (accessory)",
    "catalogName": "Tiffany Blue",
    "catalogNumber": "P21748TBL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286867_tiffany blue_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2355,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Persimmon",
    "type": "Tie",
    "catalogName": "Persimmon Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912199PER",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PER-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PER-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1300,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Ice Blue",
    "type": "Pocket Square",
    "catalogName": "Ice Blue Zig Zag Pocket Square",
    "catalogNumber": "611177IBL",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-IBL-ice_blue-pocket_square-181101165748.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356019_20181009-150631-611177IBL_PocketSquare_ZigZag_IceBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2009,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Mermaid/Spa",
    "type": "Swatch (accessory)",
    "catalogName": "Spa",
    "catalogNumber": "P21853SPA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287080_09_Mermaid_Spa.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1301,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Biscotti",
    "type": "Pocket Square",
    "catalogName": "Biscotti Zig Zag Pocket Square",
    "catalogNumber": "611178BIS",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BIS-biscotti-pocket_square-181101170000.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356049_20181009-150631-611178BIS_PocketSquare_ZigZag_Biscotti.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 40,
    "unitCost": 21.33,
    "pattern": "Paisley",
    "description": "Vest, Mens, Fancy, Fancy Back, 4 Bttn, No Pocket, Paisley, Canary",
    "type": "Vest",
    "catalogName": "Canary Paisley Vest",
    "catalogNumber": "410439CAN",
    "costToCustomer": 20,
    "attributePrimary": "not_tailored",
    "attributeSecondary": "Fancy Back",
    "attributeTertiary": "4 Bttn",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1554830239_visualizer_vest_full-paisley-CAN-canary_vest-not_tailored_vest-190405101318.png",
        "label": "VISUALIZER_VEST_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1541008025_visualizer_vest_front-paisley-CAN-canary-not_tailored_vest-1529086048.png",
        "label": "VISUALIZER_VEST_FRONT"
      },
      {
        "url": "https://gentux.imgix.net/1539288399_20181009-150631-410439CAN_Paisley_Vest_Back_Canary.jpg",
        "label": "PDP_Alt1"
      },
      {
        "url": "https://gentux.imgix.net/1539288437_20181009-150631-410439CAN_Paisley_Vest_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2309,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Indigo",
    "type": "Tie",
    "catalogName": "Indigo Pre-Tied Bow Tie",
    "catalogNumber": "912153IND",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832971_layflat-solid-IND-indigo-bow_tie-190312174617.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287211_visualizer-solid-IND-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 112,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Black",
    "type": "Cummerbund",
    "catalogName": "Black Cummerbund",
    "catalogNumber": "710039BLK",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343922_20181009-150631-710039BLK_Solid_Cummerbund_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1302,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Cornflower",
    "type": "Pocket Square",
    "catalogName": "Cornflower Blue Zig Zag Pocket Square",
    "catalogNumber": "611179CFL",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-CFL-cornflower_blue-pocket_square-181101165537.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356076_20181009-150631-611179CFL_PocketSquare_ZigZag_Cornflower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2001,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Jade",
    "type": "Swatch (accessory)",
    "catalogName": "Jade",
    "catalogNumber": "P21845JDE",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287078_03_Jade.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2338,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Petal Pink",
    "type": "Tie",
    "catalogName": "Petal Pink Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912182PTP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PTP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PTP-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 101,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Black",
    "type": "Cummerbund",
    "catalogName": "Black Paisley Cummerbund",
    "catalogNumber": "710028BLK",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343564_20181009-150631-710028BLK_Paisley_Cummerbund_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2238,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Nude",
    "type": "Tie",
    "catalogName": "Nude Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912082NUD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-NUD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-NUD-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1885,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Mint",
    "type": "Swatch (accessory)",
    "catalogName": "Mint",
    "catalogNumber": "P21729MNT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286865_mint_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1303,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Toffee Gold",
    "type": "Pocket Square",
    "catalogName": "Toffee Zig Zag Pocket Square",
    "catalogNumber": "611180TOF",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-TOF-toffee-pocket_square-181101164954.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356100_20181009-150631-611180TOF_PocketSquare_ZigZag_Toffee.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1948,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Meadow",
    "type": "Swatch (accessory)",
    "catalogName": "Meadow",
    "catalogNumber": "P21792MDW",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287078_05_Meadow.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2296,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Salmon",
    "type": "Tie",
    "catalogName": "Salmon Pre-Tied Bow Tie",
    "catalogNumber": "912140SAL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833190_layflat-solid-SAL-salmon-bow_tie-190312174845.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287205_visualizer-solid-SAL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 125,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, White",
    "type": "Cummerbund",
    "catalogName": "White Cummerbund",
    "catalogNumber": "710052WHT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354513_20181009-150631-710052WHT_Solid_Cummerbund_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1304,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Bouquet",
    "type": "Pocket Square",
    "catalogName": "Bouquet Zig Zag Pocket Square",
    "catalogNumber": "611181BQT",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BQT-lavender-pocket_square-181101165351.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356121_20181009-150631-611181BQT_PocketSquare_ZigZag_Bouquet.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2230,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Persian Plum",
    "type": "Tie",
    "catalogName": "Persian Plum Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912074PPL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PPL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PPL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 110,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, White",
    "type": "Cummerbund",
    "catalogName": "White Paisley Cummerbund",
    "catalogNumber": "710037WHT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354005_20181009-150631-710037WHT_Paisley_Cummerbund_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1305,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Portobello",
    "type": "Pocket Square",
    "catalogName": "Portobello Zig Zag Pocket Square",
    "catalogNumber": "611182PRT",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-PRT-protobello-pocket_square-181101164743.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356143_20181009-150631-611182PRT_PocketSquare_ZigZag_Portobello.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2638,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Mint Green",
    "catalogNumber": "P21880MGR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287088_39_Mint Green.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 124,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Ruby/Valentina",
    "type": "Cummerbund",
    "catalogName": "Ruby Valentino Cummerbund",
    "catalogNumber": "710051RUV",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344237_20181009-150631-710051RUV_Solid_Cummerbund_RubyValentina.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2013,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Juniper/Hunter",
    "type": "Swatch (accessory)",
    "catalogName": "Hunter",
    "catalogNumber": "P21857HUN",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287089_45_Juniper.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1306,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Watermelon",
    "type": "Pocket Square",
    "catalogName": "Watermelon Zig Zag Pocket Square",
    "catalogNumber": "611183WTM",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-WTM-deep_pink-pocket_square-181101165656.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539358473_20181009-150631-611183WTM_PocketSquare_ZigZag_Watermelon.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2275,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Jade",
    "type": "Tie",
    "catalogName": "Jade Pre-Tied Bow Tie",
    "catalogNumber": "912119JDE",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833254_visualizer_tie_no_strap-solid-JDE-jade-bow_tie-190313014641-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833237_layflat-solid-JDE-jade-bow_tie-190312171147.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2222,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Blue Ice",
    "type": "Tie",
    "catalogName": "Blue Ice Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912066BIC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-BIC-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-BIC-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 109,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Ruby/Valentina",
    "type": "Cummerbund",
    "catalogName": "Ruby Valentino Paisley Cummerbund",
    "catalogNumber": "710036RUV",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343824_20181009-150631-710036RUV_Paisley_Cummerbund_RubyValentina.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1956,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Clover",
    "type": "Swatch (accessory)",
    "catalogName": "Clover",
    "catalogNumber": "P21800CLV",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287077_01_Clover.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1307,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Tickled",
    "type": "Pocket Square",
    "catalogName": "Tickled Zig Zag Pocket Square",
    "catalogNumber": "611184TCK",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-TCK-pink-pocket_square-181101165206.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539355959_20181009-150631-611184TCK_PocketSquare_ZigZag_Tickled.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1308,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, White",
    "type": "Pocket Square",
    "catalogName": "White Zig Zag Pocket Square",
    "catalogNumber": "611185WHT",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-WHT-white-pocket_square-181101165021.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356050_20181009-150631-611185WHT_PocketSquare_ZigZag_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2267,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Aquamarine",
    "type": "Tie",
    "catalogName": "Aqua Marine Pre-Tied Bow Tie",
    "catalogNumber": "912111AQM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833331_visualizer_tie_no_strap-solid-AQM-aqua_marine-bow_tie-190313014927-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833316_layflat-solid-AQM-aqua_marine-bow_tie-190312173740.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1098,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Dark Navy",
    "type": "Cummerbund",
    "catalogName": "Dark Navy Cummerbund",
    "catalogNumber": "710987DNV",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344420_20181009-150631-710987DNV_Cummberbund_Solid_DarkNavy.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2008,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Olive",
    "type": "Swatch (accessory)",
    "catalogName": "Olive",
    "catalogNumber": "P21852OLV",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287087_35_Olive.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1309,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Black",
    "type": "Pocket Square",
    "catalogName": "Black Zig Zag Pocket Square",
    "catalogNumber": "611186BLK",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BLK-black-pocket_square-181101165934.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356083_20181009-150631-611186BLK_PocketSquare_ZigZag_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2058,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Oasis",
    "type": "Swatch (accessory)",
    "catalogName": "Oasis",
    "catalogNumber": "P21902OAS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287087_36_Oasis.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 115,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Charcoal",
    "type": "Cummerbund",
    "catalogName": "Pewter Cummerbund",
    "catalogNumber": "710042PEW",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354057_20181009-150631-710042CHA_Solid_Cummerbund_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2216,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Ferrari Red",
    "type": "Tie",
    "catalogName": "Ferrari Red Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912060FRD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-FRD-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-FRD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 103,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Charcoal",
    "type": "Cummerbund",
    "catalogName": "Pewter Paisley Cummerbund",
    "catalogNumber": "710030PEW",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343621_20181009-150631-710030CHA_Paisley_Cummerbund_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2044,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Capri",
    "type": "Swatch (accessory)",
    "catalogName": "Capri",
    "catalogNumber": "P21888CAP",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287092_54_Capri.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1310,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Platinum",
    "type": "Pocket Square",
    "catalogName": "Platinum Zig Zag Pocket Square",
    "catalogNumber": "611187PLT",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-PLT-platinum-pocket_square-181101165140.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356123_20181009-150631-611187PLT_PocketSquare_ZigZag_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2257,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Chocolate",
    "type": "Tie",
    "catalogName": "Chocolate Pre-Tied Bow Tie",
    "catalogNumber": "912101CHO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833453_layflat-solid-CHO-chocolate-bow_tie-190312172749.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287196_visualizer-solid-CHO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1993,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Aquamarine",
    "type": "Swatch (accessory)",
    "catalogName": "Aqua Marine",
    "catalogNumber": "P21837AQM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287093_58_Aqua Marine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 123,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Royal Blue",
    "type": "Cummerbund",
    "catalogName": "Horizon Cummerbund",
    "catalogNumber": "710050HOR",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344206_20181009-150631-710050RYL_Solid_Cummerbund_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1311,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Charcoal",
    "type": "Pocket Square",
    "catalogName": "Pewter Zig Zag Pocket Square",
    "catalogNumber": "611188PEW",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-CHA-charcoal-pocket_square-181101165444.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356151_20181009-150631-611188CHA_PocketSquare_ZigZag_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2255,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Eggplant",
    "type": "Tie",
    "catalogName": "Eggplant Pre-Tied Bow Tie",
    "catalogNumber": "912099EGG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833505_layflat-solid-EGG-eggplant-bow_tie-190312171530.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287195_visualizer-solid-EGG-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1312,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Royal Blue",
    "type": "Pocket Square",
    "catalogName": "Horizon Zig Zag Pocket Square",
    "catalogNumber": "611189HOR",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-RYL-royal_blue-pocket_square-181101164836.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356180_20181009-150631-611189RYL_PocketSquare_ZigZag_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 108,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Royal Blue",
    "type": "Cummerbund",
    "catalogName": "Horizon Paisley Cummerbund",
    "catalogNumber": "710035HOR",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343785_20181009-150631-710035RYL_Paisley_Cummerbund_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1901,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Ice Blue",
    "type": "Swatch (accessory)",
    "catalogName": "Ice Blue",
    "catalogNumber": "P21745IBL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286864_ice blue_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2249,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Wine/Merlot",
    "type": "Tie",
    "catalogName": "Merlot Pre-Tied Bow Tie",
    "catalogNumber": "912093MER",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833557_visualizer_tie_no_strap-solid-MER-wine-merlot-bow_tie-190313014737-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833541_layflat-solid-MER-wine-merlot-bow_tie-190312172025.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1095,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Pacific",
    "type": "Cummerbund",
    "catalogName": "Pacific Cummerbund",
    "catalogNumber": "710986PAC",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344382_20181009-150631-710986PAC_Cummberbund_Solid_Pacific.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2161,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Purple",
    "type": "Tie",
    "catalogName": "Purple Pre-Tied Bow Tie",
    "catalogNumber": "912005PUR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833672_layflat-solid-PUR-purple-bow_tie-190312165050.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1559833651_visualizer_tie_no_strap-solid-PUR-purple-bow_tie-190313014427-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2032,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Wedgewood",
    "type": "Swatch (accessory)",
    "catalogName": "Wedgewood",
    "catalogNumber": "P21876WED",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287084_25_Wedge Wood.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1313,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Purple",
    "type": "Pocket Square",
    "catalogName": "Zig Zag Viola Pocket Square",
    "catalogNumber": "611190VIO",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-PRP-purple-pocket_square-181101164809.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356233_20181009-150631-611190PRP_PocketSquare_ZigZag_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 119,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Malibu",
    "type": "Cummerbund",
    "catalogName": "Aqua-Malibu Cummerbund",
    "catalogNumber": "710046MBU",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354206_20181009-150631-710046MBU_Solid_Cummerbund_Malibu.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1314,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Ruby/Valentina",
    "type": "Pocket Square",
    "catalogName": "Ruby Valentino Zig Zag Pocket Square",
    "catalogNumber": "611191RUV",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-RUV-ruby-pocket_square-181101164902.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356265_20181009-150631-611191RUV_PocketSquare_ZigZag_Ruby.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2149,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Ferrari Red",
    "type": "Tie",
    "catalogName": "Ferrari Red Pre-Tied Bow Tie",
    "catalogNumber": "911993FRD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833875_visualizer_tie_no_strap-solid-FRD-ferrari_red-bow_tie-190313015150-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833859_layflat-solid-FRD-ferrari_red-bow_tie-190312175949.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2734,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Teal Blue",
    "catalogNumber": "P22101TEB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559590779_pdp_hero-solid-TEB-teal_blue-swatch-190603132341.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2749,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Blush Pre-Tied Bow Tie",
    "catalogNumber": "912184BSH",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1569425207_layflat-solid-BSH-petal_blush-bow_tie-190312164435.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286547_910266BSH-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1315,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, VW/DB Mint",
    "type": "Pocket Square",
    "catalogName": "Mint Zig Zag Pocket Square",
    "catalogNumber": "611192MNT",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-VMT-mint-pocket_square-181101165259.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356349_20181009-150631-611192VMT_PocketSquare_ZigZag_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1944,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Steel Blue",
    "type": "Swatch (accessory)",
    "catalogName": "Steel Blue",
    "catalogNumber": "P21788STB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286867_steel blue_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1102,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Tiffany Blue",
    "type": "Cummerbund",
    "catalogName": "Tiffany Blue Cummerbund",
    "catalogNumber": "710989TBL",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344485_20181009-150631-710989TBL_Cummberbund_Solid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1912,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Cornflower",
    "type": "Swatch (accessory)",
    "catalogName": "Cornflower",
    "catalogNumber": "P21756CFL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286863_cornflower_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1316,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Canary",
    "type": "Pocket Square",
    "catalogName": "Canary Zig Zag Pocket Square",
    "catalogNumber": "611193CAN",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-CAN-canary-pocket_square-181101165841.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356382_20181009-150631-611193CAN_PocketSquare_ZigZag_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2407,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Desert Blue",
    "type": "Tie",
    "catalogName": "Desert Blue Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912251DBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-DBL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-DBL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 120,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Mint",
    "type": "Cummerbund",
    "catalogName": "Mint Cummerbund",
    "catalogNumber": "710047MNT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354227_20181009-150631-710047MNT_Solid_Cummerbund_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 105,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Mint",
    "type": "Cummerbund",
    "catalogName": "Mint Paisley Cummerbund",
    "catalogNumber": "710032MNT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343670_20181009-150631-710032MNT_Paisley_Cummerbund_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1317,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Ivory",
    "type": "Pocket Square",
    "catalogName": "Ivory Zig Zag Pocket Square",
    "catalogNumber": "611194IVO",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-IVO-ivory-pocket_square-181101165418.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356438_20181009-150631-611194IVO_PocketSquare_ZigZag_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2703,
    "unitCost": null,
    "pattern": "Dots",
    "description": null,
    "type": "Tie",
    "catalogName": "Kelly Green Pre-Tied Pin Dot Bow Tie",
    "catalogNumber": "912221KGR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-KGN-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-KGN-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2029,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Morning Glory",
    "type": "Swatch (accessory)",
    "catalogName": "Morning Glory",
    "catalogNumber": "P21873MGL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287087_38_Morning Glory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2702,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Mercury Pre-Tied Striped Tie",
    "catalogNumber": "912481MRC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MRC-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MRC-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1318,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Lilac",
    "type": "Pocket Square",
    "catalogName": "Lilac Zig Zag Pocket Square",
    "catalogNumber": "611195LIL",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-LIL-lilac-pocket_square-181101165325.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356546_20181009-150631-611195LIL_PocketSquare_ZigZag_Lilac.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2000,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Sapphire",
    "type": "Swatch (accessory)",
    "catalogName": "Sapphire",
    "catalogNumber": "P21844SAP",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287078_06_Sapphire.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 116,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Emerald",
    "type": "Cummerbund",
    "catalogName": "Emerald Cummerbund",
    "catalogNumber": "710043EMD",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354085_20181009-150631-710043EMD_Solid_Cummerbund_Emerald.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1881,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Dark Navy",
    "type": "Swatch (accessory)",
    "catalogName": "Dark Navy",
    "catalogNumber": "P21725DNV",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286863_dark navy_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2665,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Persimmon Solid Pre-Tied Tie",
    "catalogNumber": "911717PER",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287171_visualizer-solid-PER-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631209_layflat-solid-PER-persimmon-long_tie-181115162931.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1319,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Blush",
    "type": "Pocket Square",
    "catalogName": "Petal Zig Zag Pocket Square",
    "catalogNumber": "611196PET",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BSH-petal_blush-pocket_square-181101165907.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356582_20181009-150631-611196BSH_PocketSquare_ZigZag_Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 122,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Purple",
    "type": "Cummerbund",
    "catalogName": "Viola Cummerbund",
    "catalogNumber": "710049VIO",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354490_20181009-150631-710049PRP_Solid_Cummerbund_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 107,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Purple",
    "type": "Cummerbund",
    "catalogName": "Viola Paisley Cummerbund",
    "catalogNumber": "710034VIO",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539353971_20181009-150631-710034PRP_Paisley_Cummerbund_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1320,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Malibu",
    "type": "Pocket Square",
    "catalogName": "Aqua Zig Zag Pocket Square",
    "catalogNumber": "611197MBU",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-MBU-aqua-pocket_square-181101170119.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356610_20181009-150631-611197MBU_PocketSquare_ZigZag_Malibu.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1905,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Royal Blue",
    "type": "Swatch (accessory)",
    "catalogName": "Horizon",
    "catalogNumber": "P21749HOR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286867_royal blue_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2701,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Oasis Pre-Tied Striped Tie",
    "catalogNumber": "912478OAS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-OAS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-OAS-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 118,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Lilac",
    "type": "Cummerbund",
    "catalogName": "Lilac Cummerbund",
    "catalogNumber": "710045LIL",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354177_20181009-150631-710045LIL_Solid_Cummerbund_Lilac.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1321,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Begonia",
    "type": "Pocket Square",
    "catalogName": "Begonia Zig Zag Pocket Square",
    "catalogNumber": "611198BGA",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-BGA-begonia-pocket_square-181101170052.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356642_20181009-150631-611198BGA_PocketSquare_ZigZag_Begonia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2028,
    "unitCost": 0.5,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Indigo",
    "type": "Swatch (accessory)",
    "catalogName": "Indigo",
    "catalogNumber": "P21872IND",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287089_46_Indigo.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1861,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Regency",
    "type": "Tie",
    "catalogName": "Regency Solid Pre-Tied Tie",
    "catalogNumber": "911705REG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287168_visualizer-solid-REG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631244_layflat-solid-REG-regency-long_tie-181115153919.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1980,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Cobalt",
    "type": "Swatch (accessory)",
    "catalogName": "Cobalt",
    "catalogNumber": "P21824COB",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287079_08_Cobalt.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1322,
    "unitCost": 1.5,
    "pattern": "Zig Zag",
    "description": "Pocket Square, Mens, Zig-Zag, Emerald",
    "type": "Pocket Square",
    "catalogName": "Emerald Zig Zag Pocket Square",
    "catalogNumber": "611199EMD",
    "costToCustomer": 10,
    "attributePrimary": "Zig-Zag",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-zig_zag-EMD-emerald-pocket_square-181101165722.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356679_20181009-150631-611199EMD_PocketSquare_ZigZag_Emerald.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1852,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Turquoise",
    "type": "Tie",
    "catalogName": "Turquoise Solid Pre-Tied Tie",
    "catalogNumber": "911696TRQ",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287166_visualizer-solid-TRQ-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631277_layflat-solid-TRQ-turquoise-long_tie-181115160840.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 111,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Begonia",
    "type": "Cummerbund",
    "catalogName": "Begonia Cummerbund",
    "catalogNumber": "710038BGA",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354029_20181009-150631-710038BGA_Solid_Cummerbund_Begonia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2362,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Mercury",
    "type": "Tie",
    "catalogName": "Mercury Pre-Tied Bow Tie",
    "catalogNumber": "912206MRC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833951_visualizer_tie_no_strap-solid-MRC-mercury-bow_tie-190313014442-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833929_layflat-solid-MRC-mercury-bow_tie-190312165318.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1323,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Champagne",
    "type": "Pocket Square",
    "catalogName": "Champagne Plaid Pocket Square",
    "catalogNumber": "611200CHM",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-CHM-champaign-pocket_square-181101160415.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356708_20181009-150631-611200CHM_PocketSquare_Plaid_Champagne.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1094,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Coral Reef",
    "type": "Cummerbund",
    "catalogName": "Coral Reef Cummerbund",
    "catalogNumber": "710985COR",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539704382_20181009-150631-710985COR_Cummberbund_Solid_CoralReef.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1961,
    "unitCost": 0.45,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Navy",
    "type": "Swatch (accessory)",
    "catalogName": "Marine",
    "catalogNumber": "P21805MAR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287083_19_Navy_Marine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1101,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Jalapeno Dark Orange",
    "type": "Cummerbund",
    "catalogName": "Jalapeno Cummerbund",
    "catalogNumber": "710988JDO",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344455_20181009-150631-710988JDO_Cummberbund_Solid_Jalapeno.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1933,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Portobello",
    "type": "Swatch (accessory)",
    "catalogName": "Portobello",
    "catalogNumber": "P21777PRT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286866_portobello_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2700,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Lapis Pre-Tied Striped Tie",
    "catalogNumber": "912475LAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-LAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-LAP-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1324,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Wine",
    "type": "Pocket Square",
    "catalogName": "Sangria Plaid Pocket Square",
    "catalogNumber": "611201SGA",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-WNE-wine-pocket_square-181101155714.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356738_20181009-150631-611201WNE_PocketSquare_Plaid_Wine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2662,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Peacock Pre-Tied Striped Tie",
    "catalogNumber": "912379PCK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-PCK-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-PCK-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2055,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Lapis",
    "type": "Swatch (accessory)",
    "catalogName": "Lapis",
    "catalogNumber": "P21899LAP",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287089_43_Lapis.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1325,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Coral Reef",
    "type": "Pocket Square",
    "catalogName": "Coral Reef Plaid Pocket Square",
    "catalogNumber": "611202COR",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539356183_20181009-150631-611202COR_PocketSquare_Plaid_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-COR-coral-pocket_square-181101160323.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 113,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Blush",
    "type": "Cummerbund",
    "catalogName": "Blush - Petal Cummerbund",
    "catalogNumber": "710040BSH",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343947_20181009-150631-710040BSH_Solid_Cummerbund_Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1913,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Purple",
    "type": "Swatch (accessory)",
    "catalogName": "Viola",
    "catalogNumber": "P21757VIO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286866_purple_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 121,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Platinum",
    "type": "Cummerbund",
    "catalogName": "Platinum Cummerbund",
    "catalogNumber": "710048PLT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354467_20181009-150631-710048PLT_Solid_Cummerbund_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2358,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Oasis",
    "type": "Tie",
    "catalogName": "Oasis Pre-Tied Bow Tie",
    "catalogNumber": "912202OAS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834016_visualizer_tie_no_strap-solid-OAS-oasis-bow_tie-190313014935-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834000_layflat-solid-OAS-oasis-bow_tie-190312173854.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1326,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Pacific",
    "type": "Pocket Square",
    "catalogName": "Pacific Plaid Pocket Square",
    "catalogNumber": "611203PAC",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-PAC-pacific-pocket_square-181101160203.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356273_20181009-150631-611203PAC_PocketSquare_Plaid_Pacific.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1327,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Dark Navy",
    "type": "Pocket Square",
    "catalogName": "Dark Navy Plaid Pocket Square",
    "catalogNumber": "611204DNV",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-DNV-dark_navy-pocket_square-181101155952.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356556_20181009-150631-611204DNV_PocketSquare_Plaid_DarkNavy.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2661,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Turquoise Pre-Tied Striped Tie",
    "catalogNumber": "912376TRQ",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-TRQ-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-TRQ-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1981,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Eggplant",
    "type": "Swatch (accessory)",
    "catalogName": "Eggplant",
    "catalogNumber": "P21825EGG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287078_07_Eggplant.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 106,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Platinum",
    "type": "Cummerbund",
    "catalogName": "Platinum Paisley Cummerbund",
    "catalogNumber": "710033PLT",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539353942_20181009-150631-710033PLT_Paisley_Cummerbund_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1996,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Regency",
    "type": "Swatch (accessory)",
    "catalogName": "Regency",
    "catalogNumber": "P21840REG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287086_32_Regency.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1092,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Champagne",
    "type": "Cummerbund",
    "catalogName": "Champagne Cummerbund",
    "catalogNumber": "710983CHM",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344265_20181009-150631-710983CHM_Cummberbund_Solid_Champagne.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1328,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Jalapeno Dark Orange",
    "type": "Pocket Square",
    "catalogName": "Jalapeno Plaid Pocket Square",
    "catalogNumber": "611205JDO",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-JDO-dark_orange-pocket_square-181101160018.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356578_20181009-150631-611205JDO_PocketSquare_Plaid_Jalapeno.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2660,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Freesia Pre-Tied Striped Tie",
    "catalogNumber": "912373FRE",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-FRE-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-FRE-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 117,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Ivory",
    "type": "Cummerbund",
    "catalogName": "Ivory Cummerbund",
    "catalogNumber": "710044IVO",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539354113_20181009-150631-710044IVO_Solid_Cummerbund_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2659,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Latte Pre-Tied Striped Tie",
    "catalogNumber": "912370LAT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-LAT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-LAT-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1329,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Tiffany Blue",
    "type": "Pocket Square",
    "catalogName": "Tiffany Blue Plaid Pocket Square",
    "catalogNumber": "611206TBL",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-TBL-tiffany_blue-pocket_square-181101155807.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356601_20181009-150631-611206TBL_PocketSquare_Plaid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1960,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Persian Plum",
    "type": "Swatch (accessory)",
    "catalogName": "Persian Plum",
    "catalogNumber": "P21804PPL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287082_14_Persian Plum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 104,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Ivory",
    "type": "Cummerbund",
    "catalogName": "Ivory Paisley Cummerbund",
    "catalogNumber": "710031IVO",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343644_20181009-150631-710031IVO_Paisley_Cummerbund_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2658,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Chocolate Pre-Tied Striped Tie",
    "catalogNumber": "912367CHO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-CHO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-CHO-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1330,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Plum",
    "type": "Pocket Square",
    "catalogName": "Plum Plaid Pocket Square",
    "catalogNumber": "611207PLM",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-PLM-plum-pocket_square-181101160256.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356633_20181009-150631-611207PLM_PocketSquare_Plaid_Plum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1896,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Plum",
    "type": "Swatch (accessory)",
    "catalogName": "Plum",
    "catalogNumber": "P21740PLM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286866_plum_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2657,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Eggplant Pre-Tie Striped Tie",
    "catalogNumber": "912364EGG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-EGG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-EGG-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1331,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Bellini",
    "type": "Pocket Square",
    "catalogName": "Bellini Plaid Pocket Square",
    "catalogNumber": "611208BEL",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-BEL-bellini-pocket_square-181101160601.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356656_20181009-150631-611208BEL_PocketSquare_Plaid_Bellini.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 114,
    "unitCost": 7.5,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Canary",
    "type": "Cummerbund",
    "catalogName": "Canary Cummerbund",
    "catalogNumber": "710041CAN",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343976_20181009-150631-710041CAN_Solid_Cummerbund_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1957,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Purple",
    "type": "Swatch (accessory)",
    "catalogName": "Purple",
    "catalogNumber": "P21801PUR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287086_34_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 102,
    "unitCost": 7.5,
    "pattern": "Paisley",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Paisley, Canary",
    "type": "Cummerbund",
    "catalogName": "Canary Paisley Cummerbund",
    "catalogNumber": "710029CAN",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539343598_20181009-150631-710029CAN_Paisley_Cummerbund_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1332,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Ice Blue",
    "type": "Pocket Square",
    "catalogName": "Ice Blue Plaid Pocket Square",
    "catalogNumber": "611209IBL",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-IBL-ice_blue-pocket_square-181101160045.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356683_20181009-150631-611209IBL_PocketSquare_Plaid_IceBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2656,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Cobalt Pre-Tie Striped Tie",
    "catalogNumber": "912361COB",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-COB-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-COB-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1928,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Lilac",
    "type": "Swatch (accessory)",
    "catalogName": "Lilac",
    "catalogNumber": "P21772LIL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286865_lilac_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1333,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Biscotti",
    "type": "Pocket Square",
    "catalogName": "Biscotti Plaid Pocket Square",
    "catalogNumber": "611210BIS",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-BIS-biscotti-pocket_square-181101160535.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539358600_20181009-150631-611210BIS_PocketSquare_Plaid_Biscotti.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1093,
    "unitCost": 9,
    "pattern": "Solid",
    "description": "Cummerbund, Mens, Fancy, Pleated, Solid Twill Lining Back, Solid Twill, Wine",
    "type": "Cummerbund",
    "catalogName": "Sangria Cummerbund",
    "catalogNumber": "710984SGA",
    "costToCustomer": 10,
    "attributePrimary": "Fancy",
    "attributeSecondary": "Pleated",
    "attributeTertiary": "Solid Twill Lining Back",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539344290_20181009-150631-710984WNE_Cummberbund_Solid_Wine.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2655,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Sunbeam Pre-Tied Striped Tie",
    "catalogNumber": "912358SUN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-SUN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-SUN-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1941,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Bouquet",
    "type": "Swatch (accessory)",
    "catalogName": "Bouquet",
    "catalogNumber": "P21785BQT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286864_lavender_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1334,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, White",
    "type": "Pocket Square",
    "catalogName": "White Plaid Pocket Square",
    "catalogNumber": "611211WHT",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-WHT-white-pocket_square-181101155741.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356767_20181009-150631-611211WHT_PocketSquare_Plaid_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2654,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Merlot Pre-Tied Striped Tie",
    "catalogNumber": "912355MER",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MER-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MER-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1988,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Freesia",
    "type": "Swatch (accessory)",
    "catalogName": "Freesia",
    "catalogNumber": "P21832FRE",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287090_48_Freesia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1335,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Black",
    "type": "Pocket Square",
    "catalogName": "Black Plaid Pocket Square",
    "catalogNumber": "611212BLK",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-BLK-black-pocket_square-181101160508.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356791_20181009-150631-611212BLK_PocketSquare_Plaid_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2054,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Iris",
    "type": "Swatch (accessory)",
    "catalogName": "Iris",
    "catalogNumber": "P21898IRS",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287082_15_Iris.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2652,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Burnt Orange Pre-Tied Striped Tie",
    "catalogNumber": "912349BOR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-BOR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-BOR-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2051,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Desert Blue",
    "type": "Swatch (accessory)",
    "catalogName": "Desert Blue",
    "catalogNumber": "P21895DBL",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287091_51_Desert Blue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1336,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Platinum",
    "type": "Pocket Square",
    "catalogName": "Platinum Plaid Pocket Square",
    "catalogNumber": "611213PLT",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-PLT-platinum-pocket_square-181101160230.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356814_20181009-150631-611213PLT_PocketSquare_Plaid_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2651,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Tangeringe",
    "catalogNumber": "912346TNG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-TNG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-TNG-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2650,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Nude Pre-Tied Striped Tie",
    "catalogNumber": "912343NUD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-NUD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-NUD-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1992,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Peacock",
    "type": "Swatch (accessory)",
    "catalogName": "Peacock",
    "catalogNumber": "P21836PCK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287083_20_Peacock.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1337,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Charcoal",
    "type": "Pocket Square",
    "catalogName": "Pewter Plaid Pocket Square",
    "catalogNumber": "611214PEW",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-CHA-charcoal-pocket_square-181101160349.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356838_20181009-150631-611214CHA_PocketSquare_Plaid_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1984,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Chocolate",
    "type": "Swatch (accessory)",
    "catalogName": "Chocolate",
    "catalogNumber": "P21828CHO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287091_53_Chocolate.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1338,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Royal Blue",
    "type": "Pocket Square",
    "catalogName": "Horizon Plaid Pocket Square",
    "catalogNumber": "611215HOR",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-RYL-royal_blue-pocket_square-181101155900.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356859_20181009-150631-611215RYL_PocketSquare_Plaid_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2649,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "First Blush Pre-Tied Striped Tie",
    "catalogNumber": "912340FBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-FBL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-FBL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1339,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Purple",
    "type": "Pocket Square",
    "catalogName": "Viola Plaid Pocket Square",
    "catalogNumber": "611216VIO",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-PRP-purple-pocket_square-181101155926.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356885_20181009-150631-611216PRP_PocketSquare_Plaid_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1985,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Latte",
    "type": "Swatch (accessory)",
    "catalogName": "Latte",
    "catalogNumber": "P21829LAT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287081_10_Latte.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2648,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Bright Fuchsia Pre-Tied Striped Tie",
    "catalogNumber": "912337BFU",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-BFU-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-BFU-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1340,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Ruby/Valentina",
    "type": "Pocket Square",
    "catalogName": "Ruby Valentino Plaid Pocket Square",
    "catalogNumber": "611217RUV",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-RUV-ruby-pocket_square-181101155833.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356857_20181009-150631-611217RUV_PocketSquare_Plaid_Ruby.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2647,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Marine Pre-Tied Striped Tie",
    "catalogNumber": "912334MAR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-NVY-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-NVY-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2037,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Cocoa",
    "type": "Swatch (accessory)",
    "catalogName": "Cocoa",
    "catalogNumber": "P21881COC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287091_52_Cocoa.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1893,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Platinum",
    "type": "Swatch (accessory)",
    "catalogName": "Platinum",
    "catalogNumber": "P21737PLT",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286866_platinum_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2646,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Persian Plum Pre-Tied Striped Tie",
    "catalogNumber": "912331PPL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-PPL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-PPL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1341,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, VW/DB Mint",
    "type": "Pocket Square",
    "catalogName": "Mint Plaid Pocket Square",
    "catalogNumber": "611218MNT",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-VMT-mint-pocket_square-181101160137.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356888_20181009-150631-611218VMT_PocketSquare_Plaid_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2059,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Mercury",
    "type": "Swatch (accessory)",
    "catalogName": "Mercury",
    "catalogNumber": "P21903MRC",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287088_41_Mercury.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2645,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Purple Pre-Tied Striped Tie",
    "catalogNumber": "912328PUR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-PUR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-PUR-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1342,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Ivory",
    "type": "Pocket Square",
    "catalogName": "Ivory Plaid Pocket Square",
    "catalogNumber": "611219IVO",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-IVO-ivory-pocket_square-181101160111.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356920_20181009-150631-611219IVO_PocketSquare_Plaid_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2644,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Clover Pre-Tied Striped Tie",
    "catalogNumber": "912325CLV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-CLV-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-CLV-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1343,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Blush",
    "type": "Pocket Square",
    "catalogName": "Petal Plaid Pocket Square",
    "catalogNumber": "611220PET",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-BSH-petal_blush-pocket_square-181101160442.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356949_20181009-150631-611220BSH_PocketSquare_Plaid_Blush.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1897,
    "unitCost": 0.65,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Charcoal",
    "type": "Swatch (accessory)",
    "catalogName": "Pewter",
    "catalogNumber": "P21741PEW",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286862_charcoal_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2643,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Ballet Pre-Tied Striped Tie",
    "catalogNumber": "912322BAL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-BAL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-BAL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1344,
    "unitCost": 1.5,
    "pattern": "Plaid",
    "description": "Pocket Square, Mens, Plaid, Malibu",
    "type": "Pocket Square",
    "catalogName": "Malibu Plaid Pocket Square",
    "catalogNumber": "611221MBU",
    "costToCustomer": 10,
    "attributePrimary": "Plaid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-plaid-MBU-aqua-pocket_square-181101160627.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1539356986_20181009-150631-611221MBU_PocketSquare_Plaid_Malibu.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2020,
    "unitCost": 0.55,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Silver",
    "type": "Swatch (accessory)",
    "catalogName": "Silver",
    "catalogNumber": "P21864SVR",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287085_29_Silver.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2642,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Blue Ice Pre-Tied Striped Tie",
    "catalogNumber": "912319BIC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-BIC-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-BIC-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1875,
    "unitCost": 0.5,
    "pattern": "Solid",
    "description": "Promo, Swatches, Generation Tux, Black",
    "type": "Swatch (accessory)",
    "catalogName": "Black",
    "catalogNumber": "P21719BLK",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286861_black_swatch.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 179,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Black",
    "type": "Lapel Pin",
    "catalogName": "Black Rose Lapel Pin",
    "catalogNumber": "040106BLK",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174977_20181009-150631-040106BLK_Lapel_Rose_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2641,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Tea Rose Pre-Tied Striped Tie",
    "catalogNumber": "912316TRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-TRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-TRS-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 195,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, White",
    "type": "Lapel Pin",
    "catalogName": "White Rose Lapel Pin",
    "catalogNumber": "040122WHT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178415_20181009-150631-040122WHT_Lapel_Rose_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2640,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Meadow Pre-Tied Striped Tie",
    "catalogNumber": "912313MDW",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MDW-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MDW-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2639,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Ferrari Red Pre-Tied Striped Tie",
    "catalogNumber": "912310FRD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-stripes-FRD-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-FRD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 194,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Ruby/Valentina",
    "type": "Lapel Pin",
    "catalogName": "Ruby Valentino Rose Lapel Pin",
    "catalogNumber": "040121RUV",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175888_20181009-150631-040121RUV_Lapel_Rose_Ruby.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2409,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Iris",
    "type": "Tie",
    "catalogName": "Iris Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912253IRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-IRS-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-IRS-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1509,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Wine",
    "type": "Lapel Pin",
    "catalogName": "Sangria Rose Lapel Pin",
    "catalogNumber": "041363SGA",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178493_20181009-150631-041363WNE-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1520,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Bouquet",
    "type": "Lapel Pin",
    "catalogName": "Bouquet Rose Lapel Pin",
    "catalogNumber": "041372BQT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178732_20181009-150631-041372BQT-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2155,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Blue Ice",
    "type": "Tie",
    "catalogName": "Blue Ice Pre-Tied Bow Tie",
    "catalogNumber": "911999BIC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834085_visualizer_tie_no_strap-solid-BIC-blue_ice-bow_tie-190313015031-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834069_layflat-solid-BIC-blue_ice-bow_tie-190312174731.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 187,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Lilac",
    "type": "Lapel Pin",
    "catalogName": "Lilac Rose Lapel Pin",
    "catalogNumber": "040114LIL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175598_20181009-150631-040114LIL_Lapel_Rose_Lilac.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2413,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Oasis",
    "type": "Tie",
    "catalogName": "Oasis Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912257OAS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-OAS-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-OAS-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1516,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Plum",
    "type": "Lapel Pin",
    "catalogName": "Plum Rose Lapel Pin",
    "catalogNumber": "041368PLM",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178626_20181009-150631-041368PLM-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2385,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Morning Glory",
    "type": "Tie",
    "catalogName": "Morning Glory Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912229MGL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MGL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MGL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2383,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Indigo",
    "type": "Tie",
    "catalogName": "Indigo Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912227IND",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-IND-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-IND-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 192,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Purple",
    "type": "Lapel Pin",
    "catalogName": "Viola Rose Lapel Pin",
    "catalogNumber": "040119VIO",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175797_20181009-150631-040119PRP_Lapel_Rose_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 178,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Begonia",
    "type": "Lapel Pin",
    "catalogName": "Begonia Rose Lapel Pin",
    "catalogNumber": "040105BGA",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174945_20181009-150631-040105BGA_Lapel_Rose_BrightPink.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2381,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Mulberry",
    "type": "Tie",
    "catalogName": "Mulberry Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912225MUL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MUL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MUL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2375,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Silver",
    "type": "Tie",
    "catalogName": "Silver Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912219SVR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-SVR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-SVR-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1521,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Watermelon",
    "type": "Lapel Pin",
    "catalogName": "Watermelon Rose Lapel Pin",
    "catalogNumber": "041373WTM",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178759_20181009-150631-041373WTM-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1522,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Tickled",
    "type": "Lapel Pin",
    "catalogName": "Tickled Rose Lapel Pin",
    "catalogNumber": "041374TCK",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178783_20181009-150631-041374TCK-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2371,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Salmon",
    "type": "Tie",
    "catalogName": "Salmon Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912215SAL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-SAL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-SAL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1510,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Coral Reef",
    "type": "Lapel Pin",
    "catalogName": "Coral Reef Rose Lapel Pin",
    "catalogNumber": "041364COR",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178519_20181009-150631-041364COR-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2369,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Juniper/Hunter",
    "type": "Tie",
    "catalogName": "Hunter Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912213HUN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-HUN-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-HUN-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 186,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Jalapeno Dark Orange",
    "type": "Lapel Pin",
    "catalogName": "Jalapeno Rose Men's Lapel Pin",
    "catalogNumber": "040113JDO",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175539_20181009-150631-040113JDO_Lapel_Rose_JalapenoDarkOrange.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2365,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Mermaid/Spa",
    "type": "Tie",
    "catalogName": "Spa Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912209SPA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MRD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MRD-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2363,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Olive",
    "type": "Tie",
    "catalogName": "Olive Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912207OLV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-OLV-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-OLV-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 182,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Charcoal",
    "type": "Lapel Pin",
    "catalogName": "Pewter Rose Lapel Pin",
    "catalogNumber": "040109PEW",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175358_20181009-150631-040109CHA_Lapel_Rose_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2359,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Midas Gold",
    "type": "Tie",
    "catalogName": "Midas Gold Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912203MGO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MGO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MGO-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2347,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Jade",
    "type": "Tie",
    "catalogName": "Jade Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912191JDE",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-JDE-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-JDE-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 191,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Platinum",
    "type": "Lapel Pin",
    "catalogName": "Platinum Rose Lapel Pin",
    "catalogNumber": "040118PLT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175770_20181009-150631-040118PLT_Lapel_Rose_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 183,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Emerald",
    "type": "Lapel Pin",
    "catalogName": "Emerald Rose Lapel Pin",
    "catalogNumber": "040110EMD",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175436_20181009-150631-40110EMD_Lapel_Rose_Emerald-2.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2341,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Sapphire",
    "type": "Tie",
    "catalogName": "Sapphire Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912185SAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-SAP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-SAP-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2336,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Regency",
    "type": "Tie",
    "catalogName": "Regency Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912180REG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-REG-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-REG-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 185,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Jade",
    "type": "Lapel Pin",
    "catalogName": "Jade Rose Lapel Pin",
    "catalogNumber": "040112JDE",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175505_20181009-150631-40112JDE_Lapel_Rose_Jade.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 189,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Mint",
    "type": "Lapel Pin",
    "catalogName": "Men's Rose Lapel Pin: Mint",
    "catalogNumber": "040116MNT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175679_20181009-150631-040116MNT_Lapel_Rose_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2333,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Aquamarine",
    "type": "Tie",
    "catalogName": "Aqua Marine Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912177AQM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287398_layflat-pin_dot-AQM-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-AQM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 188,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Malibu",
    "type": "Lapel Pin",
    "catalogName": "Aqua Rose Lapel Pin",
    "catalogNumber": "040115MBU",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175639_20181009-150631-040115MBU_Lapel_Rose_Aqua.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2329,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Peacock",
    "type": "Tie",
    "catalogName": "Peacock Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912173PCK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PCK-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PCK-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2325,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Turquoise",
    "type": "Tie",
    "catalogName": "Turquoise Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912168TRQ",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-TRQ-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-TRQ-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1512,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Dark Navy",
    "type": "Lapel Pin",
    "catalogName": "Dark Navy Rose Lapel Pin",
    "catalogNumber": "041366DNV",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178575_20181009-150631-041366DNV-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1517,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Ice Blue",
    "type": "Lapel Pin",
    "catalogName": "Ice Blue Rose Lapel Pin",
    "catalogNumber": "041369IBL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178652_20181009-150631-041369IBL-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2319,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Freesia",
    "type": "Tie",
    "catalogName": "Freesia Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912163FRE",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-FRE-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-FRE-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1511,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Pacific",
    "type": "Lapel Pin",
    "catalogName": "Pacific Blue Rose Lapel Pin",
    "catalogNumber": "041365PAC",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178544_20181009-150631-041365PAC-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2313,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Wedgewood",
    "type": "Tie",
    "catalogName": "Wedgewood Pre-Tied Bow Tie",
    "catalogNumber": "912157WED",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834177_visualizer_tie_no_strap-solid-WED-wedgewood-bow_tie-190313014816-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834157_layflat-solid-WED-wedgewood-bow_tie-190312172636.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 193,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Royal Blue",
    "type": "Lapel Pin",
    "catalogName": "Horizon Rose Lapel Pin",
    "catalogNumber": "040120HOR",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175826_20181009-150631-040120RYL_Lapel_Rose_Blue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2308,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Latte",
    "type": "Tie",
    "catalogName": "Latte Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912152LAT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-LAT-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-LAT-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1513,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Tiffany Blue",
    "type": "Lapel Pin",
    "catalogName": "Tiffany Blue Rose Lapel Pin",
    "catalogNumber": "041367TBL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178602_20181009-150631-041367TBL-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2293,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Chocolate",
    "type": "Tie",
    "catalogName": "Chocolate Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912137CHO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-CHO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-CHO-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2289,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Eggplant",
    "type": "Tie",
    "catalogName": "Eggplant Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912133EGG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-EGG-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-EGG-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 181,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Canary",
    "type": "Lapel Pin",
    "catalogName": "Canary Rose Lapel Pin",
    "catalogNumber": "040108CAN",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539175307_20181009-150631-040108CAN_Lapel_Rose_Canary.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1518,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Biscotti",
    "type": "Lapel Pin",
    "catalogName": "Biscotti Rose Lapel Pin",
    "catalogNumber": "041370BIS",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178676_20181009-150631-041370BIS-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2306,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Mulberry",
    "type": "Tie",
    "catalogName": "Mulberry Pre-Tied Bow Tie",
    "catalogNumber": "912150MUL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834280_visualizer_tie_no_strap-solid-MUL-mulberry-bow_tie-190313014752-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834259_layflat-solid-MUL-mulberry-bow_tie-190312172252.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2304,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Guava/Sunset",
    "type": "Tie",
    "catalogName": "Guava Pre-Tied Bow Tie",
    "catalogNumber": "912148GUA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834167_layflat-solid-GUA-guava-sunset-bow_tie-190312175607.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287210_visualizer-solid-GUA-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1019,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Champagne",
    "type": "Lapel Pin",
    "catalogName": "Champagne Rose Lapel Pin",
    "catalogNumber": "040921CHM",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178468_20181009-150631-040921CHM-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1519,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Rose, Toffee Gold",
    "type": "Lapel Pin",
    "catalogName": "Toffee Rose Lapel Pin",
    "catalogNumber": "041371TOF",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Rose",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178706_20181009-150631-041371TOF-LapelPin-Lapel_Rose.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2300,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Silver",
    "type": "Tie",
    "catalogName": "Silver Pre-Tied Bow Tie",
    "catalogNumber": "912144SVR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833881_layflat-solid-SVR-silver-bow_tie-190312173245.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287208_visualizer-solid-SVR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2285,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Cobalt",
    "type": "Tie",
    "catalogName": "Cobalt Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912129COB",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-COB-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-COB-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1523,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Champagne",
    "type": "Lapel Pin",
    "catalogName": "Champagne Carnation Lapel Pin",
    "catalogNumber": "041375CHM",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178812_20181009-150631-041375CHM-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 177,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, White",
    "type": "Lapel Pin",
    "catalogName": "White Carnation Lapel Pin",
    "catalogNumber": "040104WHT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174903_20181009-150631-040104WHT_Lapel_Carnation_White.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2283,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Mermaid/Spa",
    "type": "Tie",
    "catalogName": "Spa Pre-Tied Bow Tie",
    "catalogNumber": "912127SPA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833650_layflat-solid-MRD-mermaid-spa-bow_tie-190312170805.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287203_visualizer-solid-MRD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 166,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Ivory",
    "type": "Lapel Pin",
    "catalogName": "Ivory Carnation Lapel Pin",
    "catalogNumber": "040093IVO",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539116205_20181009-150631-040093IVO_Lapel_Flower_Ivory.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2281,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Olive",
    "type": "Tie",
    "catalogName": "Olive Pre-Tied Bow Tie",
    "catalogNumber": "912125OLV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833350_visualizer_tie_no_strap-pin_dot-OLV-olive-bow_tie-190313012945-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833329_layflat-solid-OLV-olive-bow_tie-190312175453.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 176,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Ruby/Valentina",
    "type": "Lapel Pin",
    "catalogName": "Ruby Valentino Carnation Lapel Pin",
    "catalogNumber": "040103RUV",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174835_20181009-150631-040103RUV_Lapel_Carnation_Red.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2279,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Midas Gold",
    "type": "Tie",
    "catalogName": "Midas Gold Pre-Tied Bow Tie",
    "catalogNumber": "912123MGO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833113_layflat-solid-MGO-midas_gold-bow_tie-190312171644.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287202_visualizer-solid-MGO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1524,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Wine",
    "type": "Lapel Pin",
    "catalogName": "Sangria Carnation Lapel Pin",
    "catalogNumber": "041376SGA",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178843_20181009-150631-041376WNE-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2277,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Persimmon",
    "type": "Tie",
    "catalogName": "Persimmon Pre-Tied Bow Tie",
    "catalogNumber": "912121PER",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834348_layflat-solid-PER-persimmon-bow_tie-190312174959.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287201_visualizer-solid-PER-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1813,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Navy",
    "type": "Tie",
    "catalogName": "Marine Solid Pre-Tied Tie",
    "catalogNumber": "911657MAR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287156_visualizer-solid-NVY-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630854_layflat-solid-DNV-dark_navy-long_tie-181115144339.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 174,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Purple",
    "type": "Lapel Pin",
    "catalogName": "Viola Carnation Lapel Pin",
    "catalogNumber": "040101VIO",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174752_20181009-150631-040101PRP_Lapel_Carnation_Purple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 169,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Lilac",
    "type": "Lapel Pin",
    "catalogName": "Lilac Carnation Lapel Pin",
    "catalogNumber": "040096LIL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539116429_20181009-150631-040096LIL_Lapel_Flower_Lilac.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2271,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Petal Pink",
    "type": "Tie",
    "catalogName": "Petal Pink Pre-Tied Bow Tie",
    "catalogNumber": "912115PTP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834561_layflat-solid-PTP-petal_pink-bow_tie-190312173626.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287200_visualizer-solid-PTP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2751,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Blush Pre-Tied Tie",
    "catalogNumber": "911969BSH",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542633434_layflat-solid-FBL-first_blush-long_tie-181115160003.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286673_910302BSH-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 160,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Begonia",
    "type": "Lapel Pin",
    "catalogName": "Begonia Carnation Lapel Pin",
    "catalogNumber": "040087BGA",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539115607_20181009-150631-040087BGA_Lapel_Carnation_BrightPinkBegonia.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2269,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Regency",
    "type": "Tie",
    "catalogName": "Regency Pre-Tied Bow Tie",
    "catalogNumber": "912113REG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834670_visualizer_tie_no_strap-solid-REG-regency-bow_tie-190313014657-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834638_layflat-solid-REG-regency-bow_tie-190312171417.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2265,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Peacock",
    "type": "Tie",
    "catalogName": "Peacock Pre-Tied Bow Tie",
    "catalogNumber": "912109PCK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834758_visualizer_tie_no_strap-solid-PCK-peacock-bow_tie-190313014609-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834746_layflat-solid-PCK-peacock-bow_tie-190312170652.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1532,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Tickled",
    "type": "Lapel Pin",
    "catalogName": "Tickled Carnation Lapel Pin",
    "catalogNumber": "041384TCK",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539179050_20181009-150631-041384TCK-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 172,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Peach",
    "type": "Lapel Pin",
    "catalogName": "Peach Carnation Lapel Pin",
    "catalogNumber": "040099PCH",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539703967_20181009-150631-040099PCH_Lapel_Flower_Peach.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2263,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Turquoise",
    "type": "Tie",
    "catalogName": "Turquoise Pre-Tied Bow Tie",
    "catalogNumber": "912107TRQ",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834809_visualizer_tie_no_strap-solid-TRQ-turquoise-bow_tie-190313014912-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834789_layflat-solid-TRQ-turquoise-bow_tie-190312173512.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1525,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Coral Reef",
    "type": "Lapel Pin",
    "catalogName": "Coral Reef Carnation Lapel Pin",
    "catalogNumber": "041377COR",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178866_20181009-150631-041377COR-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2261,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Freesia",
    "type": "Tie",
    "catalogName": "Freesia Pre-Tied Bow Tie",
    "catalogNumber": "912105FRE",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834632_visualizer_tie_no_strap-solid-FRE-freesia-bow_tie-190313015015-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834626_layflat-solid-FRE-freesia-bow_tie-190312174503.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1527,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Jalapeno Dark Orange",
    "type": "Lapel Pin",
    "catalogName": "Jalapeno Carnation Lapel Pin",
    "catalogNumber": "041379JDO",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178923_20181009-150631-041379JDO-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2259,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Latte",
    "type": "Tie",
    "catalogName": "Latte Pre-Tied Bow Tie",
    "catalogNumber": "912103LAT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834705_visualizer_tie_no_strap-solid-LAT-latte-bow_tie-190313014530-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834686_layflat-solid-LAT-latte-bow_tie-190312170042.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 164,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Charcoal",
    "type": "Lapel Pin",
    "catalogName": "Pewter Carnation Lapel Pin",
    "catalogNumber": "040091PEW",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539116091_20181009-150631-040091CHA_Lapel_Flower_Charcoal.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2248,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Sunbeam",
    "type": "Tie",
    "catalogName": "Sunbeam Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912092SUN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-SUN-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-SUN-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2246,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Wine/Merlot",
    "type": "Tie",
    "catalogName": "Merlot Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912090MER",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MER-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MER-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 173,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Platinum",
    "type": "Lapel Pin",
    "catalogName": "Platinum Carnation Lapel Pin",
    "catalogNumber": "040100PLT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174717_20181009-150631-040100PLT_Lapel_Flower_Platinum.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2244,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Pool",
    "type": "Tie",
    "catalogName": "Pool Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912088POL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-POL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-POL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 171,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Mint",
    "type": "Lapel Pin",
    "catalogName": "Mint Carnation Lapel Pin",
    "catalogNumber": "040098MNT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174654_20181009-150631-040098MNT_Lapel_Flower_Mint.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 167,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Jade",
    "type": "Lapel Pin",
    "catalogName": "Jade Carnation Lapel Pin",
    "catalogNumber": "040094JDE",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539116235_20181009-150631-040094JDE_Lapel_Flower_Jade.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2253,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Cobalt",
    "type": "Tie",
    "catalogName": "Cobalt Pre-Tied Bow Tie",
    "catalogNumber": "912097COB",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834770_visualizer_tie_no_strap-solid-COB-cobalt-bow_tie-190313015007-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834763_layflat-solid-COB-cobalt-bow_tie-190312174349.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2242,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Burnt Orange",
    "type": "Tie",
    "catalogName": "Burnt Orange Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912086BOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-BOR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-BOR-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 165,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Emerald",
    "type": "Lapel Pin",
    "catalogName": "Emerald Carnation Lapel Pin",
    "catalogNumber": "040092EMD",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539116136_20181009-150631-040092EMD_Lapel_Flower_Emerald.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 175,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Royal Blue",
    "type": "Lapel Pin",
    "catalogName": "Horizon Carnation Lapel Pin",
    "catalogNumber": "040102HOR",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174781_20181009-150631-040102RYL_Lapel_Carnation_RoyalBlue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2240,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Tangerine",
    "type": "Tie",
    "catalogName": "Tangerine Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912084TNG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1545142314_visualizer-pin_dot-TNG-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1545142301_layflat-pin_dot-TNG-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2236,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, First Blush",
    "type": "Tie",
    "catalogName": "First Blush Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912080FBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-FBL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-FBL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 170,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Malibu",
    "type": "Lapel Pin",
    "catalogName": "Aqua Carnation Lapel Pin",
    "catalogNumber": "040097MBU",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539174618_20181009-150631-040097MBU_Lapel_Carnation_Aqua.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1526,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Dark Navy",
    "type": "Lapel Pin",
    "catalogName": "Dark Navy Carnation Lapel Pin",
    "catalogNumber": "041378DNV",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178889_20181009-150631-041378DNV-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2234,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Bright Fuchsia",
    "type": "Tie",
    "catalogName": "Bright Fuchsia Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912078BFU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-BFU-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-BFU-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1533,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Tiffany Blue",
    "type": "Lapel Pin",
    "catalogName": "Tiffany Blue Carnation Lapel Pin",
    "catalogNumber": "041385TBL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539179073_20181009-150631-041385TBL-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2232,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Navy",
    "type": "Tie",
    "catalogName": "Marine Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912076MAR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-NVY-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-NVY-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1528,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Ice Blue",
    "type": "Lapel Pin",
    "catalogName": "Ice Blue Carnation Lapel Pin",
    "catalogNumber": "041380IBL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178944_20181009-150631-041380IBL-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2228,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Purple",
    "type": "Tie",
    "catalogName": "Purple Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912072PUR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-PUR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-PUR-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2226,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Clover",
    "type": "Tie",
    "catalogName": "Clover Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912070CLV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-CLV-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-CLV-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1529,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Cornflower",
    "type": "Lapel Pin",
    "catalogName": "Cornflower Carnation Lapel Pin",
    "catalogNumber": "041381CFL",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539178969_20181009-150631-041381CFL-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2218,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Meadow",
    "type": "Tie",
    "catalogName": "Meadow Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912062MDW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MDW-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MDW-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 161,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Black",
    "type": "Lapel Pin",
    "catalogName": "Black Carnation Lapel Pin",
    "catalogNumber": "040088BLK",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539115647_20181009-150631-040088BLK_Lapel_Flower_Black.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2224,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Ballet",
    "type": "Tie",
    "catalogName": "Ballet Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912068BAL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-BAL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-BAL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 163,
    "unitCost": 5.05,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Canary",
    "type": "Lapel Pin",
    "catalogName": "Canary Carnation Lapel Pin",
    "catalogNumber": "040090CAN",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539115983_20181009-150631-040090CAN_Lapel_Carnation_CanaryYellow.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1530,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Toffee Gold",
    "type": "Lapel Pin",
    "catalogName": "Toffee Carnation Lapel Pin",
    "catalogNumber": "041382TOF",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539179004_20181009-150631-041382TOF-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2220,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Tea Rose",
    "type": "Tie",
    "catalogName": "Tea Rose Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912064TRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-TRS-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-TRS-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1531,
    "unitCost": 5.25,
    "pattern": "Solid",
    "description": "Lapel Pin, Lapel Pin, Magnetic Back, Carnation, Portobello",
    "type": "Lapel Pin",
    "catalogName": "Portobello Carnation Lapel Pin",
    "catalogNumber": "041383PRT",
    "costToCustomer": 5,
    "attributePrimary": null,
    "attributeSecondary": "Magnetic Back",
    "attributeTertiary": "Carnation",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539179028_20181009-150631-041383PRT-LapelPin-Lapel_Flower.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2405,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Dusty Rose",
    "type": "Tie",
    "catalogName": "Dusty Rose Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912249DRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-DRS-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-DRS-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2403,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Quartz",
    "type": "Tie",
    "catalogName": "Quartz Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912247QRT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-QRT-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-QRT-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2399,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Capri",
    "type": "Tie",
    "catalogName": "Capri Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912243CAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-CAP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-CAP-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2397,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Rose Gold",
    "type": "Tie",
    "catalogName": "Rose Gold Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912241RGL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Miscellaneous",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-RGL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-RGL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2395,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Sun Coral",
    "type": "Tie",
    "catalogName": "Sun Coral Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912239SCO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-SCO-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-SCO-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1238,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Black",
    "type": "Tie",
    "catalogName": "Black Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911117BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620645_20181009-150631-911117BLK_PT_BowTie_ZigZag_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286766_911117BLK-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2391,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Mint Green",
    "type": "Tie",
    "catalogName": "Mint Green Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912235MGR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MGR-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MGR-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2415,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Mercury",
    "type": "Tie",
    "catalogName": "Mercury Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912259MRC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-MRC-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-MRC-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2411,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Lapis",
    "type": "Tie",
    "catalogName": "Lapis Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912255LAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-pin_dot-LAP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/layflat-pin_dot-LAP-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2177,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Pool",
    "type": "Tie",
    "catalogName": "Pool Pre-Tied Bow Tie",
    "catalogNumber": "912021POL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834736_visualizer_tie_no_strap-solid-POL-pool-bow_tie-190313014633-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834719_layflat-solid-POL-pool-bow_tie-190312171033.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2173,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Tangerine",
    "type": "Tie",
    "catalogName": "Tangerine Pre-Tied Bow Tie",
    "catalogNumber": "912017TNG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834586_visualizer_tie_no_strap-solid-TNG-tangerine-bow_tie-190313014649-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834559_layflat-solid-TNG-tangerine-bow_tie-190312171301.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2171,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Nude",
    "type": "Tie",
    "catalogName": "Nude Pre-Tied Bow Tie",
    "catalogNumber": "912015NUD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832761_layflat-solid-NUD-nude-bow_tie-190312174007.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287190_visualizer-solid-NUD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2169,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, First Blush",
    "type": "Tie",
    "catalogName": "First Blush Pre-Tied Bow Tie",
    "catalogNumber": "912013FBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559832826_layflat-solid-FBL-first_blush-bow_tie-190312172903.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287190_visualizer-solid-FBL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2165,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Navy",
    "type": "Tie",
    "catalogName": "Marine Pre-Tied Bow Tie",
    "catalogNumber": "912009MAR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833001_layflat-solid-NVY-navy-marine-bow_tie-190312171758.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287189_visualizer-solid-NVY-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2167,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Bright Fuchsia",
    "type": "Tie",
    "catalogName": "Bright Fuchsia Pre-Tied Bow Tie",
    "catalogNumber": "912011BFU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834382_visualizer_tie_no_strap-solid-BFU-bright_fuchsia-bow_tie-190313015055-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834365_layflat-solid-BFU-bright_fuchsia-bow_tie-190312175113.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2163,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Persian Plum",
    "type": "Tie",
    "catalogName": "Persian Plum Pre-Tied Bow Tie",
    "catalogNumber": "912007PPL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833141_visualizer_tie_no_strap-solid-PPL-persian_plum-bow_tie-190313014840-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833129_layflat-solid-PPL-persian_plum-bow_tie-190312173017.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2159,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Clover",
    "type": "Tie",
    "catalogName": "Clover Pre-Tied Bow Tie",
    "catalogNumber": "912003CLV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833239_visualizer_tie_no_strap-solid-CLV-clover-bow_tie-190313014522-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833227_layflat-solid-CLV-clover-bow_tie-190312165928.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2157,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Ballet",
    "type": "Tie",
    "catalogName": "Ballet Pre-Tied Bow Tie",
    "catalogNumber": "912001BAL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833449_visualizer_tie_no_strap-solid-BAL-ballet-bow_tie-190313014546-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833439_layflat-solid-BAL-ballet-bow_tie-190312170310.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2151,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Meadow",
    "type": "Tie",
    "catalogName": "Meadow Pre-Tied Bow Tie",
    "catalogNumber": "911995MDW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833527_visualizer_tie_no_strap-solid-MDW-meadow-bow_tie-190313014625-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833514_layflat-solid-MDW-meadow-bow_tie-190312170919.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2104,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Wedgewood",
    "type": "Tie",
    "catalogName": "Wedgewood Solid Pre-Tied Tie",
    "catalogNumber": "911948WED",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287180_visualizer-solid-WED-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631309_layflat-solid-WED-wedgewood-long_tie-181115155638.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2101,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Guava",
    "type": "Tie",
    "catalogName": "Guava Solid Pre-Tied Tie",
    "catalogNumber": "911945GUA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287178_visualizer-solid-GUA-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542639790_layflat-solid-GUA-guava-sunset-long_tie-181115163809.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2095,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Indigo",
    "type": "Tie",
    "catalogName": "Indigo Solid Pre-Tied Tie",
    "catalogNumber": "911939IND",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287179_visualizer-solid-IND-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631344_layflat-solid-IND-indigo-long_tie-181115162419.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2092,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Mulberry",
    "type": "Tie",
    "catalogName": "Mulberry Solid Pre-Tied Tie",
    "catalogNumber": "911936MUL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287178_visualizer-solid-MUL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631385_layflat-solid-MUL-mulberry-long_tie-181115155122.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2086,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Silver",
    "type": "Tie",
    "catalogName": "Silver Solid Pre-Tied Tie",
    "catalogNumber": "911930SVR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287177_visualizer-solid-SVR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631417_layflat-solid-SVR-silver-long_tie-181115160513.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2083,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Lime",
    "type": "Tie",
    "catalogName": "Lime Solid Pre-Tied Tie",
    "catalogNumber": "911927LIM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287176_visualizer-solid-LIM-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631454_layflat-solid-LIM-lime-long_tie-181115154613.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2080,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Salmon",
    "type": "Tie",
    "catalogName": "Salmon Solid Pre-Tied Tie",
    "catalogNumber": "911924SAL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287175_visualizer-solid-SAL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631497_layflat-solid-SAL-salmon-long_tie-181115162747.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2071,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Mermaid",
    "type": "Tie",
    "catalogName": "Spa Solid Pre-Tied Tie",
    "catalogNumber": "911915SPA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287173_visualizer-solid-MRD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631588_layflat-solid-MRD-mermaid-spa-long_tie-181115153038.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2074,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Fuchsia",
    "type": "Tie",
    "catalogName": "Fuchsia Solid Pre-Tied Tie",
    "catalogNumber": "911918FCH",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287174_visualizer-solid-FCH-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631651_layflat-solid-FCH-fuchsia-long_tie-181115160330.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2068,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Olive",
    "type": "Tie",
    "catalogName": "Olive Solid Pre-Tied Tie",
    "catalogNumber": "911912OLV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287172_visualizer-solid-OLV-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631694_layflat-solid-OLV-olive-long_tie-181115163624.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2062,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Merlot",
    "type": "Tie",
    "catalogName": "Merlot Solid Pre-Tied Tie",
    "catalogNumber": "911906MER",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287161_visualizer-solid-MER-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631728_layflat-solid-MER-wine-merlot-long_tie-181115154756.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2065,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Midas Gold",
    "type": "Tie",
    "catalogName": "Midas Gold Solid Pre-Tied Tie",
    "catalogNumber": "911909MGO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287172_visualizer-solid-MGO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631777_layflat-solid-MGO-midas_gold-long_tie-181115154246.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1870,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Jade",
    "type": "Tie",
    "catalogName": "Jade Solid Pre-Tied Tie",
    "catalogNumber": "911714JDE",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287170_visualizer-solid-JDE-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631810_layflat-solid-JDE-jade-long_tie-181115153549.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1867,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Sapphire",
    "type": "Tie",
    "catalogName": "Sapphire Solid Pre-Tied Tie",
    "catalogNumber": "911711SAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287169_visualizer-solid-SAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631848_layflat-solid-SAP-sapphire-long_tie-181115154940.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1864,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Petal Pink",
    "type": "Tie",
    "catalogName": "Petal Pink Solid Pre-Tied Tie",
    "catalogNumber": "911708PTP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287168_visualizer-solid-PTP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631902_layflat-solid-PTP-petal_pink-long_tie-181115161024.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1795,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Tea Rose",
    "type": "Tie",
    "catalogName": "Tea Rose Solid Pre-Tied Tie",
    "catalogNumber": "911639TRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287152_visualizer-solid-TRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542630813_layflat-solid-TRS-tea_rose-long_tie-181115152710.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1858,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Aquamarine",
    "type": "Tie",
    "catalogName": "Aqua Marine Solid Pre-Tied Tie",
    "catalogNumber": "911702AQM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542640956_visualizer_tie_full-solid-AQM-aqua_marine-long_tie-181119075127.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542631945_layflat-solid-AQM-aqua_marine-long_tie-181115161208.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1855,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Peacock",
    "type": "Tie",
    "catalogName": "Peacock Solid Pre-Tied Tie",
    "catalogNumber": "911699PCK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641045_visualizer_tie_full-solid-PCK-peacock-long_tie-181119074644.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632356_layflat-solid-PCK-peacock-long_tie-181115152854.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1840,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Eggplant",
    "type": "Tie",
    "catalogName": "Eggplant Solid Pre-Tied Tie",
    "catalogNumber": "911684EGG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287163_visualizer-solid-EGG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632462_layflat-solid-EGG-eggplant-long_tie-181115154102.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1837,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Cobalt",
    "type": "Tie",
    "catalogName": "Cobalt Solid Pre-Tied Tie",
    "catalogNumber": "911681COB",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641088_visualizer_tie_full-stripes-COB-cobalt-long_tie-181119075907.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632494_layflat-solid-COB-cobalt-long_tie-181115162051.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1831,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Pool",
    "type": "Tie",
    "catalogName": "Pool Solid Pre-Tied Tie",
    "catalogNumber": "911675POL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287160_visualizer-solid-POL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632537_layflat-solid-POL-pool-long_tie-181115153405.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2175,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Burnt Orange",
    "type": "Tie",
    "catalogName": "Burnt Orange Pre-Tied Bow Tie",
    "catalogNumber": "912019BOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833577_visualizer_tie_no_strap-solid-BOR-burnt_orange-bow_tie-190313014951-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833568_layflat-solid-BOR-burnt_orange-bow_tie-190312174121.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1828,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Burnt Orange",
    "type": "Tie",
    "catalogName": "Burnt Orange Solid Pre-Tied Tie",
    "catalogNumber": "911672BOR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641129_visualizer_tie_full-solid-BOR-burnt_orange-long_tie-181119075201.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632568_layflat-solid-BOR-burnt_orange-long_tie-181115161720.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1825,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Tangerine",
    "type": "Tie",
    "catalogName": "Tangerine Solid Pre-Tied Tie",
    "catalogNumber": "911669TNG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287159_visualizer-solid-TNG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632613_layflat-solid-TNG-tangerine-long_tie-181115153733.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1661,
    "unitCost": 6.4,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Gold",
    "type": "Tie",
    "catalogName": "Gold Pre-Tied Tie",
    "catalogNumber": "911504GLD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624064_20181009-150631-911504GLD_Solid_Long_PT_Gold.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286843_911504GLD-tie-0493.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2688,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Wedgewood Pre-Tied Striped Tie",
    "catalogNumber": "912439WED",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-WED-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-WED-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2687,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Morning Glory Pre-Tied Striped Tie",
    "catalogNumber": "912436MGL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MGL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MGL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2143,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Oasis",
    "type": "Tie",
    "catalogName": "Oasis Solid Pre-Tied Tie",
    "catalogNumber": "911987OAS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1547827720_visualizer_tie_full-solid-OAS-oasis-long_tie-190118110505-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632655_layflat-solid-OAS-oasis-long_tie-181115161351.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2140,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Lapis",
    "type": "Tie",
    "catalogName": "Lapis Solid Pre-Tied Tie",
    "catalogNumber": "911984LAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287148_visualizer-solid-LAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632696_layflat-solid-LAP-lapis-long_tie-181115151648.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2686,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Indigo Pre-Tied Striped Tie",
    "catalogNumber": "912433IND",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-IND-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-IND-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2137,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Iris",
    "type": "Tie",
    "catalogName": "Iris Solid Pre-Tied Tie",
    "catalogNumber": "911981IRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287148_visualizer-solid-IRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632724_layflat-solid-IRS-iris-long_tie-181115163953.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2685,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Mulberry Pre-Tied Striped Tie",
    "catalogNumber": "912430MUL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MUL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MUL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2131,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Dusty Rose",
    "type": "Tie",
    "catalogName": "Dusty Rose Solid Pre-Tied Tie",
    "catalogNumber": "911975DRS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287147_visualizer-solid-DRS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632769_layflat-solid-DRS-dusty_rose-long_tie-181115151321.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2128,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Quartz",
    "type": "Tie",
    "catalogName": "Quartz Solid Pre-Tied Tie",
    "catalogNumber": "911972QRT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287146_visualizer-solid-QRT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632804_layflat-solid-QRT-quartz-long_tie-181115151505.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2153,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Tea Rose",
    "type": "Tie",
    "catalogName": "Tea Rose Pre-Tied Bow Tie",
    "catalogNumber": "911997TRS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833902_visualizer_tie_no_strap-solid-TRS-tea_rose-bow_tie-190313014602-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833890_layflat-solid-TRS-tea_rose-bow_tie-190312170538.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2684,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Guava Pre-Tied Striped Tie",
    "catalogNumber": "912427GUA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-GUA-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-GUA-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2125,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Blush",
    "type": "Tie",
    "catalogName": "Petal Pre-Tied Tie (Blush)",
    "catalogNumber": "910302PET",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287145_visualizer-solid-PET-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632886_layflat-solid-PET-blush_petal-long_tie-181115164503.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2122,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Capri",
    "type": "Tie",
    "catalogName": "Capri Solid Pre-Tied Tie",
    "catalogNumber": "911966CAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287145_visualizer-solid-CAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632915_layflat-solid-CAP-capri-long_tie-181115155307.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2683,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Kelly Green Pre-Tied Striped Tie",
    "catalogNumber": "912424KGR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-KGN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-KGN-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2119,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Rose Gold",
    "type": "Tie",
    "catalogName": "Rose Gold Solid Pre-Tied Tie",
    "catalogNumber": "911963RGL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641361_visualizer_tie_full-solid-RGL-rose_gold-long_tie-181119074451.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542632965_layflat-solid-RGL-rose_gold-long_tie-181115151137.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2116,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Sun Coral",
    "type": "Tie",
    "catalogName": "Sun Coral Solid Pre-Tied Tie",
    "catalogNumber": "911960SCO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287143_visualizer-solid-SCO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633020_layflat-solid-SCO-sun_coral-long_tie-181115161907.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2113,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Cocoa",
    "type": "Tie",
    "catalogName": "Cocoa Solid Pre-Tied Tie",
    "catalogNumber": "911957COC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287182_visualizer-solid-COC-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633048_layflat-solid-COC-cocoa-long_tie-181115155451.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2110,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Mint Green",
    "type": "Tie",
    "catalogName": "Mint Green Solid Pre-Tied Tie",
    "catalogNumber": "911954MGR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287181_visualizer-solid-MGR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633084_layflat-solid-MGR-mint_green-long_tie-181115160656.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2682,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Silver Pre-Tied Striped Tie",
    "catalogNumber": "912421SVR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-SVR-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-SVR-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2107,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Bubble Gum",
    "type": "Tie",
    "catalogName": "Bubble Gum Solid Pre-Tied Tie",
    "catalogNumber": "911951BGM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287181_visualizer-solid-BGM-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633120_layflat-solid-BGM-bubble_gum-long_tie-181115163259.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2681,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Lime Pre-Tied Striped Tie",
    "catalogNumber": "912418LIM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-LIM-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-LIM-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2680,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Salmon Pre-Tied Striped Tie",
    "catalogNumber": "912415SAL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-SAL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-SAL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2679,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Hunter Pre-Tied Striped Tie",
    "catalogNumber": "912412HUN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-HUN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-HUN-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2678,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Fuchsia Pre-Tied Striped Tie",
    "catalogNumber": "912409FCH",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-FCH-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-FCH-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2677,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Spa Pre-Tied Striped Tie",
    "catalogNumber": "912406SPA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MRD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MRD-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2098,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Morning Glory",
    "type": "Tie",
    "catalogName": "Morning Glory Solid Pre-Tied Tie",
    "catalogNumber": "911942MGL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287180_visualizer-solid-MGL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633146_layflat-solid-MGL-morning_glory-long_tie-181115164137.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2676,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Olive Pre-Tied Striped Tie",
    "catalogNumber": "912403OLV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-OLV-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-OLV-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1822,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Nude",
    "type": "Tie",
    "catalogName": "Nude Solid Pre-Tied Tie",
    "catalogNumber": "911666NUD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641764_visualizer_tie_full-solid-NUD-nude-long_tie-181119075149.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633171_layflat-solid-NUD-nude-long_tie-181115161535.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2311,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Morning Glory",
    "type": "Tie",
    "catalogName": "Morning Glory Pre-Tied Bow Tie",
    "catalogNumber": "912155MGL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559833969_visualizer_tie_no_strap-solid-MGL-morning_glory-bow_tie-190313015142-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559833942_layflat-solid-MGL-morning_glory-bow_tie-190312175836.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2675,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Midas Gold Pre-Tied Striped Tie",
    "catalogNumber": "912400MGO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-MGO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-MGO-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2667,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Kelly Green Pre-Tied Bow Tie",
    "catalogNumber": "912146KGR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834023_visualizer_tie_no_strap-solid-KGN-kelly_green-bow_tie-190313014554-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834013_layflat-solid-KGN-kelly_green-bow_tie-190312170424.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2674,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Persimmon Pre-Tied Striped Tie",
    "catalogNumber": "912397PER",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-PER-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-PER-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2298,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Lime",
    "type": "Tie",
    "catalogName": "Lime Pre-Tied Bow Tie",
    "catalogNumber": "912142LIM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834078_visualizer_tie_no_strap-solid-LIM-lime-bow_tie-190313014729-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834069_layflat-solid-LIM-lime-bow_tie-190312171912.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2292,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Juniper/Hunter",
    "type": "Tie",
    "catalogName": "Hunter Pre-Tied Bow Tie",
    "catalogNumber": "912136HUN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834113_visualizer_tie_no_strap-solid-HUN-juniper-hunter-bow_tie-190313015110-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834107_layflat-solid-HUN-juniper-hunter-bow_tie-190312175340.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2673,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Jade Pre-Tied Striped Tie",
    "catalogNumber": "912394JDE",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-JDE-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-JDE-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2672,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Sapphire Pre-Tied Striped Tie",
    "catalogNumber": "912391SAP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-SAP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-SAP-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2288,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Fuchsia",
    "type": "Tie",
    "catalogName": "Fuchsia Pre-Tied Bow Tie",
    "catalogNumber": "912131FCH",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834332_visualizer_tie_no_strap-solid-FCH-fuchsia-bow_tie-190313014848-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834321_layflat-solid-FCH-fuchsia-bow_tie-190312173131.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2671,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Petal Pink Pre-Tied Striped Tie",
    "catalogNumber": "912388PTP",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-PTP-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-PTP-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2273,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Sapphire",
    "type": "Tie",
    "catalogName": "Sapphire Pre-Tied Bow Tie",
    "catalogNumber": "912117SAP",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559843878_layflat-solid-SAP-sapphire-bow_tie-190312172139.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523287200_visualizer-solid-SAP-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2670,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Regency Striped Pre-Tied Tie",
    "catalogNumber": "912385REG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-REG-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-REG-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1663,
    "unitCost": 6.4,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Steel Blue",
    "type": "Tie",
    "catalogName": "Steel Blue Pre-Tied Tie",
    "catalogNumber": "911507STB",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286845_911507STB-tie-0493.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286845_911507STB_Solid_Long_PT_Steel_Blue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1656,
    "unitCost": 6.4,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Chianti",
    "type": "Tie",
    "catalogName": "Apple Pre-Tied Tie",
    "catalogNumber": "911500APL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624032_20181009-150631-911500CHI_Solid_Long_PT_Apple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286839_911500CHI-tie-0493.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1668,
    "unitCost": 4,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Gold",
    "type": "Tie",
    "catalogName": "Gold Pre-tied Bow Tie",
    "catalogNumber": "911512GLD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286844_911512GLD-visualier-tie-bow-0447.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1523286843_911512GLD_Solid_BowTie_PT_Gold.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1670,
    "unitCost": 4,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Steel Blue",
    "type": "Tie",
    "catalogName": "Steel Blue Pre-Tied Bow Tie",
    "catalogNumber": "911514STB",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286847_911514STB-visualizer-tie-bow-0447.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1523286847_911514STB_Solid_BowTie_PT_Steel_Blue.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1666,
    "unitCost": 4,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Chianti",
    "type": "Tie",
    "catalogName": "Apple Pre-Tied Bow Tie",
    "catalogNumber": "911510APL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286841_911510CHI-visualizer-tie-bow-0447.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1523286839_911510CHI_Solid_BowTie_PT_Apple.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2712,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Chocolate Pre-Tied Tie",
    "catalogNumber": "911687CHO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1525727318_layflat-solid-CHO-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1525727287_visualizer-solid-CHO-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2251,
    "unitCost": 3.65,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Sunbeam",
    "type": "Tie",
    "catalogName": "Sunbeam Pre-Tied Bow Tie",
    "catalogNumber": "912095SUN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1559834464_visualizer_tie_no_strap-solid-SUN-sunbeam-bow_tie-190313014538-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1559834455_layflat-solid-SUN-sunbeam-bow_tie-190312170156.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2669,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Aqua Marine Pre-Tie Striped Tie",
    "catalogNumber": "912382AQM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-AQM-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-AQM-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1768,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Ferrari Red",
    "type": "Tie",
    "catalogName": "Ferrari Red Solid Pre-Tied Tie",
    "catalogNumber": "911612FRD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287282_visualizer-solid-FRD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633207_layflat-solid-FRD-ferrari_red-long_tie-181115164320.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1798,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Blue Ice",
    "type": "Tie",
    "catalogName": "Blue Ice Solid Pre-Tied Tie",
    "catalogNumber": "911642BIC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641919_visualizer_tie_full-solid-BIC-blue_ice-long_tie-181119075257.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633248_layflat-solid-BIC-blue_ice-long_tie-181115162604.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1801,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Ballet",
    "type": "Tie",
    "catalogName": "Ballet Solid Pre-Tied Tie",
    "catalogNumber": "911645BAL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287153_visualizer-solid-BAL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633280_layflat-solid-BAL-ballet-long_tie-181115152343.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1807,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Purple",
    "type": "Tie",
    "catalogName": "Purple Solid Pre-Tied Tie",
    "catalogNumber": "911651PUR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1542641991_visualizer_tie_full-solid-PUR-purple-long_tie-181119074417.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633319_layflat-solid-PUR-purple-long_tie-181115150627.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1810,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Persian Plum",
    "type": "Tie",
    "catalogName": "Persian Plum Solid Pre-Tied Tie",
    "catalogNumber": "911654PPL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287155_visualizer-solid-PPL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633362_layflat-solid-PPL-persian_plum-long_tie-181115160147.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1816,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Bright Fuchsia",
    "type": "Tie",
    "catalogName": "Bright Fuchsia Solid Pre-Tied Tie",
    "catalogNumber": "911660BFU",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287157_visualizer-solid-BFU-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633399_layflat-solid-BFU-bright_fuchsia-long_tie-181115163115.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1819,
    "unitCost": 5.75,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, First Blush",
    "type": "Tie",
    "catalogName": "First Blush Solid Pre-Tied Tie",
    "catalogNumber": "911663FBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287157_visualizer-solid-FBL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1542633434_layflat-solid-FBL-first_blush-long_tie-181115160003.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2689,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Bubble Gum Pre-Tied Striped Tie",
    "catalogNumber": "912442BGM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-BGM-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-BGM-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 363,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Black",
    "type": "Tie",
    "catalogName": "Black Paisley Pre-Tied Tie",
    "catalogNumber": "910290BLK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539608046_20181009-150631-910290BLK_Paisley_Long_PT_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286670_910290BLK-visualizer-tie-full-0508.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 387,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, White",
    "type": "Tie",
    "catalogName": "White Pre-Tied Tie",
    "catalogNumber": "910314WHT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618730_20181009-150631-910314WHT_Solid_Long_PT_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286677_910314WHT-visualizer-tie-full-0490.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 372,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, White",
    "type": "Tie",
    "catalogName": "White Paisley Pre-Tied Tie",
    "catalogNumber": "910299WHT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609201_20181009-150631-910299WHT_Paisley_Long_PT_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286672_910299WHT-visualizer-tie-full-0511.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 386,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Pre-Tied Tie",
    "catalogNumber": "910313RUV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618712_20181009-150631-910313RUV_Solid_Long_PT_RubyValentina.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286677_910313RUV-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 371,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Paisley Pre-Tied Tie",
    "catalogNumber": "910298RUV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609169_20181009-150631-910298RUV_Paisley_Long_PT_RubyValentina.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286672_910298RUV-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 377,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Pre-Tied Tie",
    "catalogNumber": "910304PEW",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618497_20181009-150631-910304CHA_Solid_Long_PT_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286674_910304CHA-visualizer-tie-full-0493.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 365,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Paisley Pre-Tied Tie",
    "catalogNumber": "910292PEW",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539608103_20181009-150631-910292CHA_Paisley_Long_PT_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286671_910292CHA-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1370,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Bellini",
    "type": "Tie",
    "catalogName": "Bellini Pre-Tied Tie",
    "catalogNumber": "911247BEL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623567_20181009-150631-911247BEL_PT_LongTie_Solid_Bellini.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286679_911247BEL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1374,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Pre-Tied Tie",
    "catalogNumber": "911249BIS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623621_20181009-150631-911249BIS_PT_LongTie_Solid_Biscotti.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286680_911249BIS-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1379,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Bouquet",
    "type": "Tie",
    "catalogName": "Bouquet Pre-Tied Tie",
    "catalogNumber": "911252BQT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623683_20181009-150631-911252BQT_PT_LongTie_Solid_Bouquet.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286681_911252BQT-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 380,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Lilac",
    "type": "Tie",
    "catalogName": "Lilac Pre-Tied Tie",
    "catalogNumber": "910307LIL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618576_20181009-150631-910307LIL_Solid_Long_PT_Lilac.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286675_910307LIL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1382,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Tickled",
    "type": "Tie",
    "catalogName": "Tickled Pre-Tied Tie",
    "catalogNumber": "911255TCK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623760_20181009-150631-911255TCK_PT_LongTie_Solid_Tickled.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286682_911255TCK-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 373,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Begonia",
    "type": "Tie",
    "catalogName": "Begonia Pre-Tied Tie",
    "catalogNumber": "910300BGA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609234_20181009-150631-910300BGA_Solid_Long_PT_Begonia.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286673_910300BGA-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1362,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Champagne",
    "type": "Tie",
    "catalogName": "Champagne Pre-Tied Tie",
    "catalogNumber": "911239CHM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623291_20181009-150631-911239CHM_PT_LongTie_Solid_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286677_911239CHM-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1364,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef Pre-Tied Tie",
    "catalogNumber": "911241COR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623447_20181009-150631-911241COR_PT_LongTie_Solid_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286678_911241COR-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1375,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Cornflower",
    "type": "Tie",
    "catalogName": "Cornflower Pre-Tied Tie",
    "catalogNumber": "911250CFL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623643_20181009-150631-911250CFL_PT_LongTie_Solid_Cornflower.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286680_911250CFL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1366,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy Pre-Tied Tie",
    "catalogNumber": "911243DNV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623486_20181009-150631-911243DNV_PT_LongTie_Solid_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286678_911243DNV-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1367,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalapeno Pre-Tied Tie",
    "catalogNumber": "911244JDO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623505_20181009-150631-911244JDO_PT_LongTie_Solid_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286679_911244JDO-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1381,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Watermelon",
    "type": "Tie",
    "catalogName": "Watermelon Pre-Tied Tie",
    "catalogNumber": "911254WTM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623740_20181009-150631-911254WTM_PT_LongTie_Solid_Watermelon.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286682_911254WTM-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 378,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Emerald",
    "type": "Tie",
    "catalogName": "Emerald Pre-Tied Tie",
    "catalogNumber": "910305EMD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618524_20181009-150631-910305EMD_Solid_Long_PT_Emerald.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286674_910305EMD-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1373,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Ice Blue",
    "type": "Tie",
    "catalogName": "Ice Blue Pre-Tied Tie",
    "catalogNumber": "911248IBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623586_20181009-150631-911248IBL_PT_LongTie_Solid_IceBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286680_911248IBL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 381,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Malibu",
    "type": "Tie",
    "catalogName": "Aqua-Malibu Pre-Tied Tie",
    "catalogNumber": "910308MBU",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618608_20181009-150631-910308MBU_Solid_Long_PT_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286675_910308MBU-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 379,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Pre-Tied Tie",
    "catalogNumber": "910306IVO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618550_20181009-150631-910306IVO_Solid_Long_PT_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286675_910306IVO-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 367,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Mint",
    "type": "Tie",
    "catalogName": "Mint Paisley Pre-Tied Tie",
    "catalogNumber": "910294MNT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539608149_20181009-150631-910294MNT_Paisley_Long_PT_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286671_910294MNT-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 382,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Mint",
    "type": "Tie",
    "catalogName": "Mint Pre-Tied Tie",
    "catalogNumber": "910309MNT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618629_20181009-150631-910309MNT_Solid_Long_PT_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286676_910309MNT-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1365,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Pacific",
    "type": "Tie",
    "catalogName": "Pacific Pre-Tied Tie",
    "catalogNumber": "911242PAC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623465_20181009-150631-911242PAC_PT_LongTie_Solid_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286678_911242PAC-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 368,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Paisley Pre-Tied Tie",
    "catalogNumber": "910295PLT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539608173_20181009-150631-910295PLT_Paisley_Long_PT_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286671_910295SPLT-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 383,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Pre-Tied Tie",
    "catalogNumber": "910310PLT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618650_20181009-150631-910310PLT_Solid_Long_PT_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286676_910310PLT-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1369,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Plum",
    "type": "Tie",
    "catalogName": "Plum Pre-Tied Tie",
    "catalogNumber": "911246PLM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623544_20181009-150631-911246PLM_PT_LongTie_Solid_Plum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286669_911246PLM-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1380,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Portobello",
    "type": "Tie",
    "catalogName": "Portobello Pre-Tied Tie",
    "catalogNumber": "911253PRT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623704_20181009-150631-911253PRT_PT_LongTie_Solid_Portobello.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286681_911253PRT-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 369,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Purple",
    "type": "Tie",
    "catalogName": "Viola Paisley Pre-Tied Tie",
    "catalogNumber": "910296VIO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539608198_20181009-150631-910296PRP_Paisley_Long_PT_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286671_910296PRP-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 384,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Purple",
    "type": "Tie",
    "catalogName": "Viola Pre-Tied Tie",
    "catalogNumber": "910311VIO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618672_20181009-150631-910311PRP_Solid_Long_PT_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286676_910311PRP-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 370,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Paisley Pre-Tied Tie",
    "catalogNumber": "910297HOR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609034_20181009-150631-910297RYL_Paisley_Long_PT_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286672_910297RYL-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 385,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Pre-Tied Tie",
    "catalogNumber": "910312HOR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618693_20181009-150631-910312RYL_Solid_Long_PT_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286676_910312RYL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1368,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Tiffany Blue Pre-Tied Tie",
    "catalogNumber": "911245TBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623526_20181009-150631-911245TBL_PT_LongTie_Solid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286679_911245TBL-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1378,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Toffee Gold",
    "type": "Tie",
    "catalogName": "Toffee Pre-Tied Tie",
    "catalogNumber": "911251TOF",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623665_20181009-150631-911251TOF_PT_LongTie_Solid_Toffee.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286681_911251TOF-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1363,
    "unitCost": 5.9,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Wine",
    "type": "Tie",
    "catalogName": "Sangria Pre-Tied Tie",
    "catalogNumber": "911240SGA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623429_20181009-150631-911240WNE_PT_LongTie_Solid_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286678_911240WNE-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 366,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Paisley Pre-Tied Tie",
    "catalogNumber": "910293IVO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539704264_20181009-150631-910293IVO_Paisley_Long_PT_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286670_910293IVO-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1421,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Champagne",
    "type": "Tie",
    "catalogName": "Champagne Striped Pre-Tied Tie",
    "catalogNumber": "911290CHM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623777_20181009-150631-911290CHM_PT_LongTie_Stripe_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286713_911290CHM-visualizer-tie-full-0657.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1423,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Wine",
    "type": "Tie",
    "catalogName": "Sangria Striped Pre-Tied Tie",
    "catalogNumber": "911292SGA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623813_20181009-150631-911292WNE_PT_LongTie_Stripe_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286683_911292WNE-visualizer-tie-full-0510.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1425,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef Striped Pre-Tied Tie",
    "catalogNumber": "911294COR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539700294_20181009-150631-1523286222_911294COR_PT_LongTie_Stripe_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286683_911294COR-visualizer-tie-full-0503.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1427,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Pacific",
    "type": "Tie",
    "catalogName": "Pacific Pre-Tied Striped Tie",
    "catalogNumber": "911296PAC",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624007_20181009-150631-911296PAC_PT_LongTie_Stripe_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286683_911296PAC-visualizer-tie-full-0502.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1429,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy Striped Pre-Tied Tie",
    "catalogNumber": "911298DNV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624039_20181009-150631-911298DNV_PT_LongTie_Stripe_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286684_911298DNV-visualizer-tie-full-0510.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1431,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalapeno Striped Pre-Tied Tie",
    "catalogNumber": "911300JDO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539699732_20181009-150631-911300JDO_PT_LongTie_Stripe_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286713_911300JDO-visualizer-tie-full-0635.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1433,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Tiffany Blue Pre-Tied Striped Tie",
    "catalogNumber": "911302TBL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624092_20181009-150631-911302TBL_PT_LongTie_Stripe_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286684_911302TBL-visualizer-tie-full-0487.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1435,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Black",
    "type": "Tie",
    "catalogName": "Black Striped Pre-Tied Tie",
    "catalogNumber": "911304BLK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624136_20181009-150631-911304BLK_PT_LongTie_Stripe_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286684_911304BLK-visualizer-tie-full-0500.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1437,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Striped Pre-Tied Tie",
    "catalogNumber": "911306PLT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624155_20181009-150631-911306PLT_PT_LongTie_Stripe_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286685_911306PLT-visualizer-tie-full-0488.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1439,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Striped Pre-Tied Tie",
    "catalogNumber": "911308PEW",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624178_20181009-150631-911308CHA_PT_LongTie_Stripe_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286713_911308CHA-visualizer-tie-full-0642.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1443,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Pre-Tied Striped Tie",
    "catalogNumber": "911310HOR",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624199_20181009-150631-911310RYL_PT_LongTie_Stripe_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286685_911310RYL-visualizer-tie-full-0505.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1445,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Purple",
    "type": "Tie",
    "catalogName": "Viola Striped Pre-Tied Tie",
    "catalogNumber": "911312VIO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624219_20181009-150631-911312PRP_PT_LongTie_Stripe_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286714_911312PRP-visualizer-tie-full-0653.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1447,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Striped Pre-Tied Tie",
    "catalogNumber": "911314RUV",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624237_20181009-150631-911314RUV_PT_LongTie_Stripe_Ruby.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286686_911314RUV-visualizer-tie-full-0505.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1449,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, VW/DB Mint",
    "type": "Tie",
    "catalogName": "Mint Pre-Tied Striped Tie",
    "catalogNumber": "911316MNT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624255_20181009-150631-911316VMT_PT_LongTie_Stripe_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286686_911316VMT-visualizer-tie-full-0488.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1451,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Striped Pre-Tied Tie",
    "catalogNumber": "911318IVO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624277_20181009-150631-911318IVO_PT_LongTie_Stripe_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286685_911318IVO-visualizer-tie-full-0504.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1453,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, White",
    "type": "Tie",
    "catalogName": "White Striped Pre-Tied Tie",
    "catalogNumber": "911320WHT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624296_20181009-150631-911320WHT_PT_LongTie_Stripe_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286687_911320WHT-visualizer-tie-full-0496.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1455,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Blush",
    "type": "Tie",
    "catalogName": "Petal Striped Pre-Tied Tie",
    "catalogNumber": "911322PET",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539624317_20181009-150631-911322BSH_PT_LongTie_Stripe_Blush.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286686_911322BSH-visualizer-tie-full-0498.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1457,
    "unitCost": 6.15,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Malibu",
    "type": "Tie",
    "catalogName": "Aqua-Malibu Pre-Tied Striped Tie",
    "catalogNumber": "911324MBU",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623995_20181009-150631-911324MBU_PT_LongTie_Stripe_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286714_911324MBU-visualizer-tie-full-0648.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 376,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Solid, Canary",
    "type": "Tie",
    "catalogName": "Canary Pre-Tied Tie",
    "catalogNumber": "910303CAN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539609310_20181009-150631-910303CAN_Solid_Long_PT_Canary.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286674_910303CAN-visualizer-tie-full-0495.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 364,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Back Fab, Paisley, Canary",
    "type": "Tie",
    "catalogName": "Canary Paisley Pre-Tied Tie",
    "catalogNumber": "910291CAN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539704320_20181009-150631-910291CAN_Paisley_Long_PT_Canary.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286669_910291CAN-visualizer-tie-full-0509.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 338,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Black",
    "type": "Tie",
    "catalogName": "Black Pre-Tied Bow Tie",
    "catalogNumber": "910265BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357442_20181009-150631-910265BLK_Solid_BowTie_PT_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286742_910265BLK-visualizer-tie-bow-0453.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 352,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Black",
    "type": "Tie",
    "catalogName": "Black Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910279BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358326_20181009-150631-910279BLK_Paisley_BowTie_PT_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286748_910279BLK-visualizer-tie-bow-0392.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 667,
    "unitCost": 5,
    "pattern": "Solid",
    "description": "Tie, Modern, Bow Tie, Pre Tied, Hand Made Knot, Satin, Black",
    "type": "Tie",
    "catalogName": "Black Satin Pre-Tied Bow Tie",
    "catalogNumber": "930806BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539631062_20181009-150631-930806BLK_BowTie_Laydown.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286814_930806BLK-visualizer-tie-bow-0442.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 351,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, White",
    "type": "Tie",
    "catalogName": "White Pre-Tied Bow Tie",
    "catalogNumber": "910278WHT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358077_20181009-150631-910278WHT_Solid_BowTie_PT_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286747_910278WHT-visualizer-tie-bow-0430.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 361,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, White",
    "type": "Tie",
    "catalogName": "White Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910288WHT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360153_20181009-150631-910288WHT_Paisley_BowTie_PT_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286751_910288WHT-visualizer-tie-bow-0386.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 350,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Pre-Tied Bow Tie",
    "catalogNumber": "910277RUV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358039_20181009-150631-910277RUV_Solid_BowTie_PT_RubyValentina.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286747_910277RUV-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 360,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910287RUV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360127_20181009-150631-910287RUV_Paisley_BowTie_PT_RubyValentina.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286750_910287RUV-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 341,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Pre-Tied Bow Tie",
    "catalogNumber": "910268PEW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357561_20181009-150631-910268CHA_Solid_BowTie_PT_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286743_910268CHA-visualizer-tie-bow-0447.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 354,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910281PEW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358397_20181009-150631-910281CHA_Paisley_BowTie_PT_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286749_910281CHA-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 349,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Pre-Tied Bow Tie",
    "catalogNumber": "910276HOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358007_20181009-150631-910276RYL_Solid_BowTie_PT_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286747_910276RYL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 359,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910286HOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360101_20181009-150631-910286RYL_Paisley_BowTIe_PT_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286750_910286RYL-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 345,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Malibu",
    "type": "Tie",
    "catalogName": "Aqua-Malibu Bow Tie",
    "catalogNumber": "910272MBU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357686_20181009-150631-910272MBU_Solid_BowTie_PT_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286744_910272MBU-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 669,
    "unitCost": 5,
    "pattern": "Solid",
    "description": "Tie, Modern, Windsor Tie, Self Tied, Satin, Black",
    "type": "Tie",
    "catalogName": "Black Satin Tie",
    "catalogNumber": "930804BLK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Self Tied",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539187981_20181009-150631-940807BLK_Tie6_ThinSolid_Satin_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286711_930804BLK-visualizer-tie-full-0527.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 346,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Mint",
    "type": "Tie",
    "catalogName": "Mint Pre-Tied Bow Tie",
    "catalogNumber": "910273MNT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357723_20181009-150631-910273MNT_Solid_BowTie_PT_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286744_910273MNT-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 356,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Mint",
    "type": "Tie",
    "catalogName": "Mint Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910283MNT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360007_20181009-150631-910283MNT_Paisley_BowTie_PT_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286749_910283MNT-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 342,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Emerald",
    "type": "Tie",
    "catalogName": "Emerald Pre-Tied Bow Tie",
    "catalogNumber": "910269EMD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357587_20181009-150631-910269EMD_Solid_BowTie_PT_Emerald.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286743_910269EMD-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 348,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Purple",
    "type": "Tie",
    "catalogName": "Viola Pre-Tied Bow Tie",
    "catalogNumber": "910275VIO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539695683_20181009-150631-1523288736_910274PLT_Solid_BowTie_PT_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286745_910275PRP-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 358,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Purple",
    "type": "Tie",
    "catalogName": "Viola Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910285VIO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360073_20181009-150631-910285PRP_Paisley_BowTie_PT_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286749_910285PRP-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 344,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Lilac",
    "type": "Tie",
    "catalogName": "Lilac Pre-Tied Bow Tie",
    "catalogNumber": "910271LIL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357658_20181009-150631-910271LIL_Solid_BowTie_PT_Lilac.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286744_910271LIL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 337,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Begonia",
    "type": "Tie",
    "catalogName": "Begonia Pre-Tied Bow Tie",
    "catalogNumber": "910264BGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357399_20181009-150631-910264BGA_Solid_BowTie_PT_Begonia.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286742_910264BGA-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 347,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Pre-Tied Bow Tie",
    "catalogNumber": "910274PLT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357756_20181009-150631-910274PLT_Solid_BowTie_PT_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286745_910274PLT-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 357,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910284PLT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539360042_20181009-150631-910284PLT_Paisley_BowTie_PT_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286750_910284PLT-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 343,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Pre-Tied Bow Tie",
    "catalogNumber": "910270IVO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357620_20181009-150631-910270IVO_Solid_BowTie_PT_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286744_910270IVO-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 355,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910282IVO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539359976_20181009-150631-910282IVO_Paisley_BowTie_PT_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286748_910282IVO-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 340,
    "unitCost": null,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Canary",
    "type": "Tie",
    "catalogName": "Canary Pre-Tied Bow Tie",
    "catalogNumber": "910267CAN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539357533_20181009-150631-910267CAN_Solid_BowTie_PT_Canary.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286743_910267CAN-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 353,
    "unitCost": null,
    "pattern": "Paisley",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Paisley, Canary",
    "type": "Tie",
    "catalogName": "Canary Paisley Pre-Tied Bow Tie",
    "catalogNumber": "910280CAN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539358358_20181009-150631-910280CAN_Paisley_BowTie_PT_Canary.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286748_910280CAN-visualizer-tie-bow-0384.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1120,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Champagne",
    "type": "Tie",
    "catalogName": "Champagne Pre-Tied Bow Tie",
    "catalogNumber": "911007CHM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618763_20181009-150631-911007CHM_PT_BowTie_Solid_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286751_911007CHM-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1121,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Wine",
    "type": "Tie",
    "catalogName": "Sangria Pre-Tied Bow Tie",
    "catalogNumber": "911008SGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618785_20181009-150631-911008WNE_PT_BowTie_Solid_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286752_911008WNE-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1122,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef Pre-Tied Bow Tie",
    "catalogNumber": "911009COR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618848_20181009-150631-911009COR_PT_BowTie_Solid_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286751_911009COR-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1123,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Pacific",
    "type": "Tie",
    "catalogName": "Pacific Blue Pre-Tied Bow Tie",
    "catalogNumber": "911010PAC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618874_20181009-150631-911010PAC_PT_BowTie_Solid_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286752_911010PAC-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1126,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy Pre-Tied Bow Tie",
    "catalogNumber": "911011DNV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618907_20181009-150631-911011DNV_PT_BowTie_Solid_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286752_911011DNV-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1127,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalapeno Pre-Tied Bow Tie",
    "catalogNumber": "911012JDO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613364_20181009-150631-911012JDO_PT_BowTie_Solid_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286752_911012JDO-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1128,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Tiffany Blue Pre-Tied Bow Tie",
    "catalogNumber": "911013TBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613422_20181009-150631-911013TBL_PT_BowTie_Solid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286753_911013TBL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1131,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Plum",
    "type": "Tie",
    "catalogName": "Plum Pre-Tied Bow Tie",
    "catalogNumber": "911014PLM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613466_20181009-150631-911014PLM_PT_BowTie_Solid_Plum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286753_911014PLM-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1132,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Bellini",
    "type": "Tie",
    "catalogName": "Bellini Pre-Tied Bow Tie",
    "catalogNumber": "911015BEL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613806_20181009-150631-911015BEL_PT_BowTie_Solid_Bellini.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286753_911015BEL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1133,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Ice Blue",
    "type": "Tie",
    "catalogName": "Ice Blue Pre-Tied Bow Tie",
    "catalogNumber": "911016IBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539614033_20181009-150631-911016IBL_PT_BowTie_Solid_IceBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286753_911016IBL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1134,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Pre-Tied Bow Tie",
    "catalogNumber": "911017BIS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539361889_20181009-150631-911017BIS_PT_BowTie_Solid_Biscotti.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286754_911017BIS-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1135,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Cornflower",
    "type": "Tie",
    "catalogName": "Cornflower Pre-Tied Bow Tie",
    "catalogNumber": "911018CFL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539361950_20181009-150631-911018CFL_PT_BowTie_Solid_Cornflower.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286754_911018CFL-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1136,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Toffee Gold",
    "type": "Tie",
    "catalogName": "Toffee Pre-Tied Bow Tie",
    "catalogNumber": "911019TOF",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539612900_20181009-150631-911019TOF_PT_BowTie_Solid_Toffee.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286755_911019TOF-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1137,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Bouquet",
    "type": "Tie",
    "catalogName": "Bouquet Pre-Tied Bow Tie",
    "catalogNumber": "911020BQT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539696520_20181009-150631-911020BQT_PT_BowTie_Solid_Bouquet.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286754_911020BQT-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1138,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Portobello",
    "type": "Tie",
    "catalogName": "Portobello Pre-Tied Bow Tie",
    "catalogNumber": "911021PRT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539697550_20181009-150631-911021PRT_PT_BowTie_Solid_Portobello.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1539697329_911021PRT-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1139,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Watermelon",
    "type": "Tie",
    "catalogName": "Watermelon Pre-Tied Bow Tie",
    "catalogNumber": "911022WTM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613132_20181009-150631-911022WTM_PT_BowTie_Solid_Watermelon.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286756_911022WTM-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1140,
    "unitCost": 3.8,
    "pattern": "Solid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Solid, Tickled",
    "type": "Tie",
    "catalogName": "Tickled Pre-Tied Bow Tie",
    "catalogNumber": "911023TCK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613183_20181009-150631-911023TCK_PT_BowTie_Solid_Tickled.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286756_911023TCK-visualizer-tie-bow-0469.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1165,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Champagne",
    "type": "Tie",
    "catalogName": "Champagne Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911046CHM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539613292_20181009-150631-911046CHM_PT_BowTie_Plaid_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286755_911046CHM-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1166,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Wine",
    "type": "Tie",
    "catalogName": "Sangria Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911047SGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539614361_20181009-150631-911047WNE_PT_BowTie_Plaid_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286755_911047WNE-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1167,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911048COR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539614576_20181009-150631-911048COR_PT_BowTie_Plaid_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286757_911048COR-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1168,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Pacific",
    "type": "Tie",
    "catalogName": "Pacific Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911049PAC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539614614_20181009-150631-911049PAC_PT_BowTie_Plaid_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286757_911049PAC-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1169,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911050DNV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539614869_20181009-150631-911050DNV_PT_BowTie_Plaid_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286756_911050DNV-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1170,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalapeno Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911051JDO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618939_20181009-150631-911051JDO_PT_BowTie_Plaid_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286756_911051JDO-visualizer-tie-bow-0401.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1171,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Tiffany Blue Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911052TBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618959_20181009-150631-911052TBL_PT_BowTie_Plaid_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286757_911052TBL-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1172,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Plum",
    "type": "Tie",
    "catalogName": "Plum Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911053PLM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618979_20181009-150631-911053PLM_PT_BowTie_Plaid_Plum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286758_911053PLM-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1173,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Bellini",
    "type": "Tie",
    "catalogName": "Bellini Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911054BEL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539618998_20181009-150631-911054BEL_PT_BowTie_Plaid_Bellini.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286758_911054BEL-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1174,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Ice Blue",
    "type": "Tie",
    "catalogName": "Ice Blue Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911055IBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619029_20181009-150631-911055IBL_PT_BowTie_Plaid_IceBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286758_911055IBL-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1175,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911056BIS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619058_20181009-150631-911056BIS_PT_BowTie_Plaid_Biscotti.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286759_911056BIS-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1176,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Black",
    "type": "Tie",
    "catalogName": "Black Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911057BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619082_20181009-150631-911057BLK_PT_BowTie_Plaid_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286758_911057BLK-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1177,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911058PLT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619112_20181009-150631-911058PLT_PT_BowTie_Plaid_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286759_911058PLT-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1178,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911059PEW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619132_20181009-150631-911059CHA_PT_BowTie_Plaid_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286759_911059CHA-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1179,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911060HOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619151_20181009-150631-911060RYL_PT_BowTie_Plaid_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286760_911060RYL-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1180,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Purple",
    "type": "Tie",
    "catalogName": "Viola Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911061VIO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619173_20181009-150631-911061PRP_PT_BowTie_Plaid_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286760_911061PRP-visualizer-tie-bow-0404.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1181,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911062RUV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619653_20181009-150631-911062RUV_PT_BowTie_Plaid_Ruby.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286760_911062RUV-visualizer-tie-bow-0407.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1182,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, VW/DB Mint",
    "type": "Tie",
    "catalogName": "Mint Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911063MNT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619673_20181009-150631-911063VMT_PT_BowTie_Plaid_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286761_911063VMT-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1183,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911064IVO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619691_20181009-150631-911064IVO_PT_BowTie_Plaid_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286761_911064IVO-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1184,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, White",
    "type": "Tie",
    "catalogName": "White Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911065WHT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619711_20181009-150631-911065WHT_PT_BowTie_Plaid_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286760_911065WHT-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1185,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Blush",
    "type": "Tie",
    "catalogName": "Petal Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911066PET",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619734_20181009-150631-911066BSH_PT_BowTie_Plaid_Blush.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286761_911066BSH-visualizer-tie-bow-0409.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1186,
    "unitCost": 4.05,
    "pattern": "Plaid",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Plaid, Malibu",
    "type": "Tie",
    "catalogName": "Aqua-Malibu Plaid Pre-Tied Bow Tie",
    "catalogNumber": "911067MBU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619752_20181009-150631-911067MBU_PT_BowTie_Plaid_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286761_911067MBU-visualizer-tie-bow-0401.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1221,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Champagne",
    "type": "Tie",
    "catalogName": "Champagne Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911100CHM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619771_20181009-150631-911100CHM_PT_BowTie_ZigZag_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286767_911119CHM-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1222,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Wine",
    "type": "Tie",
    "catalogName": "Sangria Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911101SGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619791_20181009-150631-911101WNE_PT_BowTie_ZigZag_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286762_911101WNE-visualizer-tie-bow-0595.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1223,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911102COR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619810_20181009-150631-911102COR_PT_BowTie_ZigZag_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286762_911102COR-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1224,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Pacific",
    "type": "Tie",
    "catalogName": "Pacific Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911103PAC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619829_20181009-150631-911103PAC_PT_BowTie_ZigZag_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286763_911103PAC-visualizer-tie-bow-0594.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1225,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911104DNV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619847_20181009-150631-911104DNV_PT_BowTie_ZigZag_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286763_911104DNV-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1226,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalapeno Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911105JDO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619867_20181009-150631-911105JDO_PT_BowTie_ZigZag_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286763_911105JDO-visualizer-tie-bow-0600.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1227,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Pre-Tied Tiffany Blue Zig Zag Bow Tie",
    "catalogNumber": "911106TBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619889_20181009-150631-911106TBL_PT_BowTie_ZigZag_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286763_911106TBL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1228,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Plum",
    "type": "Tie",
    "catalogName": "Plum Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911107PLM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619909_20181009-150631-911107PLM_PT_BowTie_ZigZag_Plum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286764_911107PLM-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1229,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Bellini",
    "type": "Tie",
    "catalogName": "Bellini Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911108BEL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619945_20181009-150631-911108BEL_PT_BowTie_ZigZag_Bellini.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286764_911108BEL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1230,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Ice Blue",
    "type": "Tie",
    "catalogName": "Ice Blue Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911109IBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539619963_20181009-150631-911109IBL_PT_BowTie_ZigZag_IceBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286764_911109IBL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1231,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911110BIS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620046_20181009-150631-911110BIS_PT_BowTie_ZigZag_Biscotti.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286765_911110BIS-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1232,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Cornflower",
    "type": "Tie",
    "catalogName": "Cornflower Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911111CFL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620190_20181009-150631-911111CFL_PT_BowTie_ZigZag_Cornflower.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286765_911111CFL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1233,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Toffee Gold",
    "type": "Tie",
    "catalogName": "Toffee Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911112TOF",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620208_20181009-150631-911112TOF_PT_BowTie_ZigZag_Toffee.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286765_911112TOF-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1234,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Bouquet",
    "type": "Tie",
    "catalogName": "Bouquet Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911113BQT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620238_20181009-150631-911113BQT_PT_BowTie_ZigZag_Bouquet.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286765_911113BQT-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1235,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Portobello",
    "type": "Tie",
    "catalogName": "Portobello Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911114PRT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620256_20181009-150631-911114PRT_PT_BowTie_ZigZag_Portobello.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286766_911114PRT-visualizer-tie-bow-0599.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1236,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Watermelon",
    "type": "Tie",
    "catalogName": "Watermelon Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911115WTM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620274_20181009-150631-911115WTM_PT_BowTie_ZigZag_Watermelon.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286766_911115WTM-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1237,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Tickled",
    "type": "Tie",
    "catalogName": "Tickled Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911116TCK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539698890_20181009-150631-911116TCK_PT_BowTie_ZigZag_Tickled.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1539698314_20181009-150631-2017-04-24-tie-visualizer-alignment.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1239,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Platinum",
    "type": "Tie",
    "catalogName": "Platinum Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911118PLT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620668_20181009-150631-911118PLT_PT_BowTie_ZigZag_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286767_911118PLT-visualizer-tie-bow-0459.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1240,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911119PEW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620704_20181009-150631-911119CHA_PT_BowTie_ZigZag_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286767_911119CHA-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1241,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911120HOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539620723_20181009-150631-911120RYL_PT_BowTie_ZigZag_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286768_911120RYL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1242,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Purple",
    "type": "Tie",
    "catalogName": "Viola Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911121VIO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621494_20181009-150631-911121PRP_PT_BowTie_ZigZag_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286768_911121PRP-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1245,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911122RUV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621515_20181009-150631-911122RUV_PT_BowTie_ZigZag_RubyValentina.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286768_911122RUV-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1246,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, VW/DB Mint",
    "type": "Tie",
    "catalogName": "Mint Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911123MNT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621533_20181009-150631-911123VMT_PT_BowTie_ZigZag_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286769_911123VMT-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1247,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Canary",
    "type": "Tie",
    "catalogName": "Canary Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911124CAN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621558_20181009-150631-911124CAN_PT_BowTie_ZigZag_Canary.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286768_911124CAN-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1248,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Ivory",
    "type": "Tie",
    "catalogName": "Ivory Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911125IVO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621704_20181009-150631-911125IVO_PT_BowTie_ZigZag_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286769_911125IVO-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1249,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, White",
    "type": "Tie",
    "catalogName": "White Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911126WHT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621721_20181009-150631-911126WHT_PT_BowTie_ZigZag_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286769_911126WHT-visualizer-tie-bow-0471.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1250,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Lilac",
    "type": "Tie",
    "catalogName": "Lilac Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911127LIL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621748_20181009-150631-911127LIL_PT_BowTie_ZigZag_Lilac.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286770_911127LIL-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1251,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Blush",
    "type": "Tie",
    "catalogName": "Petal Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911128PET",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539621773_20181009-150631-911128BSH_PT_BowTie_ZigZag_Blush.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286770_911128BSH-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1252,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Malibu",
    "type": "Tie",
    "catalogName": "Aqua Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911129MBU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622372_20181009-150631-911129MBU_PT_BowTie_ZigZag_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286770_911129MBU-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1253,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Begonia",
    "type": "Tie",
    "catalogName": "Begonia Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911130BGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622403_20181009-150631-911130BGA_PT_BowTie_ZigZag_Begonia.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286771_911130BGA-visualizer-tie-bow-0460.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1254,
    "unitCost": 4.05,
    "pattern": "Zig Zag",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Zig-Zag, Emerald",
    "type": "Tie",
    "catalogName": "Emerald Zig Zag Pre-Tied Bow Tie",
    "catalogNumber": "911131EMD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622423_20181009-150631-911131EMD_PT_BowTie_ZigZag_Emerald.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286771_911131EMD-visualizer-tie-bow-0595.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1273,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Champagne",
    "type": "Tie",
    "catalogName": "Champagne and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911150CHM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622441_20181009-150631-911150CHM_PT_BowTie_PinDot_Champagne.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286771_911150CHM-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1274,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Wine",
    "type": "Tie",
    "catalogName": "Sangria and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911151SGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622459_20181009-150631-911151WNE_PT_BowTie_PinDot_Wine.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286771_911151WNE-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1275,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Coral Reef",
    "type": "Tie",
    "catalogName": "Coral Reef and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911152COR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622497_20181009-150631-911152COR_PT_BowTie_PinDot_CoralReef.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286772_911152COR-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1276,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Pacific",
    "type": "Tie",
    "catalogName": "Pacific and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911153PAC",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622520_20181009-150631-911153PAC_PT_BowTie_PinDot_Pacific.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286772_911153PAC-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1277,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Dark Navy",
    "type": "Tie",
    "catalogName": "Dark Navy and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911154DNV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622953_20181009-150631-911154DNV_PT_BowTie_PinDot_DarkNavy.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286772_911154DNV-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1278,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Jalapeno Dark Orange",
    "type": "Tie",
    "catalogName": "Jalepeno and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911155JDO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539622982_20181009-150631-911155JDO_PT_BowTie_PinDot_Jalapeno.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286772_911155JDO-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1279,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Tiffany Blue",
    "type": "Tie",
    "catalogName": "Tiffany Blue and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911156TBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623008_20181009-150631-911156TBL_PT_BowTie_PinDot_TffanyBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286773_911156TBL-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1280,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Black",
    "type": "Tie",
    "catalogName": "Black and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911157BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623027_20181009-150631-911157BLK_PT_BowTie_PinDot_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286773_911157BLK-visualizer-tie-bow-0444.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1281,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Platinum",
    "type": "Tie",
    "catalogName": "Platinum and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911158PLT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623045_20181009-150631-911158PLT_PT_BowTie_PinDot_Platinum.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286773_911158PLT-visualizer-tie-bow-0419.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1282,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Charcoal",
    "type": "Tie",
    "catalogName": "Pewter and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911159PEW",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623065_20181009-150631-911159CHA_PT_BowTie_PinDot_Charcoal.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286774_911159CHA-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1283,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Royal Blue",
    "type": "Tie",
    "catalogName": "Horizon and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911160HOR",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623106_20181009-150631-911160RYL_PT_BowTie_PinDot_RoyalBlue.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286774_911160RYL-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1284,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Purple",
    "type": "Tie",
    "catalogName": "Viola and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911161VIO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623124_20181009-150631-911161PRP_PT_BowTie_PinDot_Purple.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286774_911161PRP-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1285,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Ruby/Valentina",
    "type": "Tie",
    "catalogName": "Ruby Valentino and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911162RUV",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623145_20181009-150631-911162RUV_PT_BowTie_PinDot_Ruby.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286775_911162RUV-visualizer-tie-bow-0454.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1286,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, VW/DB Mint",
    "type": "Tie",
    "catalogName": "Mint and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911163MNT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623182_20181009-150631-911163VMT_PT_BowTie_PinDot_Mint.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286775_911163VMT-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1287,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Ivory",
    "type": "Tie",
    "catalogName": "Ivory and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911164IVO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623203_20181009-150631-911164IVO_PT_BowTie_PinDot_Ivory.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286775_911164IVO-visualizer-tie-bow-0422.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1288,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, White",
    "type": "Tie",
    "catalogName": "White and Silver Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911165WHT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623227_20181009-150631-911165WHT_PT_BowTie_PinDot_White.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286776_911165WHT-visualizer-tie-bow-0605.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1289,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Blush",
    "type": "Tie",
    "catalogName": "Petal and White Pin Dot Pre-tied Bow Tie",
    "catalogNumber": "911166PET",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623255_20181009-150631-911166BSH_PT_BowTie_PinDot_Blush.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286776_911166BSH-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1290,
    "unitCost": 4.05,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Malibu",
    "type": "Tie",
    "catalogName": "Aqua-Malibu and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "911167MBU",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539623273_20181009-150631-911167MBU_PT_BowTie_PinDot_Malibu.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286776_911167MBU-visualizer-tie-bow-0425.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 478,
    "unitCost": 7.75,
    "pattern": "Micro Square",
    "description": "Tie, Modern, Windsor Tie, Self Tied, 100% Silk, Textured, Solid, Navy",
    "type": "Tie",
    "catalogName": "Navy Textured Microsquare Tie",
    "catalogNumber": "930478NVY",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Self Tied",
    "attributeTertiary": "100% Silk",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523286844_930478NVY-tie-0543.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523286844_930478NVY_Tie_TexSolid_Long_Navy.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 668,
    "unitCost": 5,
    "pattern": "Solid",
    "description": "Tie, Modern, Bow Tie, Self Tied, Satin, Black",
    "type": "Tie",
    "catalogName": "Black Bow Tie",
    "catalogNumber": "930805BLK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Self Tied",
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1539631042_20181009-150631-930805BLK_ST_BowTie_TrendSatin_Black.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1523286814_930806BLK-visualizer-tie-bow-0442.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 1719,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Persian Plum",
    "type": "Pocket Square",
    "catalogName": "Persian Plum Pocket Square",
    "catalogNumber": "611563PPL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-PPL-persian_plum-pocket_square-181030165529.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PPL-persian_plum-pocket_square-181101163619.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 2831,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Gem Pocket Square",
    "catalogNumber": "613105GEM",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814164_visualizer_pocket_square-solid-GEM-gem-pocket_square-200117011725-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579814150_layflat-solid-GEM-gem-pocket_square-200117002525.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2432,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Begonia",
    "type": "Tie",
    "catalogName": "Begonia Striped Pre-Tied Tie",
    "catalogNumber": "912276BGA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265652_visualizer-stripes-BGA-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588265632_layflat-stripes-BGA-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2429,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Emerald",
    "type": "Tie",
    "catalogName": "Emerald Striped Pre-Tied Tie",
    "catalogNumber": "912273EMD",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265517_layflat-stripes-EMD-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588265488_visualizer-stripes-EMD-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2821,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Sterling Pre-Tied Bow Tie",
    "catalogNumber": "913115STG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814553_visualizer_tie_no_strap-solid-STG-sterling-bow_tie-200117015027-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579814542_layflat-solid-STG-sterling-bow_tie-200116174404.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2820,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Sedona Pre-Tied Bow Tie",
    "catalogNumber": "913113SDA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814417_visualizer_tie_no_strap-solid-SDA-sedona-bow_tie-200117015008-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579814403_layflat-solid-SDA-sedona-bow_tie-200116174109.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2462,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Steel Blue",
    "type": "Tie",
    "catalogName": "Steel Blue Striped Pre-Tied Tie",
    "catalogNumber": "912306STB",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588266348_visualizer-stripes-STB-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588266333_layflat-stripes-STB-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2423,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Canary",
    "type": "Tie",
    "catalogName": "Canary Striped Pre-Tied Tie",
    "catalogNumber": "912267CAN",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265215_layflat-stripes-CAN-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588265188_visualizer-stripes-CAN-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2833,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Sterling Pocket Square",
    "catalogNumber": "613107STG",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814577_visualizer_pocket_square-solid-STG-sterling-pocket_square-200117011814-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579814566_layflat-solid-STG-sterling-pocket_square-200117002719.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2426,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Cornflower",
    "type": "Tie",
    "catalogName": "Cornflower Striped Pre-Tied Tie",
    "catalogNumber": "912270CFL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265393_visualizer-stripes-CFL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588265370_layflat-stripes-CFL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2834,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Dusty Sage Pocket Square",
    "catalogNumber": "613108DSG",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813982_visualizer_pocket_square-solid-DSG-dusty_sage-pocket_square-200117011838-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579813955_layflat-solid-DSG-dusty_sage-pocket_square-200117002816.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2417,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Bellini",
    "type": "Tie",
    "catalogName": "Bellini Striped Pre-Tied Tie",
    "catalogNumber": "912261BEL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265082_visualizer-stripes-BEL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588264999_layflat-stripes-BEL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2835,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Mist Pocket Square",
    "catalogNumber": "613109MST",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814313_visualizer_pocket_square-solid-MST-mist-pocket_square-200117011749-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579814295_layflat-solid-MST-mist-pocket_square-200117002622.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2653,
    "unitCost": null,
    "pattern": "Striped",
    "description": null,
    "type": "Tie",
    "catalogName": "Pool Pre-Tied Striped Tie",
    "catalogNumber": "912352POL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer-stripes-POL-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/layflat-stripes-POL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2836,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Desert Coral Pocket Square",
    "catalogNumber": "613110DCO",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813722_visualizer_pocket_square-solid-DCO-desert_coral-pocket_square-200117011638-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579813706_layflat-solid-DCO-desert_coral-pocket_square-200117002330.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2837,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Desert Coral",
    "catalogNumber": "P22110DCO",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813746_pdp_hero-solid-DCO-desert_coral-swatch-200116142413.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2800,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Mist Pre-Tied Tie",
    "catalogNumber": "913118MST",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814235_visualizer_tie_full-solid-MST-mist-long_tie-200117020909-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579814224_layflat-solid-MST-mist-long_tie-200116201709.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2838,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Dusty Sage",
    "catalogNumber": "P22111DSG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814005_pdp_hero-solid-DSG-dusty_sage-swatch-200116142421.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2839,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Gem",
    "catalogNumber": "P22112GEM",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814185_pdp_hero-solid-GEM-gem-swatch-200116142416.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2840,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Mist",
    "catalogNumber": "P22113MST",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814344_pdp_hero-solid-MST-mist-swatch-200116142418.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2798,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Dusty Sage Pre-Tied Tie",
    "catalogNumber": "913116DSG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813830_visualizer_tie_full-solid-DSG-dusty_sage-long_tie-200117020930-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579813799_layflat-solid-DSG-dusty_sage-long_tie-200116202002.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2841,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Sedona",
    "catalogNumber": "P22114SDA",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814466_pdp_hero-solid-SDA-sedona-swatch-200116142415.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2444,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Striped Pre-Tied Tie",
    "catalogNumber": "912288BIS",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265987_layflat-stripes-BIS-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588265969_visualizer-stripes-BIS-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2445,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Portobello",
    "type": "Tie",
    "catalogName": "Portobello Striped  Pre-Tied Tie",
    "catalogNumber": "912294PRT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588266039_visualizer-stripes-PRT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588266019_layflat-stripes-PRT-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2214,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Steel Blue",
    "type": "Tie",
    "catalogName": "Steel Blue and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912058STB",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588264929_layflat-pin_dot-STB-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588264907_visualizer-pin_dot-STB-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2212,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Bouquet",
    "type": "Tie",
    "catalogName": "Bouquet and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912056BQT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588264772_layflat-pin_dot-BQT-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588264741_visualizer-pin_dot-BQT-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2210,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Toffee Gold",
    "type": "Tie",
    "catalogName": "Toffee Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912054TOF",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588264434_visualizer-pin_dot-TOF-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588264415_layflat-pin_dot-TOF-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2208,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Gold",
    "type": "Tie",
    "catalogName": "Gold Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912052GLD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263934_layflat-pin_dot-GLD-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588263905_visualizer-pin_dot-GLD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2206,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Portobello",
    "type": "Tie",
    "catalogName": "Portobello Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912050PRT",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263844_visualizer-pin_dot-PRT-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588263804_layflat-pin_dot-PRT-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2204,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Tickled",
    "type": "Tie",
    "catalogName": "Tickled and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912048TCK",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263761_layflat-pin_dot-TCK-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588263735_visualizer-pin_dot-TCK-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2202,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Biscotti",
    "type": "Tie",
    "catalogName": "Biscotti Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912046BIS",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263673_visualizer-pin_dot-BIS-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588263656_layflat-pin_dot-BIS-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2797,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Sterling Pre-Tied Tie",
    "catalogNumber": "913114STG",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814523_visualizer_tie_full-solid-STG-sterling-long_tie-200117020920-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579814507_layflat-solid-STG-sterling-long_tie-200116201837.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2200,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Lilac",
    "type": "Tie",
    "catalogName": "Lilac and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912044LIL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263584_layflat-pin_dot-LIL-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588263560_visualizer-pin_dot-LIL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2196,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Watermelon",
    "type": "Tie",
    "catalogName": "Watermelon and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912040WTM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262924_visualizer-pin_dot-WTM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588262901_layflat-pin_dot-WTM-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2194,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Begonia",
    "type": "Tie",
    "catalogName": "Begonia and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912038BGA",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262778_layflat-pin_dot-BGA-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588262761_visualizer-pin_dot-BGA-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2198,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Chianti",
    "type": "Tie",
    "catalogName": "Apple Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912042APL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588263407_visualizer-pin_dot-CHI-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588263383_layflat-pin_dot-CHI-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2191,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Emerald",
    "type": "Tie",
    "catalogName": "Emerald Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912036EMD",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262660_visualizer-pin_dot-EMD-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588262631_layflat-pin_dot-EMD-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2189,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Cornflower",
    "type": "Tie",
    "catalogName": "Cornflower and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912034CFL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262501_visualizer-pin_dot-CFL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588262462_layflat-pin_dot-CFL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2187,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Canary",
    "type": "Tie",
    "catalogName": "Canary Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912032CAN",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262354_layflat-pin_dot-CAN-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588262323_visualizer-pin_dot-CAN-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2796,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Sedona Pre-Tied Tie",
    "catalogNumber": "913112SDA",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814385_visualizer_tie_full-solid-SDA-sedona-long_tie-200117020847-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579814373_layflat-solid-SDA-sedona-long_tie-200116201415.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2186,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Ice Blue",
    "type": "Tie",
    "catalogName": "Ice Blue Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912030IBL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588262117_visualizer-pin_dot-IBL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588262082_layflat-pin_dot-IBL-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2184,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Bellini",
    "type": "Tie",
    "catalogName": "Bellini and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912028BEL",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588261961_layflat-pin_dot-BEL-bow_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588261920_visualizer-pin_dot-BEL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      }
    ]
  },
  {
    "id": 2179,
    "unitCost": 3.9,
    "pattern": "Dots",
    "description": "Tie, Mens, Bow Tie, Pre Tied, Hand Made Knot, Pin Dot, Plum",
    "type": "Tie",
    "catalogName": "Plum and White Pin Dot Pre-Tied Bow Tie",
    "catalogNumber": "912023PLM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588261752_visualizer-pin_dot-PLM-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1588261640_layflat-pin_dot-PLM-bow_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2801,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Desert Coral Pre-Tied Tie",
    "catalogNumber": "913120DCO",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813603_visualizer_tie_full-solid-DCO-desert_coral-long_tie-200117020836-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579813583_layflat-solid-DCO-desert_coral-long_tie-200116201247.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2795,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Gem Pre-Tied Tie",
    "catalogNumber": "913110GEM",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814081_visualizer_tie_full-solid-GEM-gem-long_tie-200117020858-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1579814070_layflat-solid-GEM-gem-long_tie-200116201541.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2819,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Gem Pre-Tied Bow Tie",
    "catalogNumber": "913111GEM",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814131_visualizer_tie_no_strap-solid-GEM-gem-bow_tie-200117015014-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579814106_layflat-solid-GEM-gem-bow_tie-200116174207.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2822,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Dusty Sage Pre-Tied Bow Tie",
    "catalogNumber": "913117DSG",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813878_visualizer_tie_no_strap-solid-DSG-dusty_sage-bow_tie-200117015033-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579813848_layflat-solid-DSG-dusty_sage-bow_tie-200116174502.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2823,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Mist Pre-Tied Bow Tie",
    "catalogNumber": "913119MST",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814276_visualizer_tie_no_strap-solid-MST-mist-bow_tie-200117015021-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579814257_layflat-solid-MST-mist-bow_tie-200116174306.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2438,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Apple",
    "type": "Tie",
    "catalogName": "Apple Striped Pre-Tied Tie",
    "catalogNumber": "912282APL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265761_layflat-stripes-CHI-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588265742_visualizer-stripes-CHI-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2824,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Desert Coral Pre-Tied Bow Tie",
    "catalogNumber": "913121DCO",
    "costToCustomer": 10,
    "attributePrimary": "Bow Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579813680_visualizer_tie_no_strap-solid-DCO-desert_coral-bow_tie-200117015002-fs8.png",
        "label": "VISUALIZER_TIE_NO_STRAP"
      },
      {
        "url": "https://gentux.imgix.net/1579813653_layflat-solid-DCO-desert_coral-bow_tie-200116174011.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2832,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Sedona Pocket Square",
    "catalogNumber": "613106SDA",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814447_visualizer_pocket_square-solid-SDA-sedona-pocket_square-200117011701-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1579814437_layflat-solid-SDA-sedona-pocket_square-200117002427.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2842,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Swatch (accessory)",
    "catalogName": "Sterling",
    "catalogNumber": "P22115STG",
    "costToCustomer": 0,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "White",
    "media": [
      {
        "url": "https://gentux.imgix.net/1579814592_pdp_hero-solid-STG-sterling-swatch-200116142419.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2717,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Saffron Pocket Square",
    "catalogNumber": "613102SAF",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314699_visualizer_pocket_square-solid-SAF-saffron-pocket_square-190313023856-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1557314680_layflat-solid-SAF-saffron-pocket_square-190312233918.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2450,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Tickled",
    "type": "Tie",
    "catalogName": "Tickled Striped Pre-Tied Tie",
    "catalogNumber": "912291TCK",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588266088_layflat-stripes-TCK-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588266069_visualizer-stripes-TCK-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 2715,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Chianti Rose Pocket Square",
    "catalogNumber": "613100CHR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314436_visualizer_pocket_square-solid-CHR-chianti_rose-pocket_square-190313023804-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1557314063_layflat-solid-CHR-chianti_rose-pocket_square-190312233659.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1744,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Mermaid",
    "type": "Pocket Square",
    "catalogName": "Spa Pocket Square",
    "catalogNumber": "611588SPA",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MRD-mermaid-spa-pocket_square-181101162825.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MRD-mermaid-spa-pocket_square-181030163421.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1747,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Salmon",
    "type": "Pocket Square",
    "catalogName": "Salmon Pocket Square",
    "catalogNumber": "611591SAL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-SAL-salmon-pocket_square-181101164253.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-SAL-salmon-pocket_square-181030171303.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1720,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Navy",
    "type": "Pocket Square",
    "catalogName": "Marine Pocket Square",
    "catalogNumber": "611564MAR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-NVY-navy-marine-pocket_square-181101163155.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-NVY-navy-marine-pocket_square-181030164345.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2441,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Lilac",
    "type": "Tie",
    "catalogName": "Lilac Striped Pre-Tied Tie",
    "catalogNumber": "912285LIL",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588265895_visualizer-pin_dot-LIL-bow_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588265878_layflat-stripes-LIL-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2716,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Teal Blue Pocket Square",
    "catalogNumber": "613101TEB",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557314539_layflat-solid-TEB-teal_blue-pocket_square-190312233549.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1557314527_visualizer_pocket_square-solid-TEB-teal_blue-pocket_square-190313023738-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1792,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Mercury",
    "type": "Pocket Square",
    "catalogName": "Mercury Pocket Square",
    "catalogNumber": "611636MRC",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MRC-mercury-pocket_square-181101162309.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MRC-mercury-pocket_square-181030162015.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1791,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Oasis",
    "type": "Pocket Square",
    "catalogName": "Oasis Pocket Square",
    "catalogNumber": "611635OAS",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-OAS-oasis-pocket_square-181101163923.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-OAS-oasis-pocket_square-181030170341.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1790,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Lapis",
    "type": "Pocket Square",
    "catalogName": "Lapis Pocket Square",
    "catalogNumber": "611634LAP",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-LAP-lapis-pocket_square-181101162454.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-LAP-lapis-pocket_square-181030162458.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1762,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Petal",
    "type": "Pocket Square",
    "catalogName": "Blush Pocket Square",
    "catalogNumber": "611606BSH",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/1569421572_layflat-solid-FBL-first_blush-pocket_square-190313005834.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BSH-petal_blush-pocket_square-181101162004.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1766,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Iris",
    "type": "Pocket Square",
    "catalogName": "Iris Pocket Square",
    "catalogNumber": "611610IRS",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-IRS-iris-pocket_square-181101164557.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-IRS-iris-pocket_square-181030172115.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1765,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Desert Blue",
    "type": "Pocket Square",
    "catalogName": "Desert Blue Pocket Square",
    "catalogNumber": "611609DBL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-DBL-desert_blue-pocket_square-181101162242.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-DBL-desert_blue-pocket_square-181030161905.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1764,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Dusty Rose",
    "type": "Pocket Square",
    "catalogName": "Dusty Rose Pocket Square",
    "catalogNumber": "611608DRS",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-DRS-dusty_rose-pocket_square-181101162401.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-DRS-dusty_rose-pocket_square-181030162236.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1763,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Quartz",
    "type": "Pocket Square",
    "catalogName": "Quartz Pocket Square",
    "catalogNumber": "611607QRT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-QRT-quartz-pocket_square-181101162428.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-QRT-quartz-pocket_square-181030162347.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1761,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Capri",
    "type": "Pocket Square",
    "catalogName": "Capri Pocket Square",
    "catalogNumber": "611605CAP",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CAP-capri-pocket_square-181101163407.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CAP-capri-pocket_square-181030164936.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1760,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Rose Gold",
    "type": "Pocket Square",
    "catalogName": "Rose Gold Pocket Square",
    "catalogNumber": "611604RGL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-RGL-rose_gold-pocket_square-181101162335.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-RGL-rose_gold-pocket_square-181030162125.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1759,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Sun Coral",
    "type": "Pocket Square",
    "catalogName": "Sun Coral Pocket Square",
    "catalogNumber": "611603SCO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-SCO-sun_coral-pocket_square-181101164042.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-SCO-sun_coral-pocket_square-181030170712.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1758,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Cocoa",
    "type": "Pocket Square",
    "catalogName": "Cocoa Pocket Square",
    "catalogNumber": "611602COC",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-COC-cocoa-pocket_square-181101163433.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-COC-cocoa-pocket_square-181030165047.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1757,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Mint Green",
    "type": "Pocket Square",
    "catalogName": "Mint Green Pocket Square",
    "catalogNumber": "611601MGR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MGR-mint_green-pocket_square-181101163738.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MGR-mint_green-pocket_square-181030165859.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1756,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Bubble Gum",
    "type": "Pocket Square",
    "catalogName": "Bubble Gum Pocket Square",
    "catalogNumber": "611600BGM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BGM-bubble_gum-pocket_square-181101164413.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BGM-bubble_gum-pocket_square-181030171635.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1755,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Wedgewood",
    "type": "Pocket Square",
    "catalogName": "Wedgewood Pocket Square",
    "catalogNumber": "611599WED",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-WED-wedgewood-pocket_square-181101163500.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-WED-wedgewood-pocket_square-181030165158.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1754,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Morning Glory",
    "type": "Pocket Square",
    "catalogName": "Morning Glory Pocket Square",
    "catalogNumber": "611598MGL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MGL-morning_glory-pocket_square-181101164624.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MGL-morning_glory-pocket_square-181030172225.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1753,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Indigo",
    "type": "Pocket Square",
    "catalogName": "Indigo Pocket Square",
    "catalogNumber": "611597IND",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-IND-indigo-pocket_square-181101164201.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-IND-indigo-pocket_square-181030171043.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1752,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Mulberry",
    "type": "Pocket Square",
    "catalogName": "Mulberry Pocket Square",
    "catalogNumber": "611596MUL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MUL-mulberry-pocket_square-181101163341.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MUL-mulberry-pocket_square-181030164826.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1751,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Guava",
    "type": "Pocket Square",
    "catalogName": "Guava Pocket Square",
    "catalogNumber": "611595GUA",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-GUA-guava-sunset-pocket_square-181101164531.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-GUA-guava-sunset-pocket_square-181030172005.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1749,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Silver",
    "type": "Pocket Square",
    "catalogName": "Silver Pocket Square",
    "catalogNumber": "611593SVR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-SVR-silver-pocket_square-181101163711.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-SVR-silver-pocket_square-181030165749.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1748,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Lime",
    "type": "Pocket Square",
    "catalogName": "Lime Pocket Square",
    "catalogNumber": "611592LIM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-LIM-lime-pocket_square-181101163221.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-LIM-lime-pocket_square-181030164456.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1746,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Hunter",
    "type": "Pocket Square",
    "catalogName": "Hunter Pocket Square",
    "catalogNumber": "611590HUN",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-HUN-juniper-hunter-pocket_square-181101164439.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-HUN-juniper-hunter-pocket_square-181030171744.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1745,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Fuchsia",
    "type": "Pocket Square",
    "catalogName": "Fuchsia Pocket Square",
    "catalogNumber": "611589FCH",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-FCH-fuchsia-pocket_square-181101163645.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-FCH-fuchsia-pocket_square-181030165639.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1742,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Midas Gold",
    "type": "Pocket Square",
    "catalogName": "Midas Gold Pocket Square",
    "catalogNumber": "611586MGO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MGO-midas_gold-pocket_square-181101163129.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MGO-midas_gold-pocket_square-181030164235.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1743,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Olive",
    "type": "Pocket Square",
    "catalogName": "Olive Pocket Square",
    "catalogNumber": "611587OLV",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-OLV-olive-pocket_square-181101164505.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-OLV-olive-pocket_square-181030171854.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1741,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Persimmon",
    "type": "Pocket Square",
    "catalogName": "Persimmon Pocket Square",
    "catalogNumber": "611585PER",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PER-persimmon-pocket_square-181101164320.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PER-persimmon-pocket_square-181030171414.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1740,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Jade",
    "type": "Pocket Square",
    "catalogName": "Jade Pocket Square",
    "catalogNumber": "611584JDE",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-JDE-jade-pocket_square-181101162944.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-JDE-jade-pocket_square-181030163753.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1739,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Sapphire",
    "type": "Pocket Square",
    "catalogName": "Sapphire Pocket Square",
    "catalogNumber": "611583SAP",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-SAP-sapphire-pocket_square-181101163314.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-SAP-sapphire-pocket_square-181030164716.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1738,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Petal Pink",
    "type": "Pocket Square",
    "catalogName": "Petal Pink Pocket Square",
    "catalogNumber": "611582PTP",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PTP-petal_pink-pocket_square-181101163830.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PTP-petal_pink-pocket_square-181030170119.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1737,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Regency",
    "type": "Pocket Square",
    "catalogName": "Regency Pocket Square",
    "catalogNumber": "611581REG",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-REG-regency-pocket_square-181101163036.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-REG-regency-pocket_square-181030164015.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1736,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Aquamarine",
    "type": "Pocket Square",
    "catalogName": "Aqua Marine Pocket Square",
    "catalogNumber": "611580AQM",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-AQM-aqua_marine-pocket_square-181101163857.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-AQM-aqua_marine-pocket_square-181030170230.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1735,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Peacock",
    "type": "Pocket Square",
    "catalogName": "Peacock Pocket Square",
    "catalogNumber": "611579PCK",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PCK-peacock-pocket_square-181101162758.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PCK-peacock-pocket_square-181030163310.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1734,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Turquoise",
    "type": "Pocket Square",
    "catalogName": "Turquoise Pocket Square",
    "catalogNumber": "611578TRQ",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TRQ-turquoise-pocket_square-181101163804.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TRQ-turquoise-pocket_square-181030170010.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1733,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Freesia",
    "type": "Pocket Square",
    "catalogName": "Freesia Pocket Square",
    "catalogNumber": "611577FRE",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-FRE-freesia-pocket_square-181101164135.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-FRE-freesia-pocket_square-181030170933.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1732,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Latte",
    "type": "Pocket Square",
    "catalogName": "Latte Pocket Square",
    "catalogNumber": "611576LAT",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-LAT-latte-pocket_square-181101162547.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-LAT-latte-pocket_square-181030162719.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1731,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Chocolate",
    "type": "Pocket Square",
    "catalogName": "Chocolate Pocket Square",
    "catalogNumber": "611575CHO",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CHO-chocolate-pocket_square-181101163526.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CHO-chocolate-pocket_square-181030165308.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1730,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Eggplant",
    "type": "Pocket Square",
    "catalogName": "Eggplant Pocket Square",
    "catalogNumber": "611574EGG",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-EGG-eggplant-pocket_square-181101163103.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-EGG-eggplant-pocket_square-181030164125.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1729,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Cobalt",
    "type": "Pocket Square",
    "catalogName": "Cobalt Pocket Square",
    "catalogNumber": "611573COB",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-COB-cobalt-pocket_square-181101164108.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-COB-cobalt-pocket_square-181030170822.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1728,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Sunbeam",
    "type": "Pocket Square",
    "catalogName": "Sunbeam Pocket Square",
    "catalogNumber": "611572SUN",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-SUN-sunbeam-pocket_square-181030162830.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-SUN-sunbeam-pocket_square-181101162613.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1727,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Merlot",
    "type": "Pocket Square",
    "catalogName": "Merlot Pocket Square",
    "catalogNumber": "611571MER",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MER-wine-merlot-pocket_square-181101163248.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-MER-wine-merlot-pocket_square-181030164605.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1726,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Pool",
    "type": "Pocket Square",
    "catalogName": "Pool Pocket Square",
    "catalogNumber": "611570POL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-POL-pool-pocket_square-181101162917.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-POL-pool-pocket_square-181030163642.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1725,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Burnt Orange",
    "type": "Pocket Square",
    "catalogName": "Burnt Orange Pocket Square",
    "catalogNumber": "611569BOR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BOR-burnt_orange-pocket_square-181101164015.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BOR-burnt_orange-pocket_square-181030170601.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1724,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Tangerine",
    "type": "Pocket Square",
    "catalogName": "Tangerine Pocket Square",
    "catalogNumber": "611568TNG",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Orange",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TNG-tangerine-pocket_square-181101163010.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TNG-tangerine-pocket_square-181030163903.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1723,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Nude",
    "type": "Pocket Square",
    "catalogName": "Nude Pocket Square",
    "catalogNumber": "611567NUD",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-NUD-nude-pocket_square-181030170451.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-NUD-nude-pocket_square-181101163949.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1722,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, First Blush",
    "type": "Pocket Square",
    "catalogName": "First Blush Pocket Square",
    "catalogNumber": "611566FBL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-FBL-first_blush-pocket_square-181101163552.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-FBL-first_blush-pocket_square-181030165418.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1721,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Bright Fuchsia",
    "type": "Pocket Square",
    "catalogName": "Bright Fuchsia Pocket Square",
    "catalogNumber": "611565BFU",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BFU-bright_fuchsia-pocket_square-181101164346.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BFU-bright_fuchsia-pocket_square-181030171524.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1718,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Purple",
    "type": "Pocket Square",
    "catalogName": "Purple Pocket Square",
    "catalogNumber": "611562PUR",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-PUR-purple-pocket_square-181101162216.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-PUR-purple-pocket_square-181030161755.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1717,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Clover",
    "type": "Pocket Square",
    "catalogName": "Clover Pocket Square",
    "catalogNumber": "611561CLV",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CLV-clover-pocket_square-181101162521.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CLV-clover-pocket_square-181030162609.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1716,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Ballet",
    "type": "Pocket Square",
    "catalogName": "Ballet Pocket Square",
    "catalogNumber": "611560BAL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BAL-ballet-pocket_square-181101162639.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BAL-ballet-pocket_square-181030162940.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1715,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Blue Ice",
    "type": "Pocket Square",
    "catalogName": "Blue Ice Pocket Square",
    "catalogNumber": "611559BIC",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-BIC-blue_ice-pocket_square-181101164227.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-BIC-blue_ice-pocket_square-181030171153.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1714,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Tea Rose",
    "type": "Pocket Square",
    "catalogName": "Tea Rose Pocket Square",
    "catalogNumber": "611558TRS",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Pink",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-TRS-tea_rose-pocket_square-181101162732.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-TRS-tea_rose-pocket_square-181030163200.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1713,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Meadow",
    "type": "Pocket Square",
    "catalogName": "Meadow Pocket Square",
    "catalogNumber": "611557MDW",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/layflat-solid-MDW-meadow-pocket_square-181030163531.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-MDW-meadow-pocket_square-181101162851.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      }
    ]
  },
  {
    "id": 1712,
    "unitCost": 1.5,
    "pattern": "Solid",
    "description": "Pocket Square, Mens, Solid, Ferrari Red",
    "type": "Pocket Square",
    "catalogName": "Ferrari Red Pocket Square",
    "catalogNumber": "611556FRD",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-FRD-ferrari_red-pocket_square-181101164651.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-FRD-ferrari_red-pocket_square-181030172335.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2873,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Cufflinks",
    "catalogName": "Rose Gold Cufflinks",
    "catalogNumber": "030087RGL",
    "costToCustomer": 19,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583862029_product_render-cufflinks-solid-copper-2020-03-04_11-40-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2874,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Cufflinks",
    "catalogName": "Silver Cufflinks",
    "catalogNumber": "030088SLV",
    "costToCustomer": 19,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583862076_product_render-cufflinks-solid-silver-2020-03-04_12-20-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2456,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Toffee Gold",
    "type": "Tie",
    "catalogName": "Toffee Striped Pre-Tied Tie",
    "catalogNumber": "912300TOF",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588266132_visualizer-stripes-TOF-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1588266119_layflat-stripes-TOF-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2877,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Cufflinks",
    "catalogName": "Silver and Black Cufflinks",
    "catalogNumber": "030090SBL",
    "costToCustomer": 19,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Black",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583862183_product_render-cufflinks-square-silver-black-2020-03-04_11-20-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2875,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Cufflinks",
    "catalogName": "Gunmetal Cufflinks",
    "catalogNumber": "030089GNM",
    "costToCustomer": 19,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Grey",
    "media": [
      {
        "url": "https://gentux.imgix.net/1583862004_product_render-cufflinks-solid-black-2020-03-04_12-10-00.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1673,
    "unitCost": 1.7,
    "pattern": "Solid",
    "description": "Pocket Square, One Size, Solid, Steel Blue",
    "type": "Pocket Square",
    "catalogName": "Steel Blue Pocket Square",
    "catalogNumber": "601517STB",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Blue",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-STB-steel_blue-pocket_square-181101160653.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-STB-steel_blue-pocket_square-181030153615.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 1672,
    "unitCost": 1.7,
    "pattern": "Solid",
    "description": "Pocket Square, One Size, Solid, Gold",
    "type": "Pocket Square",
    "catalogName": "Gold Pocket Square",
    "catalogNumber": "601516GLD",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Yellow",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-GLD-gold-pocket_square-181101160719.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-GLD-gold-pocket_square-181030153728.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2459,
    "unitCost": 6,
    "pattern": "Striped",
    "description": "Tie, Mens, Windsor Tie, Pre Tied, Hand Made Knot, Stripe, Bouquet",
    "type": "Tie",
    "catalogName": "Bouquet Striped Pre-Tied Tie",
    "catalogNumber": "912303BQT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": "Pre Tied",
    "attributeTertiary": "Hand Made Knot",
    "colorGroup": "Purple",
    "media": [
      {
        "url": "https://gentux.imgix.net/1588266225_layflat-stripes-BQT-long_tie.jpg",
        "label": "PDP_Hero"
      },
      {
        "url": "https://gentux.imgix.net/1588266205_visualizer-stripes-BQT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      }
    ]
  },
  {
    "id": 1671,
    "unitCost": 1.7,
    "pattern": "Solid",
    "description": "Pocket Square, One Size, Solid, Chianti",
    "type": "Pocket Square",
    "catalogName": "Apple Pocket Square",
    "catalogNumber": "601515APL",
    "costToCustomer": 10,
    "attributePrimary": "Solid",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Red",
    "media": [
      {
        "url": "https://gentux.imgix.net/visualizer_pocket_square-solid-CHI-apple-pocket_square-181101160745.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/layflat-solid-CHI-apple-pocket_square-181030153838.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2664,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Tie",
    "catalogName": "Latte",
    "catalogNumber": "911690LAT",
    "costToCustomer": 10,
    "attributePrimary": "Windsor Tie",
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Brown",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287165_visualizer-solid-LAT-long_tie-fs8.png",
        "label": "VISUALIZER_TIE_FULL"
      },
      {
        "url": "https://gentux.imgix.net/1523287163_layflat-solid-LAT-long_tie.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2666,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Kelly Green Pocket Square",
    "catalogNumber": "611594KGR",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Green",
    "media": [
      {
        "url": "https://gentux.imgix.net/1523287233_layflat-solid-KGN-pocket_square.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2718,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Harvest Gold Pocket Square",
    "catalogNumber": "613103HGD",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315111_visualizer_pocket_square-solid-HGD-harves_gold-pocket_square-190313023856-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1557314862_layflat-solid-HGD-harvest_gold-pocket_square-190312234028.jpg",
        "label": "PDP_Hero"
      }
    ]
  },
  {
    "id": 2719,
    "unitCost": null,
    "pattern": "Solid",
    "description": null,
    "type": "Pocket Square",
    "catalogName": "Bronze Pocket Square",
    "catalogNumber": "613104BRZ",
    "costToCustomer": 10,
    "attributePrimary": null,
    "attributeSecondary": null,
    "attributeTertiary": null,
    "colorGroup": "Tan",
    "media": [
      {
        "url": "https://gentux.imgix.net/1557315235_visualizer_pocket_square-solid-BRZ-bronze-pocket_square-190313023830-fs8.png",
        "label": "VISUALIZER_POCKET_SQUARE"
      },
      {
        "url": "https://gentux.imgix.net/1557315225_layflat-solid-BRZ-bronze-pocket_square-190312233808.jpg",
        "label": "PDP_Hero"
      }
    ]
  }
]
